var _style, _g, _g2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon7, _g3, _polygon8, _g4, _polygon9, _g5, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon10, _polygon11, _path22, _path23, _polygon12, _polygon13, _path24, _path25, _polygon14, _path26, _path27, _polygon15, _path28, _path29, _path30, _path31, _path32, _path33, _polygon16, _polygon17, _path34, _path35, _path36, _path37, _polygon18, _path38, _polygon19, _g6, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _path39, _path40, _path41, _path42, _path43, _g7, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g8, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _polygon25, _g9, _path66, _path67, _path68, _path69, _g10, _path70, _path71, _path72, _g11, _g12, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _rect, _rect2, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _polygon26, _polygon27, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _g13, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _g14, _rect3, _rect4, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _line, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolutionIa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2518.65 1511.19",
    style: {
      enableBackground: "new 0 0 2518.65 1511.19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{opacity:0.3;fill:#B6D3C3;enable-background:new    ;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:#F1F3F9;}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:#807DFB;}\n\t.st8{fill:url(#SVGID_5_);}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:#B6D3C3;}\n\t.st11{fill:#EAEEF9;}\n\t.st12{fill:#F7F7FC;}\n\t.st13{fill:#A3A9D0;}\n\t.st14{fill:url(#SVGID_7_);}\n\t.st15{fill:url(#SVGID_8_);}\n\t.st16{fill:#8CABB7;}\n\t.st17{opacity:0.9;fill:#8CABB7;enable-background:new    ;}\n\t.st18{fill:url(#SVGID_9_);}\n\t.st19{fill:url(#SVGID_10_);}\n\t.st20{fill:#F6F6FB;}\n\t.st21{fill:url(#SVGID_11_);}\n\t.st22{fill:url(#SVGID_12_);}\n\t.st23{fill:url(#SVGID_13_);}\n\t.st24{fill:url(#SVGID_14_);}\n\t.st25{fill:#BBBFE2;}\n\t.st26{fill:#CED2F4;}\n\t.st27{fill:#242D3C;}\n\t.st28{fill:url(#SVGID_15_);}\n\t.st29{fill:url(#SVGID_16_);}\n\t.st30{fill:url(#SVGID_17_);}\n\t.st31{fill:url(#SVGID_18_);}\n\t.st32{fill:url(#SVGID_19_);}\n\t.st33{fill:#FFFFFF;}\n\t.st34{fill:#E0E0EB;}\n\t.st35{fill:url(#SVGID_20_);}\n\t.st36{fill:url(#SVGID_21_);}\n\t.st37{fill:#F5F5FA;}\n\t.st38{fill:#B9BFE8;}\n\t.st39{fill:url(#SVGID_22_);}\n\t.st40{fill:#CCD2FA;}\n\t.st41{fill:url(#SVGID_23_);}\n\t.st42{fill:url(#SVGID_24_);}\n\t.st43{fill:url(#SVGID_25_);}\n\t.st44{fill:url(#SVGID_26_);}\n\t.st45{fill:url(#SVGID_27_);}\n\t.st46{fill:url(#SVGID_28_);}\n\t.st47{fill:url(#SVGID_29_);}\n\t.st48{fill:url(#SVGID_30_);}\n\t.st49{fill:url(#SVGID_31_);}\n\t.st50{fill:url(#SVGID_32_);}\n\t.st51{fill:url(#SVGID_33_);}\n\t.st52{fill:url(#SVGID_34_);}\n\t.st53{fill:url(#SVGID_35_);}\n\t.st54{fill:url(#SVGID_36_);}\n\t.st55{fill:url(#SVGID_37_);}\n\t.st56{fill:url(#SVGID_38_);}\n\t.st57{fill:url(#SVGID_39_);}\n\t.st58{fill:url(#SVGID_40_);}\n\t.st59{fill:url(#SVGID_41_);}\n\t.st60{fill:url(#SVGID_42_);}\n\t.st61{fill:url(#SVGID_43_);}\n\t.st62{fill:url(#SVGID_44_);}\n\t.st63{fill:url(#SVGID_45_);}\n\t.st64{fill:url(#SVGID_46_);}\n\t.st65{fill:url(#SVGID_47_);}\n\t.st66{fill:url(#SVGID_48_);}\n\t.st67{opacity:0.12;fill:url(#SVGID_49_);enable-background:new    ;}\n\t.st68{fill:#20196F;}\n\t.st69{fill:url(#SVGID_50_);}\n\t.st70{fill:url(#SVGID_51_);}\n\t.st71{fill:url(#SVGID_52_);}\n\t.st72{fill:url(#SVGID_53_);}\n\t.st73{fill:#CED3F8;}\n\t.st74{fill:#BBC0E6;}\n\t.st75{fill:#A5ABCC;}\n\t.st76{fill:#E8ECF7;}\n\t.st77{fill:url(#SVGID_54_);}\n\t.st78{fill:url(#SVGID_55_);}\n\t.st79{fill:url(#SVGID_56_);}\n\t.st80{fill:#939CCA;}\n\t.st81{fill:url(#SVGID_57_);}\n\t.st82{fill:url(#SVGID_58_);}\n\t.st83{opacity:0.2;}\n\t.st84{fill:#EB975A;}\n\t.st85{fill:#696ADF;}\n\t.st86{fill:#F5F5F9;}\n\t.st87{fill:#7E7EF1;}\n\t.st88{fill:#F0F0F4;}\n\t.st89{fill:url(#SVGID_59_);}\n\t.st90{fill:#DAE0F5;}\n\t.st91{fill:#807CFB;}\n\t.st92{fill:#131147;}\n\t.st93{fill:url(#SVGID_60_);}\n\t.st94{fill:url(#SVGID_61_);}\n\t.st95{fill:url(#SVGID_62_);}\n\t.st96{fill:url(#SVGID_63_);}\n\t.st97{fill:url(#SVGID_64_);}\n\t.st98{fill:url(#SVGID_65_);}\n\t.st99{fill:url(#SVGID_66_);}\n\t.st100{fill:#FF826A;}\n\t.st101{fill:url(#SVGID_67_);}\n\t.st102{fill:#57ECEA;}\n\t.st103{fill:url(#SVGID_68_);}\n\t.st104{fill:url(#SVGID_69_);}\n\t.st105{fill:url(#SVGID_70_);}\n\t.st106{fill:#1E1C6B;}\n\t.st107{fill:url(#SVGID_71_);}\n\t.st108{fill:url(#SVGID_72_);}\n\t.st109{fill:url(#SVGID_73_);}\n\t.st110{fill:url(#SVGID_74_);}\n\t.st111{fill:url(#SVGID_75_);}\n\t.st112{fill:#94B5BF;}\n\t.st113{fill:url(#SVGID_76_);}\n\t.st114{fill:url(#SVGID_77_);}\n\t.st115{fill:url(#SVGID_78_);}\n\t.st116{fill:url(#SVGID_79_);}\n\t.st117{fill:url(#SVGID_80_);}\n\t.st118{fill:url(#SVGID_81_);}\n\t.st119{fill:url(#SVGID_82_);}\n\t.st120{fill:url(#SVGID_83_);}\n\t.st121{fill:url(#SVGID_84_);}\n\t.st122{fill:url(#SVGID_85_);}\n\t.st123{fill:url(#SVGID_86_);}\n\t.st124{fill:url(#SVGID_87_);}\n\t.st125{fill:url(#SVGID_88_);}\n\t.st126{fill:url(#SVGID_89_);}\n\t.st127{fill:url(#SVGID_90_);}\n\t.st128{fill:url(#SVGID_91_);}\n\t.st129{fill:url(#SVGID_92_);}\n\t.st130{fill:url(#SVGID_93_);}\n\t.st131{fill:#E9A284;}\n\t.st132{fill:url(#SVGID_94_);}\n\t.st133{fill:url(#SVGID_95_);}\n\t.st134{fill:url(#SVGID_96_);}\n\t.st135{fill:url(#SVGID_97_);}\n\t.st136{fill:url(#SVGID_98_);}\n\t.st137{fill:url(#SVGID_99_);}\n\t.st138{fill:#FCD1A9;}\n\t.st139{fill:url(#SVGID_100_);}\n\t.st140{fill:url(#SVGID_101_);}\n\t.st141{fill:url(#SVGID_102_);}\n\t.st142{fill:url(#SVGID_103_);}\n\t.st143{fill:url(#SVGID_104_);}\n\t.st144{fill:url(#SVGID_105_);}\n\t.st145{fill:url(#SVGID_106_);}\n\t.st146{fill:url(#SVGID_107_);}\n\t.st147{fill:url(#SVGID_108_);}\n\t.st148{fill:url(#SVGID_109_);}\n\t.st149{fill:url(#SVGID_110_);}\n\t.st150{fill:url(#SVGID_111_);}\n\t.st151{fill:url(#SVGID_112_);}\n\t.st152{fill:url(#SVGID_113_);}\n\t.st153{fill:#F2C39D;}\n\t.st154{fill:#FFC16B;}\n\t.st155{fill:url(#SVGID_114_);}\n\t.st156{fill:url(#SVGID_115_);}\n\t.st157{fill:url(#SVGID_116_);}\n\t.st158{fill:url(#SVGID_117_);}\n\t.st159{fill:url(#SVGID_118_);}\n\t.st160{fill:url(#SVGID_119_);}\n\t.st161{fill:url(#SVGID_120_);}\n\t.st162{fill:url(#SVGID_121_);}\n\t.st163{fill:url(#SVGID_122_);}\n\t.st164{fill:url(#SVGID_123_);}\n\t.st165{fill:url(#SVGID_124_);}\n\t.st166{fill:url(#SVGID_125_);}\n\t.st167{fill:url(#SVGID_126_);}\n\t.st168{fill:url(#SVGID_127_);}\n\t.st169{fill:url(#SVGID_128_);}\n\t.st170{fill:url(#SVGID_129_);}\n\t.st171{fill:url(#SVGID_130_);}\n\t.st172{fill:none;}\n\t.st173{opacity:0.3;fill:#AED3C1;enable-background:new    ;}\n\t.st174{fill:url(#SVGID_131_);}\n\t.st175{fill:url(#SVGID_132_);}\n\t.st176{opacity:0.12;fill:url(#SVGID_133_);enable-background:new    ;}\n\t.st177{fill:url(#SVGID_134_);}\n\t.st178{fill:url(#SVGID_135_);}\n\t.st179{opacity:0.12;fill:url(#SVGID_136_);enable-background:new    ;}\n\t.st180{fill:url(#SVGID_137_);}\n\t.st181{fill:url(#SVGID_138_);}\n\t.st182{opacity:0.12;fill:url(#SVGID_139_);enable-background:new    ;}\n\t.st183{fill:url(#SVGID_140_);}\n\t.st184{fill:url(#SVGID_141_);}\n\t.st185{fill:url(#SVGID_142_);}\n\t.st186{fill:url(#SVGID_143_);}\n\t.st187{fill:url(#SVGID_144_);}\n\t.st188{fill:url(#SVGID_145_);}\n\t.st189{opacity:0.12;fill:url(#SVGID_146_);enable-background:new    ;}\n\t.st190{fill:url(#SVGID_147_);}\n\t.st191{fill:url(#SVGID_148_);}\n\t.st192{fill:url(#SVGID_149_);}\n\t.st193{fill:url(#SVGID_150_);}\n\t.st194{opacity:0.12;fill:url(#SVGID_151_);enable-background:new    ;}\n\t.st195{opacity:0.12;fill:url(#SVGID_152_);enable-background:new    ;}\n\t.st196{fill:url(#SVGID_153_);}\n\t.st197{fill:url(#SVGID_154_);}\n\t.st198{fill:url(#SVGID_155_);}\n\t.st199{fill:url(#SVGID_156_);}\n\t.st200{fill:url(#SVGID_157_);}\n\t.st201{fill:url(#SVGID_158_);}\n\t.st202{fill:url(#SVGID_159_);}\n\t.st203{opacity:0.12;fill:url(#SVGID_160_);enable-background:new    ;}\n\t.st204{opacity:0.12;fill:url(#SVGID_161_);enable-background:new    ;}\n\t.st205{fill:url(#SVGID_162_);}\n\t.st206{fill:url(#SVGID_163_);}\n\t.st207{fill:url(#SVGID_164_);}\n\t.st208{opacity:0.12;fill:url(#SVGID_165_);enable-background:new    ;}\n\t.st209{opacity:0.12;fill:url(#SVGID_166_);enable-background:new    ;}\n\t.st210{fill:url(#SVGID_167_);}\n\t.st211{fill:url(#SVGID_168_);}\n\t.st212{opacity:0.12;fill:url(#SVGID_169_);enable-background:new    ;}\n\t.st213{opacity:0.12;fill:url(#SVGID_170_);enable-background:new    ;}\n\t.st214{opacity:0.12;fill:url(#SVGID_171_);enable-background:new    ;}\n\t.st215{fill:url(#SVGID_172_);}\n\t.st216{fill:url(#SVGID_173_);}\n\t.st217{fill:url(#SVGID_174_);}\n\t.st218{fill:url(#SVGID_175_);}\n\t.st219{opacity:0.12;fill:url(#SVGID_176_);enable-background:new    ;}\n\t.st220{fill:url(#SVGID_177_);}\n\t.st221{fill:url(#SVGID_178_);}\n\t.st222{fill:url(#SVGID_179_);}\n\t.st223{fill:url(#SVGID_180_);}\n\t.st224{opacity:0.12;fill:url(#SVGID_181_);enable-background:new    ;}\n\t.st225{fill:url(#SVGID_182_);}\n\t.st226{fill:url(#SVGID_183_);}\n\t.st227{fill:url(#SVGID_184_);}\n\t.st228{fill:url(#SVGID_185_);}\n\t.st229{opacity:0.12;fill:url(#SVGID_186_);enable-background:new    ;}\n\t.st230{fill:url(#SVGID_187_);}\n\t.st231{fill:url(#SVGID_188_);}\n\t.st232{fill:url(#SVGID_189_);}\n\t.st233{fill:url(#SVGID_190_);}\n\t.st234{opacity:0.12;fill:url(#SVGID_191_);enable-background:new    ;}\n\t.st235{fill:url(#SVGID_192_);}\n\t.st236{fill:url(#SVGID_193_);}\n\t.st237{fill:url(#SVGID_194_);}\n\t.st238{fill:url(#SVGID_195_);}\n\t.st239{opacity:0.12;fill:url(#SVGID_196_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_1_"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Page_layout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "White_background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2518.65,1506.53V252.34c-37.24,179.28-81.61,275.75-433.02,306.11 c-139.87,12.09-409.66-31.39-544.73,207.14c-132.05,233.2-203.25,42.71-475.69,259.18c-194.24,154.34-370.7,481.77-803.93,481.77 h2257.37L2518.65,1506.53L2518.65,1506.53z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Back_blocks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2064.635,
    y1: 2525.6011,
    x2: 2064.635,
    y2: 2832.6509,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    style: {
      stopColor: "#F8F9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9046,
    style: {
      stopColor: "#E5E9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE4F4"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2017.5,534.45 2111.77,480.03 2111.77,227.4 2017.5,281.83  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1970.365,
    y1: 2525.6011,
    x2: 1970.365,
    y2: 2832.6509,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6415,
    style: {
      stopColor: "#F6F7FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EDF7"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2017.5,534.45 1923.23,480.03 1923.23,227.4 2017.5,281.83  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2017.5,281.83 1923.23,227.4 2017.5,172.98 2111.77,227.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 933.71,
    y1: 1375.8976,
    x2: 933.71,
    y2: 1774.312,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    style: {
      stopColor: "#F8F9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9046,
    style: {
      stopColor: "#E5E9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFE4F4"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "994.87,1285.74 872.55,1356.36 872.55,1508.67 994.87,1508.67  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "872.55,1356.36 750.23,1285.74 872.54,1215.12 994.87,1285.74  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 811.39,
    y1: 1375.8976,
    x2: 811.39,
    y2: 1774.312,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6415,
    style: {
      stopColor: "#F6F7FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EDF7"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "872.55,1356.36 750.23,1285.74 750.23,1508.67 872.55,1508.67  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pie_chart"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1240.44,683.1v87.18l-75.5,43.59C1164.94,765.71,1198.74,707.17,1240.44,683.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 13195.0127,
    y1: 2401.0413,
    x2: 13300.8779,
    y2: 2216.4551,
    gradientTransform: "matrix(-1 0 0 -1 14454.8867 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79544A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1226.18,674.87l51.62,29.8l-73.96,131.65l-53.15-30.68C1150.69,757.48,1184.49,698.94,1226.18,674.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1164.9399,
    y1: 2311.5659,
    x2: 1240.4399,
    y2: 2311.5659,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1240.44,683.1v87.18l-75.5,43.59C1164.94,765.71,1198.74,707.17,1240.44,683.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1164.94,813.86l75.5-43.59l-66.85,79.1C1168.08,840.45,1164.94,828.49,1164.94,813.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1240.44,770.27v-87.18c41.7-24.07,75.5-4.56,75.5,43.59s-33.8,106.69-75.5,130.77 c-29.03,16.76-54.21,12.37-66.85-8.07L1240.44,770.27z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1226.18,674.87c20.97-12.11,39.94-13.18,53.62-5.14l13.31,7.68l-0.01,0.02 c-13.6-7.45-32.17-6.16-52.66,5.67L1226.18,674.87L1226.18,674.87z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1171.45,853.65c-4.77-3.05-8.86-7.24-12.12-12.51l14.25,8.23c3.25,5.27,7.35,9.46,12.12,12.51 L1171.45,853.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1150.6799,
    y1: 2232.541,
    x2: 1173.58,
    y2: 2232.541,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AABB7"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1159.33,841.15c-5.51-8.92-8.65-20.89-8.65-35.51l0,0l14.25,8.23l0,0c0,14.63,3.14,26.59,8.65,35.51 L1159.33,841.15z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Big_blocks"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1374.24,
    y1: 2132.7461,
    x2: 1646.46,
    y2: 2132.7461,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD5F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#E1E5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7193,
    style: {
      stopColor: "#F7F8FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1540.77,866.26 1374.24,866.26 1478.34,928.23 1374.24,988.35 1540.77,988.35 1646.46,927.32  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1374.24,988.35 1478.34,928.23 1478.34,708.86 1374.24,768.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1374.24,988.35 1270.13,928.23 1270.13,708.86 1374.24,768.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1374.24,768.96 1270.13,708.86 1374.24,648.78 1478.34,708.86  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1836.83,
    y1: 1777.326,
    x2: 1994.09,
    y2: 1777.326,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD5F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#E1E5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7193,
    style: {
      stopColor: "#F7F8FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "1933.03,1247.46 1836.83,1247.46 1896.97,1283.26 1836.83,1317.99 1933.03,1317.99  1994.09,1282.74  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1836.83,1317.99 1896.97,1283.26 1896.97,1156.52 1836.83,1191.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1836.83,1317.99 1776.68,1283.26 1776.68,1156.52 1836.83,1191.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1836.83,1191.24 1776.68,1156.52 1836.83,1121.81 1896.97,1156.52  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 2170.4099,
    y1: 2248.731,
    x2: 2482.25,
    y2: 2248.731,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD5F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#E1E5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7193,
    style: {
      stopColor: "#F7F8FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "2361.17,741.39 2170.41,741.39 2289.66,812.37 2170.41,881.25 2361.17,881.25 2482.25,811.34  "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2170.41,881.25 2289.66,812.37 2289.66,561.07 2170.41,629.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2170.41,881.25 2051.14,812.37 2051.14,561.07 2170.41,629.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2170.41,629.92 2051.14,561.07 2170.41,492.24 2289.66,561.07  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Window_with_code"
  }, /*#__PURE__*/React.createElement("g", null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1436.14,852.67c0-5.92,4.19-13.18,9.32-16.14l63.83-36.85c5.12-2.96,9.31-0.54,9.31,5.38v59.22 c0,5.92-4.19,13.18-9.31,16.14l-63.83,36.85c-5.13,2.96-9.32,0.54-9.32-5.38V852.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1423.3262,
    y1: 2151.1382,
    x2: 1494.0365,
    y2: 2273.6118,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3539,
    style: {
      stopColor: "#8990AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    style: {
      stopColor: "#9AA0BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4895,
    style: {
      stopColor: "#C6CBEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#CED3F8"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1436.14,911.89v-59.22c0-5.92,4.19-13.18,9.32-16.14l63.83-36.85c2.53-1.46,4.83-1.61,6.52-0.67 l-4.88-2.81l-0.01,0.01c-1.7-1.09-4.1-1.01-6.75,0.52l-63.82,36.85c-5.12,2.96-9.32,10.22-9.32,16.14v59.22 c0,3.1,1.15,5.22,2.98,6.13l4.64,2.69C1437.1,916.72,1436.14,914.71,1436.14,911.89z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1452.4601,
    y1: 2200.8408,
    x2: 1504.72,
    y2: 2200.8408,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1482.98,835.72c-0.84,0.22-1.72,1.29-1.95,2.4l-9.05,42.97c-0.23,1.11,0.26,1.83,1.1,1.61 c0.84-0.22,1.71-1.29,1.95-2.4l9.05-42.97C1484.32,836.23,1483.83,835.5,1482.98,835.72z M1470.51,850.69 c-0.49-0.55-1.48-0.19-2.2,0.8l-15.16,20.8c-0.43,0.59-0.69,1.3-0.69,1.9c0,0.6,0.26,1.02,0.69,1.11l15.16,3.29 c0.72,0.16,1.71-0.63,2.2-1.74c0.49-1.12,0.31-2.15-0.41-2.31l-13.27-2.88l13.27-18.2C1470.82,852.48,1471,851.23,1470.51,850.69 z M1504.03,842.91l-15.16-3.29c-0.72-0.16-1.71,0.62-2.2,1.74c-0.5,1.12-0.31,2.15,0.41,2.31l13.27,2.88l-13.27,18.2 c-0.72,0.99-0.9,2.23-0.41,2.78c0.49,0.55,1.48,0.19,2.2-0.8l15.16-20.8c0.43-0.59,0.69-1.3,0.69-1.9 C1504.71,843.41,1504.46,843,1504.03,842.91z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gears"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 2113.0498,
    y1: 2507.0562,
    x2: 2245.1201,
    y2: 2507.0562,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D6F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    style: {
      stopColor: "#D5DAF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5923,
    style: {
      stopColor: "#E2E5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8994,
    style: {
      stopColor: "#F6F7FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2232.08,566.74c0.51-0.52,1.13-0.91,1.8-1.18h7.93l3.31-7.25l-2.99-0.46c-0.91-0.14-1.95-0.44-2.79-0.93 c-0.96-0.56-1.67-1.36-1.66-2.46c0.07-0.97,0.06-1.93-0.01-2.89c-0.06-2.07,2.47-3.08,4.39-3.39l2.99-0.46l-3.39-7.24h-7.92 c-0.26-0.1-0.52-0.22-0.76-0.36c-0.39-0.22-0.75-0.5-1.07-0.82c-0.76-0.85-1.6-1.69-2.51-2.5c-1.84-1.78-0.52-3.4,0.89-4.21 l2.18-1.27l-9.19-5.3l-2.18,1.26c-1.41,0.82-4.19,1.59-7.27,0.53c-1.41-0.52-2.86-1.01-4.33-1.45c-0.56-0.18-1.03-0.39-1.42-0.61 c-1.76-1.02-1.85-2.38-1.44-3.3l0.79-1.73l-12.52-1.95l-0.79,1.73c-0.5,1.12-2.25,2.59-5.82,2.56c-1.66-0.04-3.33-0.04-4.98,0 c-1.9,0.02-3.29-0.39-4.26-0.95c-0.84-0.48-1.35-1.09-1.6-1.61l-0.81-1.74l-12.5,1.95l0.81,1.73c0.52,1.12,0.3,2.9-2.81,3.91 c-1.47,0.44-2.91,0.92-4.32,1.45c-3.06,1.05-5.85,0.29-7.27-0.52l-2.19-1.27l-9.13,5.3l2.2,1.27c1.41,0.82,2.75,2.43,0.93,4.21 c-0.9,0.82-1.73,1.65-2.48,2.5c-1.73,1.8-4.79,1.94-6.73,1.65l-3-0.46l-3.31,7.24l2.99,0.46c0.9,0.14,1.94,0.44,2.79,0.93 c0.96,0.55,1.67,1.36,1.66,2.46c-0.08,0.96-0.07,1.92,0,2.88c0.02,0.76-0.3,1.38-0.82,1.87h-20.42v9.23h17.25l0,0l0,0h7.92 c0.25,0.1,0.51,0.22,0.74,0.36c0.39,0.22,0.75,0.5,1.07,0.82c0.76,0.85,1.61,1.69,2.52,2.5c0.35,0.34,0.58,0.67,0.72,0.99h-11.86 v9.79h17.94v-0.4l1.5-0.87c1.41-0.82,4.19-1.59,7.27-0.53c0.55,0.2,1.11,0.39,1.67,0.59v8.43h17.15v-0.02l0.11,0.02l0.79-1.73 c0.06-0.12,0.13-0.25,0.22-0.38v2.11h17.25l12.51-1.94l-0.82-1.73c-0.47-1-0.32-2.52,1.94-3.56h14.66l9.12-5.3l-2.19-1.26 c-1.41-0.82-2.75-2.44-0.93-4.21C2230.5,568.42,2231.33,567.59,2232.08,566.74z M2202.67,562.65c-9.19,5.34-24.16,5.35-33.42,0 c-9.25-5.34-9.3-14.02-0.11-19.36c9.2-5.35,24.16-5.35,33.42,0C2211.82,548.64,2211.87,557.3,2202.67,562.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 2145.2085,
    y1: 2525.5354,
    x2: 2192.1311,
    y2: 2525.5354,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBFE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED2F4"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M2185.21,527.79c-9.19-5.3-24.05-5.31-33.19,0c-8.12,4.72-8.98,12.06-2.58,17.36 c0.76-0.62,1.62-1.22,2.58-1.79c9.14-5.31,24-5.31,33.19,0c1.01,0.58,1.9,1.21,2.69,1.86 C2194.33,539.91,2193.43,532.53,2185.21,527.79z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2189.45,506.83c-0.13,0.28-0.21,0.59-0.21,0.93l-0.04,15.62c0-0.33,0.08-0.65,0.21-0.93l0.79-1.73 l0.04-15.62L2189.45,506.83z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2147.77,506.83l-0.81-1.73l-0.04,15.62l0.81,1.73c0.14,0.29,0.22,0.62,0.22,0.97l0.04-15.63 C2147.99,507.45,2147.91,507.12,2147.77,506.83z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2213.09,516.97c-0.91,0.53-1.78,1.39-1.79,2.42l-0.04,15.62c0-1.03,0.88-1.89,1.79-2.42l2.18-1.27 l0.05-15.62L2213.09,516.97z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2124.24,516.97l-2.19-1.27l-0.05,15.62l2.2,1.27c0.92,0.53,1.82,1.41,1.82,2.45l0.04-15.63 C2126.05,518.38,2125.16,517.5,2124.24,516.97z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2224.86,532.57c-1.9,0.3-4.39,1.29-4.39,3.3l-0.04,15.62c0.01-2.01,2.49-3,4.39-3.3l2.99-0.46l0.04-15.62 L2224.86,532.57z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M2220.52,537.52l-0.04,15.62c0,0.44-0.02,0.88-0.05,1.32l0.04-15.62 C2220.51,538.4,2220.52,537.96,2220.52,537.52z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2117.09,538.53l0.01-2.58c0.01-1.11-0.71-1.91-1.66-2.46c-0.85-0.49-1.89-0.79-2.79-0.93l-2.99-0.47 l-0.04,15.62l2.99,0.46c0.9,0.14,1.94,0.44,2.79,0.93c0.82,0.47,1.44,1.12,1.61,1.98l-0.01,1.83c0,0.51,0.02,1.03,0.06,1.53 l0.05-15.62C2117.09,538.73,2117.09,538.64,2117.09,538.53z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M2117.1,538.92l-0.04,15.62c0-0.03,0-0.06,0-0.08l0.05-15.62C2117.1,538.86,2117.1,538.89,2117.1,538.92z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "2227.91,542.69 2227.87,558.3 2224.56,565.56 2224.6,549.94  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "2113.1,549.94 2113.06,565.56 2109.67,558.31 2109.72,542.69  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 2211.4802,
    y1: 2499.8796,
    x2: 2224.6101,
    y2: 2499.8796,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A5ACD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#BEC3E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED2F4"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M2221.61,549.46c-1.93-0.29-5-0.15-6.73,1.65c-0.75,0.85-1.57,1.69-2.48,2.5 c-0.63,0.62-0.88,1.21-0.88,1.76l-0.04,15.63c0-0.55,0.25-1.15,0.88-1.76c0.9-0.81,1.73-1.65,2.48-2.5 c1.74-1.81,4.81-1.94,6.73-1.65l3,0.47l0.04-15.62L2221.61,549.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 2113.0601,
    y1: 2499.8657,
    x2: 2126.2502,
    y2: 2499.8657,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBFE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED2F4"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M2125.35,553.62c-0.91-0.82-1.75-1.65-2.51-2.5c-0.32-0.33-0.68-0.6-1.07-0.82 c-1.76-1.02-4.11-1.07-5.69-0.83l-2.98,0.47l-0.04,15.62l2.98-0.47c1.58-0.24,3.92-0.19,5.68,0.82c0.39,0.22,0.75,0.5,1.07,0.82 c0.76,0.85,1.6,1.69,2.52,2.5c0.65,0.63,0.9,1.23,0.9,1.79l0.04-15.62C2126.26,554.85,2126,554.24,2125.35,553.62z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "2215.52,559.09 2215.48,574.72 2206.35,580.02 2206.39,564.4  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "2131.48,564.4 2131.43,580.02 2122.24,574.72 2122.29,559.09  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 2189.5398,
    y1: 2487.6997,
    x2: 2206.3899,
    y2: 2487.6997,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A5ACD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5164,
    style: {
      stopColor: "#BCC2E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED2F4"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M2204.2,563.13c-1.42-0.81-4.21-1.58-7.27-0.52c-1.4,0.52-2.85,1.01-4.32,1.44 c-2.31,0.76-3.03,1.93-3.03,2.94l-0.04,15.62c0-1.01,0.72-2.19,3.03-2.94c1.47-0.44,2.91-0.92,4.31-1.44 c3.06-1.06,5.85-0.3,7.27,0.52l2.2,1.27l0.04-15.62L2204.2,563.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 2131.4299,
    y1: 2487.6819,
    x2: 2148.3198,
    y2: 2487.6819,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBFE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED2F4"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M2146.67,564.67c-0.39-0.22-0.86-0.43-1.42-0.62c-1.48-0.44-2.92-0.92-4.32-1.44 c-3.08-1.07-5.87-0.29-7.27,0.52l-2.18,1.27l-0.05,15.62l2.18-1.26c1.41-0.82,4.19-1.59,7.27-0.53 c1.41,0.52,2.85,1.01,4.33,1.44c0.56,0.18,1.03,0.39,1.42,0.61c1.23,0.72,1.65,1.59,1.65,2.37l0.04-15.62 C2148.32,566.26,2147.91,565.38,2146.67,564.67z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "2190.61,569.69 2190.56,585.31 2178.06,587.25 2178.1,571.63  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 2159.7998,
    y1: 2482.7661,
    x2: 2178.1001,
    y2: 2482.7661,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBFE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED2F4"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M2177.29,569.9c-0.25-0.52-0.76-1.13-1.6-1.61c-0.96-0.56-2.35-0.96-4.25-0.95 c-1.66,0.03-3.32,0.03-4.98-0.01c-3.57-0.02-5.3,1.45-5.82,2.56l-0.79,1.73l-0.05,15.62l0.79-1.73 c0.51-1.12,2.25-2.59,5.82-2.56c1.67,0.04,3.33,0.04,4.98,0c1.91-0.01,3.29,0.39,4.25,0.95c0.84,0.49,1.36,1.09,1.61,1.61 l0.81,1.73l0.04-15.62L2177.29,569.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M2213.33,557.83l2.19,1.26l-9.13,5.31l-2.19-1.27c-1.42-0.81-4.21-1.58-7.27-0.52 c-1.4,0.52-2.85,1.01-4.32,1.44c-3.11,1.01-3.34,2.79-2.81,3.91l0.81,1.73l-12.51,1.94l-0.81-1.73 c-0.25-0.52-0.76-1.13-1.6-1.61c-0.96-0.56-2.35-0.96-4.25-0.95c-1.66,0.03-3.32,0.03-4.98-0.01c-3.57-0.02-5.3,1.45-5.82,2.56 l-0.79,1.73l-12.52-1.94l0.8-1.73c0.41-0.92,0.32-2.27-1.44-3.29c-0.39-0.22-0.86-0.43-1.42-0.62 c-1.48-0.44-2.92-0.92-4.32-1.44c-3.08-1.07-5.87-0.29-7.27,0.52l-2.18,1.27l-9.19-5.31l2.18-1.26c1.4-0.81,2.72-2.43,0.89-4.21 c-0.91-0.82-1.75-1.65-2.51-2.5c-0.32-0.33-0.68-0.6-1.07-0.82c-1.76-1.02-4.11-1.07-5.69-0.83l-2.98,0.47l-3.39-7.25l2.98-0.46 c1.93-0.31,4.46-1.31,4.4-3.39c-0.08-0.96-0.08-1.92,0-2.88c0.01-1.11-0.71-1.91-1.66-2.46c-0.85-0.49-1.89-0.79-2.79-0.93 l-2.99-0.47l3.32-7.24l3,0.47c1.93,0.3,4.99,0.15,6.72-1.65c0.76-0.85,1.58-1.69,2.48-2.5c1.82-1.78,0.48-3.4-0.93-4.21 l-2.19-1.27l9.13-5.31l2.2,1.27c1.42,0.82,4.2,1.58,7.26,0.52c1.41-0.52,2.85-1.01,4.32-1.45c3.11-1.01,3.34-2.79,2.81-3.91 l-0.81-1.73l12.5-1.94l0.81,1.73c0.24,0.52,0.76,1.12,1.6,1.61c0.96,0.56,2.36,0.97,4.26,0.95c1.65-0.04,3.32-0.04,4.98,0.01 c3.57,0.02,5.31-1.45,5.82-2.57l0.8-1.73l12.52,1.94l-0.79,1.73c-0.42,0.92-0.33,2.28,1.44,3.3c0.39,0.22,0.85,0.43,1.42,0.61 c1.47,0.44,2.92,0.92,4.33,1.45c3.08,1.06,5.86,0.29,7.27-0.53l2.18-1.27l9.19,5.31l-2.18,1.27c-1.4,0.82-2.72,2.43-0.88,4.21 c0.91,0.81,1.74,1.65,2.5,2.5c0.32,0.32,0.68,0.59,1.07,0.82c1.76,1.02,4.12,1.07,5.69,0.82l2.99-0.47l3.39,7.25l-2.99,0.46 c-1.92,0.31-4.45,1.32-4.39,3.39c0.07,0.96,0.08,1.92,0,2.89c-0.01,1.1,0.7,1.9,1.66,2.46c0.85,0.48,1.88,0.78,2.79,0.93 l2.98,0.46l-3.31,7.25l-2.99-0.47c-1.93-0.29-5-0.15-6.73,1.65c-0.75,0.85-1.57,1.69-2.48,2.5 C2210.57,555.4,2211.91,557.01,2213.33,557.83z M2152.05,547.03c9.25,5.34,24.22,5.34,33.41,0c9.2-5.35,9.15-14.01-0.11-19.35 c-9.25-5.34-24.22-5.35-33.42,0C2142.75,533.02,2142.79,541.69,2152.05,547.03"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "2159.85,571.63 2159.8,587.25 2147.28,585.31 2147.32,569.69  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M2192.11,525.03c-13.03-7.52-34.09-7.53-47.04,0c-6.16,3.58-9.37,8.23-9.64,12.92 c0.25,4.75,3.51,9.47,9.79,13.09c13.03,7.52,34.09,7.51,47.03-0.01c6.17-3.59,9.38-8.23,9.64-12.92 C2201.65,533.36,2198.39,528.65,2192.11,525.03z M2185.31,547.03c-9.13,5.3-23.99,5.3-33.18,0c-4.35-2.51-6.65-5.76-6.9-9.05 c0.26-3.25,2.52-6.46,6.79-8.93c9.14-5.31,24-5.31,33.19,0c4.35,2.51,6.65,5.77,6.9,9.05 C2191.84,541.34,2189.58,544.54,2185.31,547.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 2135.4143,
    y1: 2531.9297,
    x2: 2201.9192,
    y2: 2531.9297,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBFE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED2F4"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M2145.07,525.03c12.95-7.53,34.01-7.52,47.04,0c6.27,3.62,9.53,8.33,9.79,13.08 c0.3-5.16-2.96-10.39-9.79-14.33c-13.03-7.53-34.09-7.53-47.04,0c-6.71,3.9-9.91,9.05-9.64,14.16 C2135.7,533.25,2138.91,528.61,2145.07,525.03z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 1582.5302,
    y1: 1703.556,
    x2: 1755.0403,
    y2: 1703.556,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3315,
    style: {
      stopColor: "#C2C9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5767,
    style: {
      stopColor: "#D5DAF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M1735.92,1347.67c-0.69-1.2-1.54-2.38-2.51-3.53c-3.41-3.39,4.45-9.06,8-11.11 c0.07,0-10.35-6.02-10.35-6.02l-30.61,0.03c-2.05-2.62-2.58-6.18-2.57-8h-14.69c0,2.39-0.98,7.75-5.04,10.08 c-0.85,0.5-1.83,0.85-2.97,1.02c-2.08,0.4-4.13,0.89-6.11,1.46c-0.12-0.01-0.19-0.02-0.26-0.04c-1.99-0.57-4.02-1.06-6.09-1.46 c-6.56-0.99-7.91-8.21-7.89-11.11h-14.69c0,2.39-0.98,7.75-5.03,10.09c-0.85,0.48-1.83,0.85-2.97,1.02 c-2.08,0.41-4.13,0.89-6.11,1.46c-6.77,1.46-15.62-2.55-19.15-4.6l-10.42,6.01c3.53,2.05,11.32,7.72,7.87,11.1 c-0.99,1.15-1.84,2.33-2.55,3.54c-0.3,0.65-0.92,1.22-1.77,1.71c-4.05,2.34-13.3,2.89-17.45,2.89l-0.03,8.5 c5,0,17.46,0.8,19.14,4.6c0.69,1.21,1.52,2.38,2.51,3.54c3.41,3.39-4.45,9.06-8,11.11l10.35,6.02c0.36-0.21,0.81-0.44,1.29-0.7 l-1.21,0.7l30.59,0.03c2.01,2.61,2.53,6.12,2.51,7.94l57.72,0.05c0-0.01,14.38-7.99,14.38-7.99l18.9,0.02l10.42-6.01 c-3.54-2.05-11.33-7.73-7.88-11.11c0.6-0.7,1.14-1.42,1.63-2.14l9.69,0.01l10.41-6.02c0.01,0,0.06-8.5,0.06-8.5 C1749.7,1352.49,1737.6,1351.47,1735.92,1347.67z"
  })), /*#__PURE__*/React.createElement("g", null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M1605.2,1317.33c-0.01-3.3-5.83-7.46-8.74-9.15l0.07,24.81c2.91,1.69,8.73,5.84,8.74,9.15L1605.2,1317.33z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1698.43,1332.99l-0.07-24.81c-2.94,1.7-8.85,5.89-8.84,9.2l0.07,24.81 C1689.58,1338.88,1695.49,1334.69,1698.43,1332.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 1621.27,
    y1: 1723.4648,
    x2: 1673.39,
    y2: 1723.4648,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9BFE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8DFF6"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1629.01,1345.84c10.21-5.89,26.67-5.89,36.81,0c5.03,2.92,7.55,6.75,7.57,10.59l-0.07-24.81 c-0.02-3.83-2.53-7.66-7.57-10.59c-10.14-5.89-26.6-5.89-36.8,0c-5.13,2.96-7.69,6.85-7.68,10.72l0.07,24.81 C1621.32,1352.68,1623.88,1348.79,1629.01,1345.84z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "1606.54,1361.19 1596.19,1355.17 1596.27,1379.99 1606.62,1386  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "1698.17,1379.99 1698.1,1355.17 1687.68,1361.19 1687.75,1386  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 1606.5601,
    y1: 1685.068,
    x2: 1639.7999,
    y2: 1685.068,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9BFE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCD2FA"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M1625.82,1381.4c1.98,0.57,4.02,1.06,6.1,1.46c6.48,0.97,7.87,8.03,7.88,11l-0.07-24.81 c-0.01-2.97-1.4-10.02-7.87-10.99c-2.08-0.4-4.12-0.89-6.1-1.46c-5.83-1.99-15.65,2.54-19.2,4.6l0.07,24.81 C1610.16,1383.95,1619.98,1379.41,1625.82,1381.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 8950.999,
    y1: -5249.9165,
    x2: 8967.3916,
    y2: -5277.3311,
    gradientTransform: "matrix(-0.5 0.866 0.866 0.5 10708.0703 -3751.9209)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCD2FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9BFE8"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1659.54,1383.87c0.83-0.48,1.81-0.83,2.95-1c2.08-0.41,4.1-0.89,6.1-1.46c5.87-2,15.63,2.54,19.16,4.6 l-0.07-24.81c-3.52-2.05-13.29-6.59-19.16-4.6c-2,0.57-4.02,1.06-6.1,1.46c-1.14,0.17-2.11,0.53-2.96,1 c-4,2.31-4.84,7.59-5.07,10.1l0.07,24.81C1654.7,1391.46,1655.54,1386.18,1659.54,1383.87z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1604.2,1344.07c3.41,3.38-4.45,9.06-8,11.11l10.35,6.02c3.55-2.06,13.37-6.59,19.2-4.6 c1.98,0.57,4.02,1.06,6.1,1.46c6.55,0.98,7.9,8.21,7.87,11.11h14.68c0.23-2.51,1.07-7.79,5.07-10.1c0.84-0.48,1.81-0.83,2.96-1 c2.08-0.4,4.1-0.89,6.1-1.46c5.86-1.99,15.63,2.54,19.16,4.6l10.42-6.02c-3.54-2.05-11.34-7.72-7.89-11.11 c0.99-1.15,1.85-2.33,2.55-3.54c0.3-0.65,0.92-1.22,1.77-1.71c4.05-2.34,13.29-2.89,17.42-2.88l0.05-8.51 c-5.36,0.21-17.46-0.8-19.14-4.61c-0.69-1.2-1.54-2.38-2.51-3.53c-3.41-3.39,4.45-9.06,8-11.11l-10.35-6.01 c-3.55,2.05-13.37,6.59-19.2,4.6c-1.99-0.57-4.02-1.06-6.09-1.46c-6.56-0.99-7.91-8.21-7.89-11.1l-14.69-0.01 c0,2.4-0.98,7.76-5.03,10.09c-0.85,0.49-1.83,0.85-2.97,1.01c-2.08,0.41-4.13,0.89-6.11,1.46c-6.77,1.46-15.62-2.55-19.15-4.6 l-10.42,6.01c3.53,2.05,11.32,7.72,7.87,11.1c-0.99,1.15-1.84,2.33-2.55,3.54c-0.3,0.66-0.92,1.22-1.77,1.72 c-4.05,2.33-13.3,2.89-17.45,2.89l-0.03,8.51c5-0.01,17.46,0.8,19.14,4.6C1602.38,1341.73,1603.2,1342.91,1604.2,1344.07z  M1628.94,1321.02c10.2-5.89,26.66-5.89,36.8,0c10.13,5.89,10.08,15.43-0.12,21.32c-10.19,5.88-26.66,5.88-36.79,0 C1618.69,1336.44,1618.75,1326.91,1628.94,1321.02z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1596.19,1355.17c3.55-2.05,11.41-7.72,8-11.11c-0.99-1.15-1.82-2.33-2.51-3.54 c-1.68-3.8-14.14-4.61-19.14-4.6l0.07,24.81c3.11,0,9.1,0.31,13.59,1.46L1596.19,1355.17z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "1654.47,1393.97 1654.4,1369.16 1639.72,1369.16 1639.79,1393.97  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 1689.3593,
    y1: 1710.9362,
    x2: 1712.03,
    y2: 1710.9362,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#B9BFE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCD2FA"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M1712.03,1360.74l-0.07-24.81c-4.13-0.01-13.37,0.54-17.42,2.88c-0.85,0.49-1.47,1.06-1.77,1.71 c-0.7,1.21-1.57,2.38-2.55,3.54c-3.45,3.38,4.35,9.06,7.89,11.11l0.02,7.13C1702.66,1361.08,1708.85,1360.74,1712.03,1360.74z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Little_blocks"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 2405.49,
    y1: 1991.886,
    x2: 2481.4099,
    y2: 1991.886,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD5F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#E1E5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7193,
    style: {
      stopColor: "#F7F8FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "2451.93,1051.14 2405.49,1051.14 2434.52,1068.42 2405.49,1085.19 2451.93,1085.19  2481.41,1068.17  "
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2405.49,1085.19 2434.52,1068.42 2434.52,1034.38 2405.49,1051.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2405.49,1085.19 2376.45,1068.42 2376.45,1034.38 2405.49,1051.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2405.49,1051.14 2376.45,1034.38 2405.49,1017.62 2434.52,1034.38  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 1505.0601,
    y1: 1955.921,
    x2: 1573.67,
    y2: 1955.921,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD5F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#E1E5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7193,
    style: {
      stopColor: "#F7F8FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "1547.03,1088.75 1505.06,1088.75 1531.3,1104.36 1505.06,1119.51 1547.03,1119.51 1573.67,1104.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1505.0601,
    y1: 1963.496,
    x2: 1531.3,
    y2: 1963.496,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "1505.06,1119.51 1531.3,1104.36 1531.3,1073.6 1505.06,1088.75  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1478.83,
    y1: 1963.496,
    x2: 1505.0601,
    y2: 1963.496,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C18A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "1505.06,1119.51 1478.83,1104.36 1478.83,1073.6 1505.06,1088.75  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1478.83,
    y1: 1986.446,
    x2: 1531.3,
    y2: 1986.446,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "1505.06,1088.75 1478.83,1073.6 1505.06,1058.46 1531.3,1073.6  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Light_bulb"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 1365.74,
    y1: 2353.6311,
    x2: 1562.03,
    y2: 2353.6311,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6CBE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1782,
    style: {
      stopColor: "#DFE1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    style: {
      stopColor: "#F1F2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#FBFCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "1562.03,694.3 1388.86,694.3 1373.13,706.42 1365.74,711.76 1520.05,718.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1343.52,
    y1: 2350.4121,
    x2: 1404.9399,
    y2: 2350.4121,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6CBE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1782,
    style: {
      stopColor: "#DFE1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    style: {
      stopColor: "#F1F2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#FBFCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1343.52,701.61c8.39,8.39,26.46,15.86,30.71,16.92c4.25-1.06,22.32-8.54,30.71-16.92 C1385.71,700.46,1362.75,700.46,1343.52,701.61z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1339.61,667.08v25.3c0,5.11,3.38,10.23,10.14,14.13c13.52,7.81,35.44,7.81,48.96,0 c6.76-3.9,10.14-9.02,10.14-14.13v-25.3H1339.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 1337.5502,
    y1: 2370.2434,
    x2: 1410.9902,
    y2: 2370.2434,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1410.93,679.96c0-0.67-0.47-1.37-1.09-1.74c0.75-1.75,1.14-3.58,1.14-5.45 c-0.05-0.97-1.03-2.01-2.07-2.01c-1.04,0,0,2.01,0,2.01h-0.48c0,4.99-3.46,9.74-9.74,13.37c-13.47,7.77-35.38,7.77-48.85,0 c-6.28-3.63-9.74-8.37-9.74-13.37h-0.53c0,0,1.03-2.01,0-2.01c-1.04,0-2.02,1.04-2.02,2.01c0,1.86,0.39,3.68,1.14,5.43 c-0.65,0.36-1.14,1.08-1.14,1.76c0,1.86,0.39,3.68,1.14,5.42c-0.64,0.37-1.14,1.08-1.14,1.76c0,5.94,3.91,11.47,11.02,15.58 c14.17,8.18,37.23,8.18,51.4,0c7.1-4.1,11.02-9.64,11.02-15.58c-0.05-0.67-0.52-1.37-1.14-1.73 C1410.59,683.65,1410.98,681.83,1410.93,679.96z M1398.69,700.51c-13.47,7.77-35.38,7.77-48.85,0 c-5.9-3.41-9.31-7.8-9.71-12.46c1.87,2.79,4.7,5.33,8.43,7.48c14.17,8.18,37.23,8.18,51.4,0c3.72-2.15,6.56-4.7,8.43-7.48 C1408,692.71,1404.58,697.1,1398.69,700.51z M1398.69,693.33c-13.47,7.78-35.38,7.78-48.85,0c-5.9-3.41-9.31-7.8-9.71-12.46 c1.87,2.79,4.7,5.33,8.43,7.49c14.17,8.18,37.23,8.18,51.4,0c3.72-2.15,6.56-4.7,8.43-7.49 C1408,685.53,1404.59,689.92,1398.69,693.33z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 1312.9,
    y1: 2443.5085,
    x2: 1435.5699,
    y2: 2443.5085,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M1435.57,606.82c0-33.88-27.46-61.33-61.33-61.33c-33.88,0-61.34,27.46-61.34,61.33 c0,17.23,7.11,32.78,18.55,43.92c4.66,4.68,5.81,13.13,5.81,15.5c0,5.46,3.61,10.93,10.83,15.1c14.44,8.34,37.85,8.34,52.29,0 c7.22-4.17,10.83-9.63,10.83-15.1c0-2.37,1.16-10.83,5.86-15.53C1428.46,639.6,1435.57,624.04,1435.57,606.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 1337.26,
    y1: 2393.8059,
    x2: 1411.21,
    y2: 2393.8059,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#ECEFF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    style: {
      stopColor: "#E0E4F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE1F4"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1348.09,651.15c14.44-8.34,37.85-8.34,52.29,0c14.44,8.34,14.44,21.85,0,30.19s-37.85,8.34-52.29,0 C1333.65,673,1333.65,659.48,1348.09,651.15z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1325.28,612.08c-2.91,0-5.27-2.36-5.27-5.26c0-29.9,24.32-54.22,54.22-54.22 c2.91,0,5.27,2.36,5.27,5.26s-2.36,5.26-5.27,5.26c-24.09,0-43.69,19.6-43.69,43.69 C1330.55,609.72,1328.19,612.08,1325.28,612.08z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.0996,
    y1: 2406.8188,
    x2: 1364.2009,
    y2: 2448.2126,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1199,
    style: {
      stopColor: "#392718"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2445,
    style: {
      stopColor: "#6D4B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3713,
    style: {
      stopColor: "#9A6A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#BE8351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    style: {
      stopColor: "#DB965D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7499,
    style: {
      stopColor: "#EFA466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    style: {
      stopColor: "#FBAC6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAF6D"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M1387.94,599.54c-0.79-0.45-1.66-0.45-2.47,0.02c-1.69,0.98-2.95,4.17-3.76,8.23 c-0.55-1.63-1.27-2.85-2.2-3.39c-0.78-0.45-1.66-0.45-2.46,0.02c-1.7,0.98-2.95,4.17-3.77,8.23c-0.55-1.62-1.27-2.85-2.19-3.38 c-0.78-0.45-1.66-0.45-2.47,0.02c-1.69,0.98-2.95,4.17-3.76,8.23c-0.55-1.62-1.26-2.85-2.19-3.39 c-0.79-0.45-1.66-0.45-2.46,0.02c-3.19,1.84-4.85,11.49-4.85,20.07c0,8.74,2.08,11.32,4.09,13.81 c2.13,2.64,4.33,5.36,4.33,17.03c0,0.71,0.57,1.28,1.27,1.28c0.71,0,1.28-0.57,1.28-1.28c0-12.56-2.6-15.78-4.89-18.63 c-1.89-2.35-3.53-4.38-3.53-12.21c0-9.72,2.06-16.89,3.55-17.83c0.82,0.55,2.32,4.85,2.32,12.97c0,0.7,0.57,1.27,1.27,1.27 c0.71,0,1.28-0.57,1.28-1.27c0-9.72,2.05-16.9,3.54-17.84c0.83,0.55,2.33,4.85,2.33,12.97c0,0.71,0.57,1.27,1.27,1.27 c0.7,0,1.28-0.57,1.28-1.27c0-9.73,2.05-16.9,3.54-17.83c0.82,0.55,2.33,4.85,2.33,12.97c0,0.7,0.57,1.27,1.28,1.27 c0.7,0,1.28-0.57,1.28-1.27c0-9.72,2.05-16.9,3.54-17.84c0.83,0.55,2.33,4.85,2.33,12.97c0,8.07-1.81,12.47-3.74,17.12 c-2.19,5.31-4.68,11.32-4.68,23.44c0,0.71,0.57,1.28,1.28,1.28c0.7,0,1.28-0.57,1.28-1.28c0-11.62,2.28-17.13,4.49-22.47 c2.02-4.89,3.93-9.52,3.93-18.09C1391.6,608.43,1390.64,601.1,1387.94,599.54z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 1370.85,
    y1: 2542.176,
    x2: 1376.11,
    y2: 2542.176,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AABB7"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1373.48,536.15c-1.45,0-2.63-1.18-2.63-2.63v-31.29c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63 v31.29C1376.11,534.97,1374.93,536.15,1373.48,536.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 1405.9655,
    y1: 2527.1931,
    x2: 1421.7344,
    y2: 2527.1931,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AABB7"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1408.6,545.11c-0.43,0-0.86-0.1-1.26-0.32c-1.28-0.7-1.75-2.3-1.05-3.57l10.5-19.24 c0.69-1.28,2.3-1.75,3.57-1.05c1.28,0.7,1.75,2.3,1.05,3.57l-10.5,19.24C1410.43,544.61,1409.53,545.11,1408.6,545.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 1325.2355,
    y1: 2527.1931,
    x2: 1341.0044,
    y2: 2527.1931,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AABB7"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M1338.37,545.11c-0.93,0-1.83-0.5-2.31-1.37l-10.5-19.24c-0.7-1.28-0.23-2.88,1.05-3.57 c1.27-0.7,2.87-0.23,3.57,1.05l10.5,19.24c0.7,1.28,0.23,2.88-1.05,3.57C1339.22,545.01,1338.79,545.11,1338.37,545.11z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Pedestal"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 1662.12,
    y1: 2118.759,
    x2: 2089.9199,
    y2: 2118.759,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4017,
    style: {
      stopColor: "#CFD5F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M1662.12,941.29c0-31.6,20.88-63.21,62.65-87.32c83.53-48.22,218.97-48.22,302.5,0 c41.76,24.11,62.65,55.72,62.65,87.32c0,31.6-20.88,63.21-62.65,87.32c-83.53,48.23-218.97,48.22-302.5,0 C1683,1004.5,1662.12,972.9,1662.12,941.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 1616.39,
    y1: 2070.9697,
    x2: 2044.1901,
    y2: 2070.9697,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBC0E6"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1981.54,1000.69c-83.53,48.23-218.97,48.22-302.5,0c-41.76-24.11-62.65-55.72-62.65-87.32v27.93 c0,31.6,20.88,63.21,62.65,87.32c83.53,48.23,218.97,48.23,302.5,0c41.77-24.11,62.65-55.72,62.65-87.32v-27.93 C2044.19,944.97,2023.3,976.58,1981.54,1000.69z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1616.39,913.37c0-31.6,20.88-63.21,62.65-87.32c83.53-48.22,218.97-48.22,302.5,0 c41.76,24.11,62.65,55.72,62.65,87.32s-20.88,63.21-62.65,87.32c-83.53,48.23-218.97,48.22-302.5,0 C1637.27,976.57,1616.39,944.97,1616.39,913.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 1834.71,
    y1: 2167.0059,
    x2: 2044.1801,
    y2: 2167.0059,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M2044.18,913.37c0-31.6-20.88-63.21-62.65-87.32c-18.09-10.45-38.63-18.62-60.54-24.54l-86.28,183.07 c65.32,0,133.55-4.09,185.91-14.81C2036.32,952.11,2044.19,932.74,2044.18,913.37z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Robotic_head"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 1804.5808,
    y1: 2214.4385,
    x2: 1995.923,
    y2: 2214.4385,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4FFF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0683,
    style: {
      stopColor: "#BFE6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1502,
    style: {
      stopColor: "#ACD0D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    style: {
      stopColor: "#9EBFC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3665,
    style: {
      stopColor: "#93B4BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5342,
    style: {
      stopColor: "#8EADB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M1962.38,892.04c-6.58-39.59-25.31-148.28-25.31-148.28c0.04,12.14-106.87,63.68-165.31,29.93 c-36.11-20.85-56.42-45.9-57.9-67.11v134.71l0.07,0.02c-1.5,10.03,2.86,12.07-1.55,24.57c-11.37,10.92-17.72,23.09-19.05,35.41 c-0.01,0.01-0.02,0.03-0.03,0.05c0.01,0,0.01,0.01,0.02,0.01c-0.18,1.63-0.3,3.26-0.3,4.89c0,20.06,13.26,40.13,39.78,55.44 c53.04,30.62,139.02,30.62,192.06,0c26.52-15.31,39.77-35.38,39.77-55.44C1964.64,901.49,1963.87,896.73,1962.38,892.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 1713.8601,
    y1: 2252.2859,
    x2: 1951.29,
    y2: 2252.2859,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0568,
    style: {
      stopColor: "#E2EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1244,
    style: {
      stopColor: "#C7D6DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    style: {
      stopColor: "#B1C6CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    style: {
      stopColor: "#A0BAC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4052,
    style: {
      stopColor: "#95B1BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5627,
    style: {
      stopColor: "#8EACB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M1951.29,826.61c-7.04-41.15-14.22-82.85-14.22-82.85c0.04,12.16-106.87,63.68-165.31,29.93 c-28.18-16.26-46.57-35.06-54.07-52.62l-3.83,0.36v73.15l116.59,99.88C1890.86,826.61,1921.25,872.64,1951.29,826.61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 1661.7944,
    y1: 2419.5889,
    x2: 1929.4406,
    y2: 2241.6648,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4861,
    style: {
      stopColor: "#E0E2F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBC0E6"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M1625.97,706.59c0-36.51,6.71-70.91,18.56-101.12c27.13-69.15,259.42-69.57,286.66-0.92 c12.08,30.43,18.92,65.16,18.92,102.04c0,54.92-57.09,88.14-82.12,126.42c-29.7,45.41-31.36,91.01-79.94,91.01 C1698.54,924.02,1625.97,826.67,1625.97,706.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.2533,
    y1: 2182.5312,
    x2: 1939.1982,
    y2: 2442.958,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M1903.12,576.41c-10.33-0.53-21.33,3.05-32.78,12.83c-59.54,50.87,19.08,157.82-21.39,202.91 c-40.18,44.77-46.19,124.79-70.67,131.21c0.13,0.01,0.26,0.13,0.39,0.3c3.11,0.24,6.24,0.37,9.39,0.37 c48.58,0,50.24-45.6,79.94-91.01c25.04-38.28,82.12-71.5,82.12-126.42c0-36.88-6.84-71.61-18.92-102.04 C1926.74,593.31,1916.76,583.94,1903.12,576.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_47_",
    cx: -26.8074,
    cy: -2428.2561,
    r: 26.8139,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 2621.4548 -947.3894)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#F67D66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#DE715C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4582,
    style: {
      stopColor: "#9F5142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7403,
    style: {
      stopColor: "#3D1F19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1733,764.34c5.24-10.62,16.89-13.24,26.15-5.88c9.28,7.39,12.5,21.96,7.33,32.55 c-5.2,10.58-16.89,13.23-26.15,5.86C1731.02,789.51,1727.83,774.93,1733,764.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 1695.01,
    y1: 2275.938,
    x2: 1831.2977,
    y2: 2275.938,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1830.81,774.64c0.9-6.52,4.16-27.95-32.51-26.56c-19.16,0.72-38.39-0.93-56.89-4.26 c-30.24,14.12-46.09,44.07-46.4,64.92c16.68,6.85,34.99,11.79,54.1,14.54C1802.01,830.88,1827.52,798.38,1830.81,774.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 1626.37,
    y1: 2341.3159,
    x2: 1649.76,
    y2: 2341.3159,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M1644.17,692.24c-7.47-11.03-11.43-22.78-12.99-34.54v-0.03l-0.54,0.01c-2.72,15.75-4.27,32.06-4.27,48.9 c0,13.54,1.04,26.72,2.81,39.57c2.84,11.74,9.99,23.12,20.58,33.65C1641.5,756.25,1635.43,726.3,1644.17,692.24z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1640.81,624.55c0-21.76,14.38-43.53,43.14-60.13c57.52-33.21,150.79-33.21,208.32,0 c28.76,16.61,43.14,38.37,43.14,60.13c0,21.77-14.38,43.53-43.14,60.14c-57.53,33.21-150.8,33.21-208.32,0 C1655.19,668.08,1640.81,646.31,1640.81,624.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1652.52,624.55c0-20.03,13.23-40.07,39.71-55.35c52.95-30.57,138.8-30.57,191.75,0 c26.47,15.29,39.71,35.32,39.71,55.35c0,20.04-13.23,40.07-39.71,55.36c-52.95,30.57-138.8,30.57-191.76,0 C1665.76,664.62,1652.52,644.58,1652.52,624.55z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Wires"
  }, /*#__PURE__*/React.createElement("g", null, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M1909.29,980.8c3.23-1.87,8.46-1.87,11.69,0c3.23,1.86,3.23,4.88,0,6.75c-3.23,1.86-8.46,1.86-11.69,0 S1906.06,982.67,1909.29,980.8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M1883.02,943.68c0-4.17,2.93-9.25,6.54-11.34c3.61-2.08,6.54-0.39,6.54,3.78c0,4.18-2.93,9.25-6.54,11.33 C1885.96,949.54,1883.02,947.85,1883.02,943.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 1922.6284,
    y1: 2077.9148,
    x2: 1894.4685,
    y2: 2125.6643,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382,
    style: {
      stopColor: "#20196F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    style: {
      stopColor: "#19367C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#0B6C95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4252,
    style: {
      stopColor: "#038DA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4957,
    style: {
      stopColor: "#009AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5896,
    style: {
      stopColor: "#0586A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7808,
    style: {
      stopColor: "#125289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9699,
    style: {
      stopColor: "#20196F"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M1915.13,987.32c-1.74,0-3.15-1.41-3.15-3.15v-27.7l-23.99-13.85c-1.51-0.87-2.02-2.79-1.15-4.3 s2.8-2.02,4.3-1.15l25.56,14.76c0.97,0.56,1.57,1.6,1.57,2.73v29.52C1918.28,985.91,1916.87,987.32,1915.13,987.32z"
  }))), /*#__PURE__*/React.createElement("g", null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M1931.66,967.88c3.23-1.87,8.46-1.87,11.69,0c3.23,1.86,3.23,4.88,0,6.75s-8.46,1.87-11.69,0 C1928.43,972.77,1928.43,969.75,1931.66,967.88z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M1905.4,930.76c0-4.17,2.93-9.25,6.54-11.33s6.54-0.39,6.54,3.78c0,4.18-2.93,9.25-6.54,11.33 C1908.33,936.62,1905.4,934.93,1905.4,930.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 1944.8822,
    y1: 2091.0388,
    x2: 1916.7224,
    y2: 2138.7883,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382,
    style: {
      stopColor: "#20196F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0752,
    style: {
      stopColor: "#331C6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2266,
    style: {
      stopColor: "#7E2A66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#B53461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D63A5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4957,
    style: {
      stopColor: "#E33C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5612,
    style: {
      stopColor: "#CF385E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6957,
    style: {
      stopColor: "#9A2F63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8857,
    style: {
      stopColor: "#47206B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9699,
    style: {
      stopColor: "#20196F"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M1937.51,974.41c-1.74,0-3.15-1.41-3.15-3.15v-27.7l-23.99-13.85c-1.51-0.87-2.02-2.79-1.15-4.3 s2.8-2.02,4.3-1.15l25.56,14.76c0.97,0.56,1.57,1.6,1.57,2.73v29.52C1940.65,973,1939.24,974.41,1937.51,974.41z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Microscheme"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 1666.0601,
    y1: 2437.6272,
    x2: 1919.28,
    y2: 2437.6272,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#915481"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#362E94"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1768.84,635.67c-0.42-0.73-1.35-0.98-2.08-0.56l-76.01,43.88c0.5,0.3,0.97,0.61,1.48,0.9 c0.51,0.3,1.05,0.57,1.57,0.86l74.48-43C1769.01,637.34,1769.26,636.41,1768.84,635.67z M1894.71,601.89l-29.97,17.3 c-2.84-1.22-6.76-1.1-9.35,0.4c-1.63,0.94-2.56,2.33-2.56,3.82s0.93,2.88,2.56,3.82c2.86,1.65,7.33,1.65,10.19,0 c1.63-0.94,2.56-2.33,2.56-3.82c0-0.79-0.27-1.54-0.75-2.22l28.5-16.45h23.39c-0.46-1.02-0.95-2.04-1.48-3.05h-22.32 C1895.21,601.68,1894.94,601.75,1894.71,601.89z M1864.06,624.59c-1.93,1.12-5.2,1.12-7.14,0c-0.64-0.37-1.03-0.82-1.03-1.18 s0.4-0.81,1.03-1.18c1.93-1.12,5.2-1.12,7.14,0c0.64,0.37,1.03,0.82,1.03,1.18C1865.09,623.77,1864.69,624.22,1864.06,624.59z  M1826.27,604.17c-0.73,0.42-0.98,1.35-0.56,2.09c0.42,0.73,1.36,0.98,2.09,0.56l31.9-18.42c2.84,1.22,6.76,1.1,9.35-0.4 c1.62-0.94,2.56-2.33,2.56-3.82s-0.93-2.88-2.56-3.82c-2.86-1.65-7.33-1.65-10.19,0c-1.63,0.94-2.56,2.33-2.56,3.82 c0,0.79,0.27,1.54,0.76,2.22L1826.27,604.17z M1860.39,583c1.93-1.12,5.2-1.12,7.14,0c0.64,0.37,1.03,0.82,1.03,1.18 s-0.39,0.81-1.03,1.18c-1.93,1.12-5.2,1.12-7.14,0c-0.64-0.37-1.03-0.82-1.03-1.18C1859.36,583.81,1859.75,583.36,1860.39,583z  M1797.72,603.98c0.42,0.73,1.35,0.98,2.08,0.56l36.92-21.32c0.47-0.27,0.76-0.78,0.76-1.32v-30.26 c-1.01-0.23-2.03-0.45-3.05-0.66v30.04l-36.16,20.88C1797.55,602.31,1797.3,603.25,1797.72,603.98z M1789.97,594.7l36.92-21.32 c0.47-0.27,0.76-0.78,0.76-1.32v-9.35c0-0.55-0.29-1.05-0.76-1.32l-25.55-14.75c-2.19-0.12-4.39-0.22-6.59-0.28l29.85,17.23v7.59 l-36.16,20.88c-0.73,0.42-0.98,1.35-0.56,2.09C1788.31,594.88,1789.24,595.12,1789.97,594.7z M1855.63,649.61l24.09-13.91 c2.84,1.22,6.76,1.1,9.35-0.4c1.63-0.94,2.56-2.33,2.56-3.82s-0.93-2.88-2.56-3.82c-2.86-1.65-7.33-1.65-10.19,0 c-1.63,0.94-2.56,2.33-2.56,3.82c0,0.79,0.27,1.54,0.76,2.22l-22.22,12.83l-57.29-33.08c-0.73-0.42-1.66-0.17-2.09,0.56 c-0.42,0.73-0.17,1.66,0.56,2.09l58.05,33.52C1854.57,649.89,1855.15,649.89,1855.63,649.61z M1880.41,630.31 c1.93-1.12,5.2-1.12,7.14,0c0.64,0.37,1.03,0.82,1.03,1.18s-0.39,0.81-1.03,1.18c-1.93,1.12-5.2,1.12-7.14,0 c-0.64-0.37-1.03-0.82-1.03-1.18C1879.38,631.12,1879.77,630.67,1880.41,630.31z M1861.73,605.93c0.42,0.73,1.35,0.98,2.08,0.56 l39.77-22.96c-0.77-0.72-1.54-1.45-2.36-2.17l-38.94,22.48C1861.56,604.27,1861.31,605.2,1861.73,605.93z M1792.32,689.6 c-2.86-1.65-7.33-1.65-10.19,0c-0.98,0.56-1.67,1.3-2.09,2.12c-4.54-0.18-9.02-0.51-13.44-0.98l13.82-7.98 c0.73-0.42,0.98-1.35,0.56-2.09c-0.42-0.73-1.36-0.98-2.09-0.56l-17.33,10c-14.51-1.93-28.27-5.4-40.58-10.31l58.77-33.94 c0.73-0.42,0.98-1.36,0.56-2.08c-0.42-0.73-1.35-0.98-2.08-0.56l-61.52,35.53c-0.5,0.29-0.8,0.84-0.76,1.41 c0.03,0.58,0.4,1.09,0.93,1.31c13.35,5.67,28.48,9.62,44.49,11.72c0.1,0.03,0.2,0.03,0.3,0.04c5.96,0.77,12.03,1.3,18.19,1.54 c0.38,0.96,1.15,1.83,2.27,2.48c2.86,1.65,7.33,1.65,10.19,0c1.62-0.94,2.56-2.33,2.56-3.82 C1794.87,691.94,1793.94,690.54,1792.32,689.6z M1790.79,694.61c-1.93,1.12-5.2,1.12-7.14,0c-0.64-0.37-1.03-0.82-1.03-1.18 s0.4-0.81,1.03-1.18c1.93-1.12,5.2-1.12,7.14,0c0.64,0.37,1.03,0.82,1.03,1.18C1791.82,693.79,1791.43,694.24,1790.79,694.61z  M1862.31,675.1c-2.59-1.5-6.51-1.62-9.35-0.4l-53.03-30.62c-0.73-0.42-1.66-0.17-2.08,0.56c-0.42,0.73-0.17,1.66,0.56,2.08 l27.53,15.9v9.63c-1.3,0.17-2.54,0.54-3.57,1.13c-1.63,0.94-2.56,2.33-2.56,3.82s0.93,2.88,2.56,3.82 c2.86,1.65,7.33,1.65,10.19,0c1.62-0.94,2.56-2.33,2.56-3.82s-0.93-2.88-2.56-3.82c-1.03-0.59-2.27-0.97-3.57-1.13v-7.87 l21.33,12.32c-0.48,0.68-0.76,1.43-0.76,2.22c0,1.49,0.93,2.88,2.56,3.82c2.86,1.65,7.33,1.65,10.19,0 c1.62-0.94,2.56-2.33,2.56-3.82C1864.87,677.44,1863.94,676.04,1862.31,675.1z M1831.03,676.04c0.64,0.37,1.03,0.82,1.03,1.18 s-0.39,0.81-1.03,1.18c-1.94,1.12-5.2,1.12-7.14,0c-0.64-0.37-1.03-0.82-1.03-1.18s0.4-0.81,1.03-1.18 c0.96-0.56,2.25-0.83,3.54-0.84c0.01,0,0.02,0.01,0.02,0.01l0.02-0.01C1828.77,675.2,1830.06,675.48,1831.03,676.04z  M1860.78,680.11c-1.93,1.12-5.2,1.12-7.14,0c-0.64-0.37-1.03-0.82-1.03-1.18s0.4-0.81,1.03-1.18c1.94-1.12,5.2-1.12,7.14,0 c0.64,0.37,1.03,0.82,1.03,1.18S1861.42,679.74,1860.78,680.11z M1700.11,653.25h15.4c0.27,0,0.53-0.07,0.76-0.2l39.95-23.07 c0.73-0.42,0.98-1.35,0.56-2.09c-0.42-0.73-1.36-0.98-2.08-0.56l-39.6,22.86h-14.58l-17.28-9.98c0.48-0.68,0.75-1.43,0.75-2.22 c0-1.49-0.93-2.89-2.56-3.82c-2.86-1.65-7.33-1.65-10.19,0c-1.63,0.94-2.56,2.33-2.56,3.82s0.93,2.88,2.56,3.82 c2.59,1.5,6.51,1.62,9.35,0.4l18.75,10.83C1699.58,653.18,1699.85,653.25,1700.11,653.25z M1679.91,639.18 c-1.94,1.12-5.2,1.12-7.14,0c-0.64-0.37-1.03-0.82-1.03-1.18s0.4-0.81,1.03-1.18c1.93-1.12,5.2-1.12,7.14,0 c0.64,0.37,1.03,0.82,1.03,1.18C1680.94,638.36,1680.55,638.81,1679.91,639.18z M1810.13,634.77c-0.73-0.42-1.66-0.17-2.08,0.56 c-0.42,0.73-0.17,1.66,0.56,2.09l39.66,22.89c0.23,0.13,0.49,0.2,0.76,0.2h59.54c0.91-1.01,1.79-2.03,2.61-3.05h-61.74 L1810.13,634.77z M1712.05,616.75h29.28c0.84,0,1.53-0.68,1.53-1.53c0-0.84-0.68-1.53-1.53-1.53h-28.87l-44.37-25.62 c-0.71,0.78-1.36,1.57-2.03,2.36l45.22,26.11C1711.52,616.68,1711.79,616.75,1712.05,616.75z M1736.44,576.75 c0,1.49,0.93,2.88,2.56,3.82c2.86,1.65,7.33,1.65,10.19,0c1.62-0.94,2.56-2.33,2.56-3.82s-0.93-2.88-2.56-3.82 c-2.6-1.5-6.51-1.62-9.35-0.4l-24.37-14.07c-1.24,0.45-2.46,0.92-3.68,1.4l25.41,14.67 C1736.72,575.21,1736.44,575.96,1736.44,576.75z M1740.53,575.57c1.94-1.12,5.2-1.12,7.14,0c0.64,0.37,1.03,0.82,1.03,1.18 s-0.39,0.81-1.03,1.18c-1.94,1.12-5.2,1.12-7.14,0c-0.64-0.37-1.03-0.82-1.03-1.18C1739.49,576.39,1739.89,575.93,1740.53,575.57 z M1768.21,587.23c0,0.84,0.68,1.53,1.53,1.53c0.84,0,1.53-0.68,1.53-1.53v-18.12c0-0.55-0.29-1.05-0.76-1.32l-29-16.74 c-1.48,0.31-2.97,0.62-4.43,0.97l31.15,17.98v17.23L1768.21,587.23L1768.21,587.23z M1703.85,593.01h29.21l26.71,15.42 c0.73,0.42,1.66,0.17,2.08-0.56c0.42-0.73,0.17-1.66-0.56-2.09l-58.06-33.52c-0.73-0.42-1.66-0.17-2.08,0.56 c-0.42,0.73-0.17,1.66,0.56,2.09l26.06,15.04h-23.51l-23.22-13.41c-0.9,0.66-1.79,1.33-2.64,2l24.69,14.26 C1703.32,592.94,1703.58,593.01,1703.85,593.01z M1757.73,666.28c0,0.55,0.29,1.05,0.76,1.32l9.7,5.6 c0.73,0.42,1.66,0.17,2.08-0.56c0.42-0.73,0.17-1.66-0.56-2.09l-7.41-4.28l26.57-15.34c0.73-0.42,0.98-1.35,0.56-2.09 c-0.42-0.73-1.35-0.98-2.08-0.56l-28.86,16.66C1758.02,665.23,1757.73,665.73,1757.73,666.28z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Microchip"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 1788.11,
    y1: 2435.501,
    x2: 1880.37,
    y2: 2435.501,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A5ABCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "1823.1,591.49 1788.11,591.49 1845.38,624.55 1788.11,657.61 1823.1,657.61 1880.37,624.55  "
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "1730.85,604.34 1788.11,637.41 1788.11,657.61 1730.85,624.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "1788.11,637.41 1845.38,604.34 1845.38,624.55 1788.11,657.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1788.11,569.38 1842.35,600.7 1788.11,632.01 1733.87,600.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "1814.33,628.54 1819.16,625.76 1819.16,639.69 1814.33,642.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "1827.09,621.17 1831.92,618.39 1831.92,632.32 1827.09,635.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "1801.57,635.91 1806.4,633.12 1806.4,647.05 1801.57,649.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "1761.89,628.54 1757.07,625.76 1757.07,639.69 1761.89,642.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "1749.13,621.17 1744.31,618.39 1744.31,632.32 1749.13,635.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "1774.65,635.91 1769.83,633.12 1769.83,647.05 1774.65,649.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "1730.85,604.34 1733.87,600.7 1788.11,632.01 1788.11,637.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "1788.11,632.01 1788.11,637.41 1845.38,604.34 1842.35,600.7  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 2078.7,
    y1: 1874.601,
    x2: 2289.7974,
    y2: 1874.601,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M2282.53,1136.63l-28.12-16.23c2.51,2.35,3.76,5.02,3.71,7.7h0.01v18.83h-0.01 c-0.05,3.65-2.46,7.29-7.26,10.06l-154.7,89.31c-4.8,2.77-11.13,4.17-17.46,4.2l0,0h32.23v-0.02c6.15-0.1,12.24-1.49,16.9-4.18 l154.7-89.31C2292.22,1151.39,2292.22,1142.23,2282.53,1136.63z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 1963.7401,
    y1: 1870.751,
    x2: 2258.1501,
    y2: 1870.751,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3146,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4663,
    style: {
      stopColor: "#BBC0E6"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M2250.86,1138.14l-154.7,89.31c-9.69,5.6-25.56,5.6-35.26,0l-89.9-51.9c-4.81-2.78-7.23-6.43-7.26-10.09 l0,0v18.83l0,0c0.03,3.67,2.45,7.32,7.27,10.1l89.91,51.91c9.7,5.6,25.56,5.6,35.26,0l154.7-89.31 c4.8-2.77,7.21-6.41,7.26-10.06h0.01v-18.83h-0.01C2258.06,1131.74,2255.65,1135.38,2250.86,1138.14z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2250.86,1117.78c9.7,5.6,9.7,14.76,0,20.36l-154.7,89.31c-9.69,5.6-25.56,5.6-35.26,0l-89.9-51.9 c-9.7-5.6-9.7-14.76,0-20.36l154.7-89.31c9.7-5.6,25.56-5.6,35.26,0L2250.86,1117.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 2044.9901,
    y1: 1909.876,
    x2: 2258.135,
    y2: 1909.876,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D6F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7338,
    style: {
      stopColor: "#F2F3FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M2250.86,1117.78l-32.76-18.92h-28.51l16.32,9.42l-160.92,93.21h96.13l109.74-63.36 C2260.56,1132.54,2260.56,1123.38,2250.86,1117.78z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "2028.67,1046.96 2044.99,1056.38 2044.99,1201.5 2028.67,1192.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "2044.99,1021.96 2205.91,928.75 2205.91,1108.29 2044.99,1201.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2186.51,833.94c-4.03-5.38-12.08-7.03-17.9-3.67l-187.86,108.46c-5.82,3.36-7.28,10.51-3.26,15.88 l105.16,140.42c4.03,5.37,12.08,7.03,17.9,3.67l187.86-108.46c5.82-3.36,7.28-10.51,3.26-15.88L2186.51,833.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 2043.1438,
    y1: 2173.7241,
    x2: 2198.0488,
    y2: 1989.1152,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7584,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#BBC0E6"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M2100.55,1098.71c-5.82,3.36-13.87,1.71-17.9-3.67l-105.16-140.42c-3.23-4.31-2.92-9.75,0.33-13.48 l-13.3,15.73l0,0c-3.41,3.72-3.79,9.29-0.5,13.68l105.16,140.42c4.03,5.38,12.08,7.03,17.9,3.67l187.86-108.46 c1.42-0.82,2.58-1.87,3.46-3.06l0,0l12.67-14.97c-0.75,0.8-1.63,1.51-2.66,2.11L2100.55,1098.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 1986.1499,
    y1: 2095.656,
    x2: 2283.7798,
    y2: 2095.656,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#34318C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297,
    style: {
      stopColor: "#302D86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6476,
    style: {
      stopColor: "#232172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1C6B"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M2092.71,1091.76c-35.52-47.43-71.04-94.86-106.56-142.29c63.39-37.48,126.77-74.96,190.15-112.44 c35.83,47.84,71.66,95.68,107.48,143.52C2220.09,1017.61,2156.4,1054.69,2092.71,1091.76z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M2175,940.84c-17.53-23.79-50.8-45.88-80.69-30.12c3.6,4.81,5.47,7.31,9.3,12.42 c22.88-11.79,48.4,5.56,61.76,23.62c8.84,11.95,13.62,24.78,13.74,35.6c5.54,2.09,8.29,3.11,13.75,5.09 C2192.94,973.5,2186.63,956.62,2175,940.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M2105.01,983.86c-17.74-23.7-18.07-50.48-1.4-60.72c-3.83-5.11-5.7-7.61-9.3-12.42 c-27.91,18.73-15.33,57.53,1.07,79.06c15.48,20.32,40.7,38.43,67.83,34.09c-2.34-5.17-3.58-7.85-6.15-13.33 C2140.78,1013.51,2119.72,1003.5,2105.01,983.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2192.86,987.45c-5.46-1.98-8.21-3-13.75-5.09c0.12,10.81-4.22,19.73-12.62,24.75 c-2.88,1.72-6.06,2.83-9.43,3.44c2.57,5.48,3.81,8.16,6.15,13.33c4.39-0.88,8.57-2.37,12.37-4.62 C2186.71,1012.67,2192.78,1001.39,2192.86,987.45z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M2026.59,945.23c-8.79,5.31-13.18,7.97-21.96,13.28c-1.27-1.7-1.89-2.53-3.13-4.18 c8.8-5.29,13.2-7.94,22-13.23C2024.72,942.73,2025.34,943.56,2026.59,945.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M2033.26,954.13c-8.76,5.35-13.14,8.02-21.9,13.37c-1.32-1.76-1.97-2.63-3.26-4.36 c8.77-5.34,13.15-8,21.93-13.33C2031.3,951.52,2031.95,952.39,2033.26,954.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M2029.25,970.08c-4.37,2.69-6.56,4.03-10.93,6.72c-1.36-1.81-2.03-2.71-3.37-4.5 c4.37-2.68,6.56-4.02,10.94-6.7C2027.22,967.37,2027.9,968.27,2029.25,970.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M2148.72,904.38c-0.74,0-1.35-0.6-1.35-1.35c-0.02-6.32,0-9.48,0.15-15.74l0.02-0.74l25.73-15.74 c0.63-0.39,1.47-0.19,1.86,0.45c0.39,0.64,0.19,1.47-0.45,1.87l-24.47,14.97c-0.14,5.76-0.16,8.89-0.13,14.93 C2150.08,903.77,2149.47,904.38,2148.72,904.38L2148.72,904.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M2220.58,984.38l-0.6-0.21c-6.45-2.25-9.73-3.44-16.32-5.87c-0.71-0.26-1.06-1.04-0.8-1.74 s1.04-1.07,1.74-0.8c6.37,2.35,9.63,3.53,15.68,5.65l24.77-14.75c0.64-0.38,1.47-0.18,1.86,0.47c0.39,0.64,0.17,1.47-0.47,1.86 L2220.58,984.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M2095.41,1058.67c-0.46,0-0.91-0.24-1.16-0.66c-0.38-0.64-0.17-1.47,0.47-1.86l24.68-14.69 c0.24-5.67,0.3-8.74,0.38-14.58c0.01-0.74,0.61-1.34,1.35-1.34c0,0,0.01,0,0.02,0c0.75,0.01,1.35,0.63,1.34,1.37 c-0.07,6.12-0.15,9.21-0.41,15.4l-0.03,0.73l-25.94,15.45C2095.89,1058.61,2095.65,1058.67,2095.41,1058.67z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M2179.29,930.99c-17.53-23.79-50.81-45.87-80.69-30.11c3.6,4.81,5.47,7.31,9.3,12.42 c22.88-11.79,48.4,5.55,61.76,23.61c8.84,11.95,13.62,24.79,13.74,35.61c5.54,2.08,8.29,3.11,13.75,5.09 C2197.23,963.65,2190.92,946.77,2179.29,930.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M2109.3,974.02c-17.74-23.7-18.07-50.49-1.4-60.72c-3.83-5.12-5.7-7.61-9.3-12.42 c-27.91,18.73-15.33,57.53,1.07,79.06c15.47,20.32,40.7,38.43,67.83,34.09c-2.34-5.17-3.58-7.85-6.15-13.33 C2145.07,1003.66,2124.01,993.65,2109.3,974.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M2197.15,977.61c-5.46-1.98-8.22-3.01-13.75-5.09c0.12,10.81-4.22,19.72-12.62,24.75 c-2.88,1.72-6.06,2.83-9.43,3.44c2.57,5.48,3.81,8.16,6.15,13.33c4.39-0.87,8.56-2.37,12.37-4.62 C2191,1002.82,2197.07,991.55,2197.15,977.61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 1986.1499,
    y1: 2095.666,
    x2: 2283.78,
    y2: 2095.666,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M2283.78,980.54c-63.69,37.07-127.38,74.14-191.07,111.21c-35.52-47.43-71.04-94.86-106.56-142.29 c63.39-37.48,126.77-74.96,190.15-112.44C2212.12,884.87,2247.95,932.71,2283.78,980.54z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M2192.14,858.18c-63.41,37.45-126.81,74.9-190.21,112.35c-6.7-8.95-9.91-13.24-15.77-21.06 c63.39-37.48,126.77-74.96,190.15-112.44C2182.16,844.86,2185.39,849.16,2192.14,858.18z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M2001.67,949.95c7.45-4.4,11.26-6.65,18.98-11.22c2.06,2.76,3.12,4.17,5.28,7.05 c-7.73,4.57-11.54,6.82-18.99,11.22C2004.79,954.12,2003.73,952.71,2001.67,949.95z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2220.47,962.74c-2.19,1.28-3.28,1.92-5.48,3.2c-1.74-2.3-2.62-3.45-4.39-5.79 c2.2-1.29,3.3-1.93,5.49-3.21C2217.85,959.28,2218.73,960.44,2220.47,962.74z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2230.67,956.78c-2.15,1.26-3.22,1.88-5.39,3.15c-1.74-2.3-2.62-3.46-4.38-5.8 c2.17-1.26,3.25-1.9,5.4-3.15C2228.06,953.32,2228.93,954.48,2230.67,956.78z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M2240.69,950.94c-2.1,1.23-3.16,1.84-5.29,3.08c-1.74-2.31-2.62-3.47-4.38-5.81 c2.13-1.24,3.19-1.86,5.29-3.09C2238.07,947.46,2238.95,948.63,2240.69,950.94z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Shapes_on_screen"
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M2062.03,965.64c-0.33,0.19-0.54,0.55-0.54,1.01c0,0.78,0.66,1.57,1.45,1.73l9.78,2.04l-2.14,8.98 c-0.17,0.75,0.33,1.6,1.1,1.93c0.45,0.2,0.9,0.18,1.23-0.02c0.25-0.14,0.43-0.38,0.5-0.69l2.52-10.65c0.11-0.41,0-0.86-0.28-1.26 c-0.27-0.39-0.68-0.69-1.13-0.77l-11.59-2.41C2062.6,965.45,2062.28,965.5,2062.03,965.64L2062.03,965.64z M2045.09,975.51 c-0.25,0.14-0.44,0.39-0.51,0.71l-2.54,10.64c-0.09,0.4,0.03,0.87,0.29,1.26c0.28,0.4,0.68,0.68,1.12,0.78l11.61,2.42 c0.34,0.07,0.65,0.02,0.89-0.12c0.33-0.19,0.55-0.56,0.54-1.02c0-0.78-0.65-1.55-1.44-1.73l-9.78-2.04l2.14-8.98 c0.17-0.73-0.33-1.6-1.1-1.93C2045.87,975.3,2045.42,975.32,2045.09,975.51L2045.09,975.51z M2052.99,964.04 c-0.49,0.29-0.69,0.93-0.43,1.58l10.21,26.15c0.31,0.79,1.16,1.32,1.89,1.17c0.12-0.03,0.23-0.07,0.33-0.13 c0.5-0.29,0.7-0.93,0.44-1.6l-10.2-26.14c-0.31-0.8-1.16-1.32-1.9-1.17C2053.21,963.93,2053.09,963.98,2052.99,964.04 L2052.99,964.04z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M2127.96,993.9c-0.33,0.19-0.54,0.55-0.53,1.01c0,0.78,0.66,1.57,1.45,1.73l9.78,2.04l-2.14,8.98 c-0.17,0.75,0.33,1.6,1.1,1.93c0.45,0.2,0.9,0.18,1.23-0.02c0.25-0.14,0.43-0.38,0.5-0.69l2.52-10.65c0.11-0.41,0-0.86-0.28-1.26 c-0.27-0.39-0.68-0.69-1.13-0.77l-11.59-2.41C2128.52,993.71,2128.21,993.76,2127.96,993.9L2127.96,993.9z M2111.01,1003.78 c-0.25,0.14-0.44,0.39-0.51,0.71l-2.54,10.64c-0.09,0.4,0.03,0.87,0.29,1.26c0.28,0.4,0.68,0.68,1.12,0.78l11.61,2.42 c0.34,0.07,0.65,0.02,0.89-0.12c0.33-0.19,0.55-0.56,0.54-1.02c0-0.78-0.65-1.55-1.45-1.73l-9.78-2.04l2.14-8.98 c0.17-0.73-0.33-1.6-1.1-1.93C2111.79,1003.56,2111.35,1003.58,2111.01,1003.78L2111.01,1003.78z M2118.92,992.3 c-0.49,0.29-0.69,0.93-0.43,1.58l10.21,26.15c0.31,0.79,1.16,1.32,1.89,1.17c0.12-0.03,0.23-0.07,0.33-0.13 c0.5-0.29,0.69-0.93,0.44-1.6l-10.2-26.14c-0.31-0.8-1.16-1.32-1.9-1.17C2119.14,992.19,2119.02,992.24,2118.92,992.3 L2118.92,992.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 2122.9021,
    y1: 2077.7893,
    x2: 2163.2366,
    y2: 2147.6504,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#601B2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    style: {
      stopColor: "#42131F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    style: {
      stopColor: "#1E080E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8287,
    style: {
      stopColor: "#080204"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M2183.67,927.14c-18.09,10.65-59.17,34.95-77.26,45.6c-0.65-0.86-3.39-4.68-3.94-5.22 c18.08-10.66,59.15-34.96,77.22-45.62C2180.38,922.8,2183.03,926.29,2183.67,927.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 2169.8796,
    y1: 2052.3655,
    x2: 2194.7419,
    y2: 2095.4282,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#601B2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    style: {
      stopColor: "#42131F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    style: {
      stopColor: "#1E080E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8287,
    style: {
      stopColor: "#080204"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M2207.61,975c-18.09,10.65-28.57,16.88-46.66,27.53c-0.65-0.86-3.39-4.68-3.94-5.22 c18.08-10.66,28.55-16.89,46.63-27.55C2204.33,970.66,2206.97,974.16,2207.61,975z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 2178.4495,
    y1: 2040.9155,
    x2: 2203.3118,
    y2: 2083.9783,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#601B2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    style: {
      stopColor: "#42131F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    style: {
      stopColor: "#1E080E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8287,
    style: {
      stopColor: "#080204"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M2216.18,986.45c-18.09,10.65-28.57,16.88-46.66,27.53c-0.65-0.86-3.39-4.68-3.94-5.22 c18.08-10.66,28.55-16.89,46.63-27.55C2212.9,982.11,2215.54,985.6,2216.18,986.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 2109.374,
    y1: 2098.604,
    x2: 2157.1028,
    y2: 2181.2725,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#601B2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    style: {
      stopColor: "#42131F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    style: {
      stopColor: "#1E080E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8287,
    style: {
      stopColor: "#080204"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M2177.18,890.37c-11.43,6.74-37.91,22.39-60.41,35.68l3.93,5.24c22.51-13.29,49-28.95,60.45-35.69 C2180.5,894.77,2177.86,891.27,2177.18,890.37z M2085.33,944.62c0.55,0.55,3.29,4.36,3.94,5.22 c5.25-3.09,13.67-8.06,23.42-13.81l-3.93-5.24C2099.01,936.55,2090.58,941.52,2085.33,944.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 2117.946,
    y1: 2087.1526,
    x2: 2165.675,
    y2: 2169.8213,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20196F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    style: {
      stopColor: "#130F42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6043,
    style: {
      stopColor: "#09071E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8455,
    style: {
      stopColor: "#020208"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M2093.9,956.07c0.54,0.55,3.29,4.36,3.94,5.22c8.59-5.06,25.66-15.14,43.15-25.47l-3.93-5.25 C2119.57,940.91,2102.49,951,2093.9,956.07z M2185.75,901.82c-8.18,4.82-24.06,14.21-40.67,24.02l3.93,5.25 c16.62-9.82,32.52-19.21,40.71-24.03C2189.07,906.21,2186.43,902.72,2185.75,901.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 2156.5002,
    y1: 2073.0898,
    x2: 2189.0349,
    y2: 2129.4417,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#024E56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#023C42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    style: {
      stopColor: "#011B1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8147,
    style: {
      stopColor: "#000708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M2201.68,937.91c-10,5.9-22.32,13.18-34.39,20.32l3.93,5.25c12.08-7.14,24.42-14.43,34.43-20.32 C2205.01,942.3,2202.37,938.81,2201.68,937.91z M2139.88,974.42c0.55,0.55,3.29,4.36,3.94,5.22 c5.84-3.44,12.48-7.36,19.39-11.44l-3.93-5.24C2152.36,967.05,2145.72,970.97,2139.88,974.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 2165.0681,
    y1: 2061.6511,
    x2: 2197.603,
    y2: 2118.0027,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#601B2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    style: {
      stopColor: "#42131F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    style: {
      stopColor: "#1E080E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8287,
    style: {
      stopColor: "#080204"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M2210.25,949.35c-6.44,3.8-13.84,8.17-21.52,12.71l3.93,5.25c7.69-4.54,15.11-8.92,21.56-12.72 C2213.58,953.75,2210.94,950.26,2210.25,949.35z M2148.45,985.86c0.55,0.55,3.29,4.36,3.94,5.22 c9.42-5.54,20.88-12.32,32.27-19.04l-3.93-5.25C2169.34,973.53,2157.86,980.31,2148.45,985.86z"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2062.03,962.14c-0.33,0.19-0.54,0.55-0.54,1.01c0,0.78,0.66,1.57,1.45,1.73l9.78,2.04l-2.14,8.98 c-0.17,0.75,0.33,1.61,1.1,1.93c0.45,0.2,0.9,0.18,1.23-0.02c0.25-0.14,0.43-0.38,0.5-0.69l2.52-10.65 c0.11-0.41,0-0.86-0.28-1.26c-0.27-0.39-0.68-0.69-1.13-0.77l-11.59-2.41C2062.6,961.94,2062.28,961.99,2062.03,962.14 L2062.03,962.14z M2045.09,972.01c-0.25,0.14-0.44,0.39-0.51,0.71l-2.54,10.64c-0.09,0.4,0.03,0.87,0.29,1.26 c0.28,0.4,0.68,0.68,1.12,0.78l11.61,2.42c0.34,0.07,0.65,0.02,0.89-0.12c0.33-0.19,0.55-0.56,0.54-1.02 c0-0.78-0.65-1.55-1.44-1.73l-9.78-2.04l2.14-8.98c0.17-0.73-0.33-1.6-1.1-1.93C2045.87,971.79,2045.42,971.81,2045.09,972.01 L2045.09,972.01z M2052.99,960.53c-0.49,0.29-0.69,0.93-0.43,1.58l10.21,26.15c0.31,0.79,1.16,1.32,1.89,1.17 c0.12-0.03,0.23-0.07,0.33-0.13c0.5-0.29,0.7-0.93,0.44-1.6l-10.2-26.14c-0.31-0.8-1.16-1.32-1.9-1.17 C2053.21,960.43,2053.09,960.47,2052.99,960.53L2052.99,960.53z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2127.96,990.4c-0.33,0.19-0.54,0.55-0.53,1.01c0,0.78,0.66,1.57,1.45,1.73l9.78,2.04l-2.14,8.98 c-0.17,0.75,0.33,1.6,1.1,1.93c0.45,0.2,0.9,0.18,1.23-0.02c0.25-0.14,0.43-0.38,0.5-0.69l2.52-10.65c0.11-0.41,0-0.86-0.28-1.26 c-0.27-0.39-0.68-0.69-1.13-0.77l-11.59-2.41C2128.52,990.2,2128.21,990.25,2127.96,990.4L2127.96,990.4z M2111.01,1000.27 c-0.25,0.14-0.44,0.39-0.51,0.71l-2.54,10.64c-0.09,0.4,0.03,0.87,0.29,1.26c0.28,0.4,0.68,0.68,1.12,0.78l11.61,2.42 c0.34,0.07,0.65,0.02,0.89-0.12c0.33-0.19,0.55-0.56,0.54-1.02c0-0.78-0.65-1.55-1.45-1.73l-9.78-2.04l2.14-8.98 c0.17-0.73-0.33-1.61-1.1-1.93C2111.79,1000.05,2111.35,1000.08,2111.01,1000.27L2111.01,1000.27z M2118.92,988.79 c-0.49,0.29-0.69,0.93-0.43,1.58l10.21,26.15c0.31,0.79,1.16,1.32,1.89,1.17c0.12-0.03,0.23-0.07,0.33-0.13 c0.5-0.29,0.69-0.93,0.44-1.6l-10.2-26.14c-0.31-0.8-1.16-1.32-1.9-1.17C2119.14,988.69,2119.02,988.73,2118.92,988.79 L2118.92,988.79z"
  })), /*#__PURE__*/React.createElement("g", null, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M2183.67,923.63c-18.09,10.65-59.17,34.95-77.26,45.6c-0.65-0.86-3.39-4.68-3.94-5.22 c18.08-10.66,59.15-34.96,77.22-45.62C2180.38,919.29,2183.03,922.78,2183.67,923.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 2157.0103,
    y1: 2077.406,
    x2: 2207.6101,
    y2: 2077.406,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M2207.61,971.5c-18.09,10.65-28.57,16.88-46.66,27.53c-0.65-0.86-3.39-4.68-3.94-5.22 c18.08-10.66,28.55-16.89,46.63-27.55C2204.33,967.16,2206.97,970.65,2207.61,971.5z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M2216.18,982.94c-18.09,10.65-28.57,16.88-46.66,27.53c-0.65-0.86-3.39-4.68-3.94-5.22 c18.08-10.66,28.55-16.89,46.63-27.55C2212.9,978.61,2215.54,982.1,2216.18,982.94z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M2177.18,886.87c-11.43,6.74-37.91,22.39-60.41,35.69l3.93,5.24c22.51-13.29,49-28.95,60.45-35.68 C2180.5,891.26,2177.86,887.77,2177.18,886.87z M2085.33,941.11c0.55,0.55,3.29,4.36,3.94,5.22 c5.25-3.09,13.67-8.06,23.42-13.82l-3.93-5.24C2099.01,933.04,2090.58,938.02,2085.33,941.11z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2093.9,952.56c0.54,0.55,3.29,4.36,3.94,5.22c8.59-5.06,25.66-15.14,43.15-25.47l-3.93-5.25 C2119.57,937.41,2102.49,947.5,2093.9,952.56z M2185.75,898.31c-8.18,4.82-24.06,14.21-40.67,24.02l3.93,5.25 c16.62-9.82,32.52-19.21,40.71-24.03C2189.07,902.71,2186.43,899.21,2185.75,898.31z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M2201.68,934.4c-10,5.9-22.32,13.18-34.39,20.32l3.93,5.25c12.08-7.14,24.42-14.43,34.43-20.32 C2205.01,938.8,2202.37,935.31,2201.68,934.4z M2139.88,970.91c0.55,0.55,3.29,4.36,3.94,5.22c5.84-3.44,12.48-7.36,19.39-11.44 l-3.93-5.24C2152.36,963.54,2145.72,967.47,2139.88,970.91z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2210.25,945.85c-6.44,3.8-13.84,8.17-21.52,12.71l3.93,5.25c7.69-4.54,15.11-8.92,21.56-12.72 C2213.58,950.24,2210.94,946.75,2210.25,945.85z M2148.45,982.36c0.55,0.55,3.29,4.36,3.94,5.22 c9.42-5.54,20.88-12.32,32.27-19.04l-3.93-5.25C2169.34,970.02,2157.86,976.81,2148.45,982.36z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Man_near_screen"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 2232.3401,
    y1: 1806.306,
    x2: 2344.3901,
    y2: 1806.306,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    style: {
      stopColor: "#CED2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#E9EBF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    style: {
      stopColor: "#F9FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2232.34,
    y: 1243.45,
    className: "st103",
    width: 112.05,
    height: 20.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 2282.8601,
    y1: 1836.046,
    x2: 2394.9102,
    y2: 1836.046,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    style: {
      stopColor: "#CED2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#E9EBF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    style: {
      stopColor: "#F9FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2282.86,
    y: 1213.71,
    className: "st104",
    width: 112.05,
    height: 20.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 2253.9639,
    y1: 1839.9934,
    x2: 2295.26,
    y2: 1839.9934,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A4400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A4430"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M2295.26,1227.97c0-16.18-10.25-16.65-10.25-16.65s-5.55,0-14.57-3.75c-8.9-3.7-21.44-2.26-14.43,10.66 c0.06,0.15,0.14,0.31,0.24,0.48c0.43,0.69,1.16,1.35,2.28,1.99l22.4,13.14C2284.33,1235.8,2295.18,1231.29,2295.26,1227.97z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M2295.2,1226.51c-0.19,3.32-10.89,7.74-14.28,5.81l-22.4-13.14c-0.74-0.43-2.02-1.28-3.16-2.3 c0.21,0.45,0.39,0.87,0.65,1.36c0.06,0.15,0.14,0.31,0.24,0.48c0.43,0.69,1.16,1.35,2.28,1.99l22.4,13.14 c3.2,1.83,12.91-2.01,14.2-5.24c0.05-0.25,0.1-0.47,0.1-0.66C2295.26,1227.45,2295.22,1227,2295.2,1226.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 2276.0522,
    y1: 1844.7255,
    x2: 2291.7261,
    y2: 1844.7255,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#B57454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#68461B"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M2291.09,1209.19c-2.64,0-11.93,2.36-11.93,2.36s-0.07,1.29-0.83,2.41c-0.09,0.1-0.17,0.21-0.26,0.31 c-1.84,1.27-3.7,3.29,0.65,6.02c3.56,2.24,6.46,0.82,7.83-0.56c0.56-1.04,1.38-2.21,2.52-2.87c1.18-0.68,1.91-0.99,2.43-1.02 c-0.01-0.07,0.02-0.22,0.02-0.22S2292.2,1209.19,2291.09,1209.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 2245.6799,
    y1: 1927.2119,
    x2: 2293.0239,
    y2: 1927.2119,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4B38A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9D7BB"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M2291.25,1051c-10.13,0.18-35.45,0.63-45.57,0.82c3.77,30.45,11.35,58.1,16.42,87.59 c5.44,28.66,11.56,48.8,16.91,72.65c1.96,4.44,10.91,2.76,12.73-1.51c1.42-21.97,3.05-48.73-3.47-74.07 C2289.37,1109.16,2291.89,1078.58,2291.25,1051z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 2202.8848,
    y1: 1810.2644,
    x2: 2244.1899,
    y2: 1810.2644,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A4400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A4430"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M2244.19,1257.69c0-16.18-10.26-16.65-10.26-16.65s-5.55,0-14.57-3.74c-8.89-3.7-21.44-2.27-14.43,10.66 c0.06,0.16,0.14,0.31,0.24,0.48c0.43,0.69,1.16,1.35,2.27,1.99l22.4,13.14C2233.26,1265.53,2244.11,1261.02,2244.19,1257.69z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M2244.13,1256.24c-0.19,3.32-10.89,7.74-14.28,5.81l-22.4-13.14c-0.74-0.43-2.02-1.29-3.16-2.3 c0.21,0.44,0.39,0.87,0.65,1.35c0.06,0.16,0.14,0.31,0.24,0.48c0.43,0.69,1.16,1.35,2.27,1.99l22.4,13.14 c3.19,1.82,12.92-2.01,14.2-5.24c0.05-0.25,0.1-0.47,0.1-0.66C2244.19,1257.18,2244.15,1256.72,2244.13,1256.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 2224.9856,
    y1: 1814.9954,
    x2: 2240.656,
    y2: 1814.9954,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#B57454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#68461B"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M2240.02,1238.92c-2.64,0-11.93,2.36-11.93,2.36s-0.06,1.29-0.83,2.41c-0.09,0.1-0.17,0.21-0.26,0.31 c-1.83,1.28-3.7,3.29,0.65,6.02c3.56,2.24,6.46,0.82,7.83-0.56c0.56-1.04,1.38-2.21,2.53-2.87c1.18-0.68,1.9-0.99,2.42-1.03 c0-0.07,0.02-0.22,0.02-0.22S2241.13,1238.92,2240.02,1238.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 2220.8232,
    y1: 1908.9496,
    x2: 2291.8293,
    y2: 1908.9496,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4B38A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9D7BB"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M2259.11,1123.4c2.78-13.09,34.72-14.71,32.62-66.18c-10.02-1.48-60.58,22.24-70.6,20.76 c-1.25,30.66,1.71,59.18,1.9,89.1c0.68,29.16,3.44,50.03,4.82,74.44c1.21,4.7,10.32,4.51,12.81,0.59 c4.98-21.44,10.97-47.58,8.68-73.64C2252.32,1154.03,2255.87,1138.73,2259.11,1123.4z"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2268.61,957.28c35.67,23.83,39.92,71.16,20.64,101.2C2289.25,1058.48,2293.4,991.92,2268.61,957.28z"
  })), /*#__PURE__*/React.createElement("g", null, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M2270.25,1086.4c-21.71,12.18-44.42,12.21-52.17-2.77c2.9-27.89,5.61-50.58,0.02-77.31 c1.65-14.76,2.81-16.98,0.92-25.59c0.67-2.89,9.55-9.05,16.02-14.95c6.99-6.38,11.71-12.45,15.31-13.18 c29.69-6.06,44.11,46.84,41.63,103.24C2289.68,1070.82,2280.93,1080.4,2270.25,1086.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 2225.7292,
    y1: 2124.833,
    x2: 2267.7549,
    y2: 2124.833,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#B57454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#68461B"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M2266.81,955.96c-6.44-4.65-5.48-7.7-4.52-14.03c1.23-3.32,1.94-7.01,1.94-10.93 c0-14.1-8.98-26.29-19.99-25.53c-22.18,1.52-18.24,13.2-18.24,27.3c0,13.06,5.92,22.06,15.84,23.57c0,2.14-0.57,3.38-3.27,6.08 c7.24,4.34,17.82,2.3,22,0.41C2265.03,960.81,2269.83,959.08,2266.81,955.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 2165.1299,
    y1: 2079.0369,
    x2: 2187.29,
    y2: 2079.0369,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#B57454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#68461B"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M2185.96,989.8l0.04,0.12c0-5.57-1.16-8.81-3.31-9.76c-0.46-1.33-0.95-2.72-1.42-4.05 c-2.77-7.76-11.47-14.42-13.32-12.57c-1.11,1.11,3.31,4.53,5.64,8.23c1.54,2.44,1.55,3.79,1.94,5.83c0,0-10.4,0.97-10.4,9.61 c0,7.03,3.79,4.25,3.79,2.87c2.69,7.12,5.87,2.91,7.11,8.72l11.26-4.98C2187.29,993.82,2186.76,992.2,2185.96,989.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 2268.76,
    y1: 2116.5212,
    x2: 2227.2065,
    y2: 2158.075,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A9AD"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M2253.99,901.89c-2.86-1.47-5.43-0.71-7.03-1.73c-3.79-2.32-7.38-3.8-9.38-2.7 c-0.98,0.53-2.82,2.24-2.82,2.24c-1.97,1.97-6.02-2.23-6.99,2.87c-0.28,1.5-0.35,2.74-0.33,3.96c-9.47,1.22-4.81,9.84,2.8,26.46 c0.01-2.7,5.74-8.93,5.74,3.05c0,1.29-0.96,1.54-0.12,3.25c0.85,1.71,6.29,6,9.89,9.59c5.01,5.01,7.95,0.52,16.24,1.42 c0-3.55,0.92-5.33,2.18-7.55c0.8-1.4,5.34-5.87,5.35-13.65C2263.07,929.89,2274.51,912.46,2253.99,901.89z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2219.02,980.73c-2.79,11.05-5.11,28.69-6,38.78c-9.08-9.45-17.42-13.58-25.28-26.13l-12.84,5.36 c2.42,8.77,26.22,44.86,43.18,47.51c16.58-6.21,19.73-36.67,22.18-49.73C2243.86,977.41,2223.12,969.71,2219.02,980.73z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Flat_pie_charts"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 4255.2324,
    y1: -6138.4097,
    x2: 4400.7495,
    y2: -6138.4097,
    gradientTransform: "matrix(0.7494 -1.0114 0.434 0.7486 1125.1191 9337.0693)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAF6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF826A"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M1720.04,388.34l-9.98-14.13c22.97-28.62,30.81-67.1,17.5-85.94l17.23-21.47 C1763.61,293.45,1752.53,347.87,1720.04,388.34z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1720.04,388.34l-9.98-14.13c22.97-28.62,30.81-67.1,17.5-85.94l17.23-21.47 C1763.61,293.45,1752.53,347.87,1720.04,388.34z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M1727.57,288.27c-13.3-18.84-42.71-10.91-65.68,17.71c-14.12,17.6-22.5,38.92-23.78,57.11 c-0.8,11.39,1.15,21.57,6.28,28.83c8.51,12.05,23.6,13.1,39.38,4.85c8.9-4.65,18.01-12.24,26.29-22.55l9.98,14.13 c-11.71,14.59-24.6,25.32-37.18,31.9c-22.32,11.68-43.66,10.18-55.69-6.85c-7.24-10.26-10.01-24.65-8.88-40.77 c1.82-25.73,13.66-55.88,33.63-80.77c32.48-40.48,74.07-51.69,92.88-25.04L1727.57,288.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 1660.9102,
    y1: 2719.4724,
    x2: 1717.3102,
    y2: 2719.4724,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M1676.27,335.62c-0.66-0.56-1.86-0.03-2.69,1.21l-11.95,17.9c-0.45,0.68-0.72,1.46-0.72,2.13 s0.26,1.15,0.71,1.31l11.95,4.1c0.83,0.28,2.03-0.56,2.69-1.9c0.66-1.33,0.52-2.63-0.3-2.92l-10.08-3.46l10.08-15.1 C1676.79,337.65,1676.93,336.19,1676.27,335.62z M1716.6,322.99l-11.95-4.1c-0.82-0.28-2.02,0.56-2.69,1.9 c-0.66,1.33-0.52,2.63,0.3,2.92l10.08,3.46l-10.09,15.11c-0.82,1.24-0.96,2.7-0.3,3.27c0.66,0.57,1.87,0.03,2.69-1.21 l11.95-17.9c0.45-0.68,0.72-1.46,0.72-2.13C1717.32,323.63,1717.05,323.15,1716.6,322.99z M1692.05,319.03l-9.56,44.02 c-0.29,1.34,0.3,2.21,1.31,1.96c1.02-0.26,2.08-1.54,2.37-2.87l9.56-44.03c0.29-1.34-0.3-2.22-1.31-1.96 C1693.41,316.4,1692.35,317.69,1692.05,319.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 13508.9443,
    y1: 5024.7407,
    x2: 13665.9189,
    y2: 5024.7407,
    gradientTransform: "matrix(-0.866 0.5 0 -1.1547 13397.7559 -550.3967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAF6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF826A"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M1631.04,402.01V425c-26.54,15.32-48.06,52.59-48.06,83.24l-19.91,11.49 C1563.07,476.38,1593.5,423.68,1631.04,402.01z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1631.04,402.01V425c-26.54,15.32-48.06,52.59-48.06,83.24l-19.91,11.49 C1563.07,476.38,1593.5,423.68,1631.04,402.01z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1631.04,424.99V402c13.53-7.81,26.11-10.45,36.7-8.7l-10.75,25.53 C1649.5,417.6,1640.61,419.47,1631.04,424.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 13523.0781,
    y1: 4956.7793,
    x2: 13665.9189,
    y2: 4956.7793,
    gradientTransform: "matrix(-0.866 0.5 0 -1.1547 13397.7559 -550.3967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M1582.98,508.23c0,30.65,21.52,43.07,48.06,27.75c16.32-9.42,30.72-27.15,39.41-46.53l16.32,3.71 c-12.28,27.4-32.65,52.48-55.73,65.81c-37.54,21.67-67.97,4.1-67.97-39.24L1582.98,508.23z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M1679.1,452.74c0-19.6-8.82-31.69-22.11-33.9l10.75-25.53c18.79,3.11,31.26,20.22,31.26,47.94 c0,16.69-4.54,34.75-12.24,51.91l-16.32-3.71C1675.89,477.32,1679.1,464.54,1679.1,452.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 1618.16,
    y1: 2580.9661,
    x2: 1645.85,
    y2: 2580.9661,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M1632,475.52c-1.94,1.12-3.76,1.3-5.13,0.51c-1.37-0.79-2.13-2.46-2.13-4.7c0-4.62,3.26-10.26,7.26-12.57 s7.26-0.43,7.26,4.19l6.59-3.8c0-7.5-4.51-11.2-10.55-9.42v-6l-6.58,3.8v6c-6.05,5.2-10.55,14.1-10.55,21.6 c0,4.27,1.44,7.45,4.05,8.96c2.62,1.51,6.09,1.16,9.79-0.97c4-2.31,7.26-0.43,7.26,4.19s-3.26,10.26-7.26,12.57 s-7.26,0.43-7.26-4.19l-6.59,3.8c0,7.5,4.51,11.2,10.55,9.42v5.53l6.58-3.8v-5.53c6.05-5.21,10.55-14.1,10.55-21.61 C1645.85,474.7,1639.64,471.11,1632,475.52z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pie_chart_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 2256.74,
    y1: 2358.4614,
    x2: 2364.3301,
    y2: 2358.4614,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M2311.74,743.55c-20.07,11.59-36.34,2.19-36.34-20.98c0-23.18,16.27-51.36,36.34-62.95 c16.37-9.45,30.2-4.94,34.75,9.61l17.84-16.6c-6.89-22.02-27.82-28.84-52.59-14.54c-30.37,17.54-55,60.18-55,95.25 s24.62,49.28,55,31.75c7.83-4.52,15.27-10.72,22.01-18.01l-7.46-15.43C2321.83,736.47,2316.91,740.56,2311.74,743.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 2249.6396,
    y1: 2304.5042,
    x2: 2327.4082,
    y2: 2439.2039,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79544A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M2256.74,733.34c0-35.07,24.62-77.72,55-95.25c15.34-8.86,29.21-9.6,39.19-3.66l0,0l-7.85-4.53l0,0 c-9.97-5.95-23.84-5.2-39.19,3.66c-30.37,17.53-54.99,60.18-54.99,95.25c0,17.51,6.14,29.82,16.07,35.58l0,0l0.03,0.02 c0.01,0,0.01,0.01,0.02,0.01l7.8,4.51l0,0C2262.88,763.16,2256.74,750.85,2256.74,733.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 2333.1799,
    y1: 2397.771,
    x2: 2346.49,
    y2: 2397.771,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79544A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M2333.18,655.34c2.38,2.37,4.26,5.5,5.46,9.35l7.85,4.53C2344.17,661.81,2339.43,657.02,2333.18,655.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 2282.4199,
    y1: 2322.2454,
    x2: 2326.29,
    y2: 2322.2454,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79544A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M2318.43,727.11c-4.45,4.82-9.37,8.92-14.54,11.9c-8.03,4.64-15.45,5.91-21.47,4.28 c6.61,6.6,17.28,7.2,29.32,0.25c5.17-2.99,10.09-7.08,14.55-11.91l0,0l0,0L2318.43,727.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 2318.4299,
    y1: 2361.8811,
    x2: 2348.0801,
    y2: 2361.8811,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AABB7"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M2346.49,669.23l-7.85-4.53c1.03,3.29,1.59,7.1,1.59,11.37c0,17.2-8.97,37.16-21.8,51.04l7.85,4.53 c12.83-13.88,21.8-33.84,21.8-51.04C2348.08,676.33,2347.52,672.52,2346.49,669.23z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2346.49,669.23c1.03,3.29,1.59,7.1,1.59,11.37c0,17.2-8.97,37.16-21.8,51.04l7.46,15.43 c19.41-21.01,32.98-51.21,32.98-77.24c0-6.47-0.84-12.23-2.4-17.21L2346.49,669.23z"
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 204,
    height: 121,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAAB6CAYAAAAcc9ekAAAACXBIWXMAAAv+AAAL/gFBkBnlAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAHflJREFUeNrsnfl3FEeSxzMkQGDM IcAGAzZgjMHYY3yOZ6+38/aX/av3nsvr8fhcsDEGc9jgg8NgAwKh2IyqSFVWVkRmVh9SdyvrvUKt 7la3UOenIr5xpTHlKEc5ylGOcpSjHOUoRznKUY5ylKMc5ShHOeQDyp+gHMMciAjCOkI6AaBAU45y CLBssuc2e27h75ft+dCej+z5ZBbhKdCUY1BgNjMse+x5mL8SQL/Y8zt7/mjPe/ZcmjV4CjTlGNS6 PGvPo/Y8Yc/T9jxozwV73rLnV/b80p7f2PMHe9518MwCOAWacgziipFVOWPP9xiYF+25yNbHWZoL 9jzL8HzF9923r/XEaZ65ubkCTTk2jCv2EgPzDn+/gzXNnKdpbtrzW4bnffs6H/L3zmVbnlZ4NpVl UY4BXLGTDA65ZNvtOe9dgLcwZFvtudeeh+xrLTJw5+152Z437PmzPR8QPCsrK1MFTrE05dBgWeBz UXDFnrHnTn58Lv5y+JiDApdZ45z3XLarDM9jq3WmJkxdoCmHBAtZiQN8HrPnbwNXzMECidd0Nx+z VfmZrcxFe5K79lcLySUKHqDBhy2XDSbX8hT3rMDiFv5WD5ZD9nyF3TGC5rjiikmASMdmL4hAlus5 e+4jl83+3GeV7gFzvYIKKz1UuWyTqncKNAWWedYhBMoL7IKdYt1yiLXIDvv8BWsV5jIh0bwaB88C v+duhvKcheVLtkDXJ13vFPdsY8NCi/dp1ijv2MfesmCQhTlib5OIf4oWOsHi/Vz3NQdbTC7KdodB uVjBI+gdM2FRtgLNxtMszrIQLAfs/UdME0J+jd2z7WwVIK1buiupx6JChmcpgKfSO/as9A7DNTEh 6uKebRxgNrFmIZdon73vedYtp9hFOsY6Y6uJR8Rqy4LCndC52ddl2+3rHXvWeqdx2SZC7xRoNoZ1 oYW5izSLvY+syoss8l9i3bJoV+FT0FgX0f0yEizKY6iZHc8yQa7eMZOld4p7Nvuu2Fa+ap9g3fI6 aRa+otP9FNHahGRdeEFTqgSDRY7jWjQgvl6u3lm2emvFrHF+p0Az27DQ1fqgvZ8sy5v2fNvU4eNF fpyu7HOYsCA47gUH4mNRvcP5nTsM12P7f1xZK5etuGezq1sIlmOsWU6xpTnMbtpmp1skYHActDAV YqTNWTPoMCTqHQtMpXfs/+8Kw0TBgvvsso0dngLN7OqWU57If44X3Ta2QoAxHYIyMzCgFQJBz6Tg SekdviBcYneNggXfevA8JnjGBU5xz2ZXtxz3YKHH59GPiimwoIRES9CAjktH+IC+0FIhalAXp693 frLnFdY6X5imINSFqcdidQo00wuMqySmwsnnPN3yrqdbnGWZw9gaX4UFo5am96Lq3mgvuAxwlMed 3qGWamo1+N7UxaCf2PMDhudHZ3XMiPM7xT2bXmBcJp+0C5W8UPnLb0wdRt5nmv4WMaXSgIGKldHe P1jXoMMIrRuw+ljMXRPdufD/ANXb+i7b015w44m3tgmcXxicJ6MKURdopguWOYah0i72fIX1y8um zr0cZHdsix9ClvUKDgyK9hhABJ6GoK6eCQMRkNZGrHuce7qNLyAr/Gpkfffb82t7XmM3bjVQMCw4 xT2bLlioFmwvA3PGro63TA3Nfif0kS6EGFiY0N1CjOcoh4iaAWQsNNCXH0jQBQ+CrH0IGBeevsHu GgUJ/s/UbdcUKFidVTCMu1agmS5YDrJlIXeM6sRewvoKu429hrkuIHmwaKCoORxdqJs+eUbIvEOC ToBnhYFYYkBI61BS9EP+eoWtzi/DwFOgmVxgNrGvTvrkEMNygl0xyugfQHLT0Cxg2BDmgyOBorhl qSRnH3DUxQaDPL8XOM7qOHjI6lxgq3Oeb19leO4Zbz5bLjwFmsmDBdi67GQ4Ttv7T3uwPIv0GNYZ fWSRgAIRmBD4cmITI/5RpcGTq2mYRSWBNSQ8BA6V3NxkWEjnfOHB8z3DQ8GCLL1ToJksWFxGf5EB edM+9lt2xw54sMxjyxULRL0SMs6GJHOlQN/lI4SQtV6cXvDkWZ3H7JbdZDeNLM/npg5TX2J37lFO LVuJnk0OLAte1OdF+xiV7VPe5VW6j6qQ7QprEpRebsXXI9rtrpVBk8uL8YNfGnDRSzDjFXk/DLTQ asBNvA9Xo3CrrwtCOLv+Zo5P10e0g/UhlRQdZL24wFG22xxlW61lk+Ap0KwvMPP8oS3yedTeT7qF gCEN8wLSB4yV0J9ru2Jt6yLBgomYcraGgUypgxo3SgAC2tYKsa2T3O8HPcDpgNh868Pj8lzbGaQ9 bHko4kZDDW/Zz8GFqDt6p7hn62dd3AdHzWAnuSnsFMNyiGGp2o0xjIr54t4Hp+WayS5brmUZ2K+H AX4euq4eQNxd8101SAUmZK21wkGAmwzKVdOM0yXdc50tz2py1IFToFkfV8xNZTnMuuVdhucw0lWv DQskYUHZ7eoEAnqUx8CYlC8o2qZZ2KBG56ADTYa2iUf7nN55yMEAmjt92TR9OxfY+hBYD1yUbb4s 5zV1xcgdeIZF/uv2/t/Zr/9oKElZu2L7soAxWsgYO2DI7hvyIoTRgdADsmxwktAo4Yj8YlDw3DW6 kO3iz8fNfNvJP7HsAfakaJr1ccVOsm45zq7Yol3dmzkqBu2Fn9YuHXcMJWCwExjojGGCwbwtjN4B nQUfivyYLsmUUt0WA8i2Nr7ecdFLF5B5loMGBzjSRpbnhwLN+rhilHN5jmFp5Vt6w4LYXqcYumXY Efyxnn9IAdHTBLn/lJsABaBHx4ahJXeMVIYR3ORF2lwx6F7+HMlFu12gGS8su/mKddwLIdPXZ5Cu aLV1ga72QFncYxcCSbdIlcuxbsxenZrQ4ynYaSjLgExuI4AMclJ5mx7GzP0l6HPcwdE118QHBZrR 6xYXQnb5lpcFV6yahdx1pVAJHXswKC6YD0sqV4ORZYKpVYrpheyDoi186MdhEhVIsZ03Ygr5pMDA XdNUEXzBwQFqNVgu0IwGljnvqnQ40C3HhnXFpPBx6IJpP58Dime/VF0SbXUGkw77jvhQ69hi76+3 WztYnrALRiFoGuJBoefzpukI/b5AMzpYtrP5JmDO+LrFVP3sFSyiK4ZtNa+Kd1Qe10PPPSGJWZ3V 2U7dFQpDr/z0Y30LPXu8vYPFTb1xu7hRac3fGBbXj0OPPSrRs9HAQq7YQdYtlM1/Pa1bPBg6Ea0U LNi9H3OiWH1BER725qKNHJLM6BgE4gX6vjZ0YHFbgPzkuWIfmboH54YHy+q8gQJNj2MFkXTIPNSw 7GVYTrBuoWw+NYftl3RLmGsJoTAmAougV9QK5j6gaK+Rue7zLQCMAaiewEDLujg37A5bFirY/MY0 CU3XOrCa0PTLaAo0mbCYpiFsh/2rH4W61ZhAOc2wUBXy0wzLfKtOLAILBitXFP/+/RiPeI0CEs2q jMtNyoJzUGMGoit2zzRlM2fZulxly0KlM78abhWgnw3bBQo0+bC4hjCyLu+xbjmKlPjCeqNWdBse xWCJ9OhjEFpWIQuDCAO6XF1LF6y3CDCQo/ghLeIhRyFpWipWNgMdke+7YtQa8CGfbufp1QHrJjH6 qUCj6xayFg6Wui+/7p48Zj+Odyq3jMQ/MizoqudlcS7C0oEm4YIlevuHhUQDxkjASA+BZCGgvw7S 2AGIWyEQC53JYlDFMoWQr7MrdpaFvgsjPzA9tvIo0LQtC7Bo3wx1+PgZDxZyxV6uLQvSpP2dWP/9 ICbwxRxLL6syHCi9W5iFBQ4Q1Qjjdc0gDbHy33bA0OBAt0muy7dcNE3/zJLpORetQOPBYiqLgQv2 EyLLctzUmuUVhsXCY/ZxMxjrFm+elxLVUmESel40PTMOS+I/rZ8RyHWh+lECAoUAeguAYmUwsC63 2P0iq/K5abbruONbl76DNTY8NEgRMcRN9hNasN+4rj5yvagC+XWkiuQalqc5fMzNYNjSFH0tixQ9 k8r/xwGJUYS+6F5JbhnE3bKYO9bRIh4wEAEmAR1CFxYa2UTJyU+tW/eJ/YwvsWXp5YoVaLrWhf5i VPaym12x5yvNgkgtxm+wdSE3bDPNEkMeYydbjXhNWAcWzargaCDBDFqSHk8OMAmrI0PStTChGxab BwBdYHxYrplmeMZ51jDXWdM8MiMYUbtpg8Lij0g6XOmVWrdQfdgxpPuwmvqy3S7u+aqaKgAgvx6s gSWVexk9JPrAspRlGJlWiWgSDZisaFvbutxizXKeRf55/p6ayu5aK7M0qCu2oaFZCSe+IO62nxJ1 StJGR79jWJ61H8MepGpWpEYwnJcy94hKFCzQIamsvmRVsK+rFanzH/nuZZm1XhBGukBa/A0w0K+N GaGu3FviELHTLTT4/FNDyUmoYameg1VyUsy3jPLPMMu6xcGy39RT9k/b22+TO8ZtxjR4bzNWHZMI PjBa/72qVUTNkleFPIwlweiH3MPKKDkZSAED0HGxQBD7ILx3AhhkYAgWSj5Sxv57FvcEy8d8+3YF E3iwwGi32phpSyPoFurAe5GjYnRSvdhhti5bXK6lky/xwr9ahEyyPFJRZS4oA0OimhdQLYVJaZkM CwNusSv6JQ8Y0Nwxuow9groOjPIqLpvvKpFD3bJCf4dxbeq0aYZhkXTLK6uw1Jn8RS6qnPcjYqlI WAgFhnoHIxYFhoMlXb1sotny2PdqtCzxq0eBSVgYCOiB0LrU2mWJ9QkB8qWnW26wxXGDzUemWzYM NBm65YQHy4L9uqkdPo6L/LDhq2tVTHKDMPd8ULnAfEtilC3+IEN4mFTCMBItA6dbPLSU6JcWTvaB USyLg8W5YjT9/317fmbqZKXbPsPNYh6pbtkQ0Ii6pXbFat1izKs87WWBt6MAqT4sBYykc2Ldk2J/ fitgAEODkm1FekTLIAYMNIFgUMPJ0HXRUrAA65Y2LM4V+4h1y9WWG8Z/jrWAZWagGVS3RIspw8dS pfnYf0exBoB0myXGfDkh0SiJ/1EI/9aiD503JUkKESMWfEsfJIEQ6pZzpt05+etauWEzBw02dWL9 dEtGSQtifPxRbBp/TPCj94+U9YccSIw39zgTmGSINGMyYDuX0t8lMwJwAAndAhUsV+0z/M7JlfUE ZiqhwUF1SywbL0TF1EJKzSXDfGA00FChJ2dr8lxg+rplAKH1ACFrn6lh2i6ZFEKWdMsvFDmzz153 WKYSGqdb7B9/q/26GwbVLUHZi1ry4i/cmC4JgTFxYDDyxGh/S8eNGhKYwMJoiciUS6YBo1knzuQ/ sveHrlhbt6CFBSYHlqmCRtMtmNItzrp0SmAwXSMmXOnF2WIZwj0WRU7tfQlrln4OhiJ1BHzawsj1 Y23rArU7tgRyCLmrW2Bu4tbjREOj6Rb0dAsBhE63ULk+dkPIkm7pBQwq24inVn3CLROtTGZIeLRW xlv04jimRA5GipC1rcsKNAnKuCs2IbplKqHxpr5srUr2AWhAOHVM/p1xY12xmgSzgBHdIgp9YaGm S/bl/pZY7RgOYWUkMNLHgDomEh42gQUB72fkIIDxK6iR7yM361doqpDJqvyN3bErYQh5UmGZaGiw 7s13I5KoL/+IvfM1+2H8vaGSfaymV26L6ZYoMKhXIovRMcyzDBjZ/TUKDAYNYZABktGjZ7nh5Y6V CF8XQLcuedql2sbC3u9gca3G50zTm39vvUPIUw2NFxkjV+tZ+z1NpyRX7DV2y47Z1bUf68HUc1mu UcKNygUmNeVFFv+YtjDY3TpPZSCjiSU5fy8JRGNdBoWFtcuyvf0T1JbkS3bDLni6hQZZDLwt+YaH RtiolSwJ7dlCloUawo74e7eAtwVkzjwxsRXZpAfzqcAk5o1pvTUiyJAYV5Tsc5H3cumEfQMNEoaU O2JfEPOZQv+Jvf0Y6mpjqj7+o6knVl4MdIvrnjTTBMy6Q4N+b35tPXbZ+2iU60moXTHKuzyPPCKJ NY7pM4BvYGCMLvqTOiazcwwyqo5jkMQMkNw6LJTcj8a60H92peqgBHMX6jDyJQbmjwzMHbMOdWIz BQ3rFh+WAxwNo+F7pylCxu3GT5lgs6OohVFEv19QqblkXWuCceuiCv+4WxbVIANCIgEjRrhioeSW BYq1IXvWpW7yIstyl9wxhuUcn26YxV0zZF/+hobGsy5kORbt9wc9WCiM7DL6u9lVm0vN/8qdLSYm NRVXqi8wJvJaMcsCMbnfAxQ1kmXkdmIJmJh1kVyxyrpApU1u2PsuQQMLaRgabEEBgPvTqFsmAppA tzzFUbGTrF1e9WDZVYWRw2mVISzadMoRAJP3/xGDZGKkzMB4QNEiY2ruxPunl3WRYGFXjACBelLl ZwEs/rRKMyvArAk0Xr7F3/CIhu3RhH3Ku7xd6RbaJNSfgxyzLtgMuDIDJC1TwORYmYzAnK5bFDL6 QhKFJafhq591CWGhyBi5Yn/m8+KswzJ2aDxYCATadm0nw/KSl9GnCTCHeQBfZVmk/InYz+K7UZEK ZG2T1oFmhSXdMlTyLcO5W6kQsg9L1xWTy196WRdBt4CuW2YWlrWwNHOsSWj4Hu2SewgpQVnnXNxG rbt4d7C5VIQqZzVnJSWHvhjobpkXTxoLJBowYflLvF+/Dth3ymOE0DO3x7lK5Nv2jitQJyc/Y1go 50KRsl9nTbesKTTYTNonV+yIqTL41f4tL7CGOYykW6CyPnOhdelEoTQrIwAjT3nB9FwxxTWTN1yS gAn8oRFDAiKEgXVJDt6DbldlYFmC38kJfXK3LkKda/mUYSG37AfTbEmBGwWYkULjwUKWY7f9/nn7 Qbxnb/8zR8f2VKFlctWgyuanR0xE3DJJ9KskqAt9NEf24ofBAGm/BniulZGLKiEvMBC+npegXDF1 2f49qIX9n+z53yz0v9+osIwMGgGWQ/aDIM3yqr39FmuXRdMkJ0EsEu6xyzG/r+ySRdwpsV9/QCsj aYRxQBKLemVWGAuBARDD1LyD+T1Th5EvQF32QsWVHzIwJPQfbVRYRgINA0Ow7AlgId1ylLXMDn4f SC/aUMVrm7D2qwMbtVs2bkha2ghMp7V4WFigO/mF/l3hprCzUGuWjxiYb9kV+8VMWWHlREEj6RZD E/bbsFCFspuyn1zNYqRsOBuY/ZQ+/TG9o1tZAgf0qUugNHoJj3VdrwA0z6Xj/zSJ/OXK3YKq2pia wv7Nnn8xzbTKBxvZFRsamoRuOSXCgukrfcwl68oVjEfYek6vTEWiUSiqHJkVUZ7vA5E7iE+DpVVT 5sVMGBYC5aaph4V/zUL/rwzMPTMDdWLrCk3EFXO6ZY/TLfomqtJVfjRGIwuOBGWiboExQKKB0gIi Vlkcm7ivBwSq4RRN9yTBQj0ttCWF629xuxpXpS8FlCGg4UQlAUHJScriUxj5N6baf1LQLZp2GQMY 0aEWmP9+ObolY9JRliVRQXGwREpgdD0jZPrbzyHtssz65AJbFadbqBlsqN3BCjRtWOg5lFOhKmRq Nf5Xe54xdc/L0310i2plMpU2pmYaD3FIVsP9WnmbcaVB0XQLqKUtHkiquA/eXQaGXCzKt/zIoFAI +X+NP2V/AyUnxwJNAAvtEPYyWxaC5k0Gpulv6TdSMnSK+lmIUVLSqkCGzm8DMGJI/ChYStwLekZ6 LIQa2v8/BwuFiikh+TnDQonKy2YKW40nDhoFFqpAdrqF3LPdbF1gdXlFRkNiChjs5UWN1tcDbTI+ pF+yz36twpYSYJJDKeSSfu+OFCzcm0+w0OQXmid2lmG5xa5Y0S0jsDRzLOhJ4JNFoQrkkwzLLt+6 iBds6KNlMB1Z62l1MJ+Vgf23rN3FtHIaD5bu7DBhIoxgmVRXrKkVW2ZYvmLL8hHDcsWHpViX0UFD lcaLDMu/mHqoxT62PHOZnk6UgkEKMdWnqNzxb+T9YjAwLQoomAFJ4Pr5W+WBYOmksHG2dWHdAnX0 i9yv/zR1Jv+bAst4oUH+497gK9N+dsd6r650YIDHY2AGdJHX8n8WwAcJ6nod7z5No2DGewxirlRY QmAGtS5NW9FDMC1X7H0GhkLI6z5lf9ahoSsRXan+YOrCPIq2/N7UDWPOPcu6XkOod0xz8fek9io4 0ppFzHht7LqI4IFTPwHSo41UGNI4+7uc+ZMu+8BijNJhqcEC1g2rRf4d08wT83XLTb4ArhRYxgsN mXhKbNFgt5/5/Mk0LcnPm7qZTIYnjEiFS04yKRg3RqIb5MPnFpofZAgW76D+GGb+vBTd8n9ypMDU I16X+KJGuoXyLJRzOVd0y9ocIF850embp+xtSl5SEpNyM2esy0FBAhGe/pUAeZu4dvtYdOsk9uWn 900aTOtgbNFnumMJ7SJYF3K3vmP36w/sjl0rsKwzNB44VQja3naDMI5ZaM7Y76lAk/I2R01dDTDX WZCRzsr2w5g14rVbIZ1fh5MNiBZWzngriIyITYn9TFjIA/Cz+R+Yuhr5eoFlQqCR4DE8RcbeR739 /5TSO4h61Guk4HgLE0doWpKhb5DGAHTNjOSGJWHhiJjnirnRrh+zS3aN9cxS0S3rq2m0CJDlBKk8 /C5rntv8gUX1DkB7oes6xNVTteFxCywsZ8FVXaON1kul55EnwkLUcnVyUDGXS4NJidpBXLfUs5Db rtj/sIXxYSnWZRItTR+9I8GjXa2HtTq9LYa3QZLuPmLUqkjuVi4oIAienq4Yfb1RXLEpsDSS5bGw VFE2e/s7e/s+WyAXon6VXTYq8NzmrwkMko1y2JinpYSjXH19AamIl3BFEIaBY8eyuCZ5DBa8XGem jmJORMKEm8iRyyW24te8qBgJ/a/571tK9qfR0gRWx80220J7YLKVoRq1fzD18HKaQLOd4QRZl0Ss UOiuDSFREONWSHwE4ttXaFUGWcWU7npRm7cl6suHOr/yJcNC+ZaLpj31pWiXabQ0gdWhD/yJBeah vU0f7h17+zu2OLfZZTvOkTdqYKv2lYGWLmnrHFXriIWVwSKPeVegD8fATsWzkd8vd/hFzCJBq4yN tqV4AHUEjCzLX1jof11gmVFLo1geApFaoY+autjzTc9doz0zySLRrOY5yLE8klum1rLJuy3nWhzI BETTKZARNUO3h0udzXetxp+xG0baxZXsF1g2AjQRl+0In2fYfTtimhaDXkI/GVjIsDra+/WacJmC pTtXAE0bFoLjnH3Ox9aiUjb/Ogt9a12w6JaNBI0CD3V4UsvBi2x5SPNQcnQvu2zzksaPJklzwElY HTWooP2RQCjOAZO0MvxOJPJ/Yp1yjt2wL2pLA7f4cbYuUFbmrGqaHnqHFsTP9vaPfDW9yV/duNq9 rHnmU3qjFXkLvmk/tUkGgRZZA+XSITxR0SWdX0yxLg/YktCOxrQz2OemVbKPpQq5WJqo5dlmb+9n F+2kafI7lO+hbtEtuRGuWMZec9dyfLCOjEp1NnetS+iKOd3yJwbHlb4sW1CwLMMCTQqcao9Ne3uB LcwRdtWoLOcdDhh0rE6sPycXHhjyr9PDukiuGH2lEn6ytg8LLMU96+OyVYk8Cw25JA/tV7oSf8dX 5JsM0JHQZeuEplG2DGGEbdCOzdymIejtihXrUizNaKwPBQue4UAB7b35Bn89oumdHJcNxvhXEmC5 z2BcLq5YgWatwCGXbavnsjl40npHAcgIlqfPXyW9F0hVVHnfNFuAf8XAFFesQLOu8PTSO5CavoSD g7I6G62uWnWzFAgUSkzSMAvK5H9bXLGiadZa8yzbNfnrIHonNossWuKfgESwLvT70dCKP7Nu+YK/ v8tBgCcFlmJppkrvDAFtzBWjxOM9tiJkUT6xv9d/sTvmkpMrBZYCzaS5bA4eyu28y/C4QYabxgCM K9knV8uFkOmkEUlUhXzB/l63ixtWoJlkeDbbr9vtAj9ob5/kKaA0X5o2k6Ihh5tz/0+QTnJW88TY LaQpLxQ6pnzLN6Yu31/dkoLdynIUTTNhdNcL8xG3Xbs2YNecRaOmaBqov5MB9IQktC73GZYP+HS7 Gv9cYCnQTJdp9OChmjb7lVynb1nr0HnChwfyaXEi3w3gu8yw/Lupm8Ju8mMrBZbink3t4bts9mvl srHeecMubNfDszMRKHAi/z67XAQgRcM+YZFPzWGVbimwlGPqoYnpHVO3IKT0DmXyKUx8gy3LWT7P m6b0pViXcky3ezYCveP+z8tsQUirUL6FEpQ0/YWGWtwrsJRjpqFR4KG8iaR39vHTyRWjcpf/MPVM sWvsotHPYYGlHNrx/wIMACknx87b8gF0AAAAAElFTkSuQmCC",
    transform: "matrix(0.9243 0 0 0.9243 2244.0547 770.1588)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cylinder_graph"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 2353.3601,
    y1: 2112.0759,
    x2: 2442.3401,
    y2: 2112.0759,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#DDE0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5386,
    style: {
      stopColor: "#F6F7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M2439.11,943.47c-2.16-1.25-4.98-1.87-7.81-1.87l0,0h-77.94v12.75h77.94c2.83,0,5.66-0.62,7.81-1.87 c2.16-1.25,3.23-2.88,3.23-4.51C2442.35,946.34,2441.27,944.71,2439.11,943.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 2405.3999,
    y1: 2129.1909,
    x2: 2494.3799,
    y2: 2129.1909,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#DDE0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5386,
    style: {
      stopColor: "#F6F7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M2491.15,926.35c-2.16-1.25-4.98-1.87-7.81-1.87l0,0h-77.94v12.76h77.94c2.83,0,5.66-0.62,7.81-1.87 c2.16-1.25,3.23-2.88,3.23-4.51S2493.3,927.6,2491.15,926.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 2393.71,
    y1: 2155.1973,
    x2: 2415.8,
    y2: 2155.1973,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A9D0"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M2393.71,872.47v58.39c0,1.63,1.08,3.26,3.23,4.51c4.31,2.49,11.31,2.49,15.62,0 c2.16-1.25,3.24-2.88,3.24-4.51v-58.39H2393.71z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2396.95,867.97c4.31-2.49,11.31-2.49,15.62,0c2.16,1.24,3.24,2.88,3.24,4.51s-1.08,3.26-3.24,4.51 c-4.31,2.49-11.31,2.49-15.62,0c-2.16-1.25-3.23-2.88-3.23-4.51S2394.79,869.21,2396.95,867.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 2379.9099,
    y1: 2092.626,
    x2: 2432.1699,
    y2: 2092.626,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#DDE0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5386,
    style: {
      stopColor: "#F6F7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M2428.94,962.92c-2.16-1.25-4.98-1.87-7.81-1.87l0,0h-41.22v12.75h41.22c2.83,0,5.65-0.62,7.81-1.87 c2.16-1.25,3.23-2.88,3.23-4.51C2432.18,965.79,2431.1,964.16,2428.94,962.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 2368.22,
    y1: 2105.0322,
    x2: 2390.3,
    y2: 2105.0322,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M2368.22,936.24v31.18c0,1.63,1.08,3.26,3.23,4.51c4.31,2.49,11.31,2.49,15.62,0 c2.16-1.25,3.23-2.88,3.23-4.51v-31.18H2368.22z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M2371.46,931.73c4.31-2.49,11.31-2.49,15.62,0c2.16,1.25,3.23,2.88,3.23,4.51s-1.08,3.27-3.23,4.51 c-4.31,2.49-11.31,2.49-15.62,0c-2.16-1.24-3.23-2.88-3.23-4.51C2368.22,934.61,2369.3,932.98,2371.46,931.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 2341.6799,
    y1: 2134.6072,
    x2: 2363.77,
    y2: 2134.6072,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABB7",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AABB7"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M2341.68,896.53v51.45c0,1.63,1.08,3.26,3.23,4.51c4.31,2.49,11.31,2.49,15.62,0 c2.16-1.25,3.24-2.88,3.24-4.51v-51.45H2341.68z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2344.91,892.02c4.31-2.49,11.31-2.49,15.62,0c2.16,1.25,3.24,2.88,3.24,4.51s-1.08,3.27-3.24,4.51 c-4.31,2.49-11.31,2.49-15.62,0c-2.16-1.24-3.23-2.88-3.23-4.51S2342.76,893.27,2344.91,892.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 2327.8701,
    y1: 2075.5159,
    x2: 2416.8501,
    y2: 2075.5159,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#DDE0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5386,
    style: {
      stopColor: "#F6F7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7195,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M2413.62,980.03c-2.16-1.24-4.98-1.87-7.81-1.87l0,0h-77.94v12.75h77.94c2.83,0,5.65-0.62,7.81-1.87 c2.16-1.25,3.23-2.88,3.23-4.51C2416.86,982.91,2415.78,981.28,2413.62,980.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 2316.1899,
    y1: 2095.9722,
    x2: 2338.27,
    y2: 2095.9722,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A9D0"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M2316.19,937.24v47.3c0,1.63,1.08,3.26,3.23,4.51c4.31,2.49,11.31,2.49,15.62,0 c2.16-1.25,3.23-2.88,3.23-4.51v-47.3H2316.19z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2319.42,932.73c4.31-2.49,11.31-2.49,15.62,0c2.16,1.24,3.23,2.88,3.23,4.51s-1.08,3.26-3.23,4.51 c-4.31,2.49-11.31,2.49-15.62,0c-2.16-1.25-3.23-2.88-3.23-4.51S2317.27,933.97,2319.42,932.73z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Man_with_block"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 248,
    height: 146,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPcAAACSCAYAAACZtVy6AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAALe1JREFUeNrsXWnPHMdx7nr5khR1 2RRl2bplSY5kS74SwzZiJzKCwHBiIB8CA/kSID8gfyJ/If8jAQI4CQLESAwnThzH8anDukydlCVZ lHVQIilyK1U71TN9VHX37O579xDNvWZ3552dp+t5qqqrnOtb3/rWt771rW9961vf+ta3vvWtb33r W9/61re+9e2ob9BPQd/8hoh8PRyjcT2Nj9I4LY/fo/EqjTdpXKKxAOiXTgd33w4SsLdp3ELjqzT+ nMbv07iBxlka36Hx7zQepfF6B3kHd98OjrVmEN9D40s0vkHjizQ+IoBHsd5Pd5B3cPftYACbQX1j AdTZWzrIO7j7tv+BfZxu7qTx9QZQWyD/JX3Ot+n2n2g8SeMCA3xra6uf4H2wbfdTcCSBzehjh9lf 0Phrub894/1sFK6l8aCbHHCjFV8sFpc6yLvl7tvuA/sk3dxK42t0/6/c4DxbZ5KvUvUO8g7uvu0s qE/QuJk08cN0+0166k9ofHyD7K2DvIO7b3sE6k/RLWvrP6VxH40TFkIheTzzQhn1OI2ux7vm7ttO AZtufofGt+j+t+j2ExaoRyDjBOjQBGA7wLse75a7b/vFWofAbrlaoPAZ0Kl6B3ff9i+ocZ0LBdR9 O8g7uPu2LgUX+l2l4CYNr1jvMEelqMfLIO96vIO7bwJcfwu8SZya/SUn6eGH6fHddP/TNP6Axpdp 3B76U0qUG3FzVxG0A5yt9Us0/pfGf9P4GY3naLxB4yID3R9xB3wH96HbFouFEyD734mvcnZQXUPj JjfEqu8TUP8ejYdo3Cz7lCn3GoBG7QKqaPHlC5gBnp/5wA2rzX5O4/synqLxFo0rAvKF/+oO9A7u Q2Gp2ToTtrfodlvo9Sk3LO7glNHP0vhdAfQ9ND5UA7VKw2e4wCcTD0Wqnu2CugUP3uMt+VnR4t8V qv6m0PWLMglc7dS9g/vAW2u20qyh6e61dMvAPSOWmun3p8RSs6a+USy6aZlDIGP6RGRQwbDS2H4R KYtGoETdYyvOAP+1WPEf0/iVUHd+jh1v7wrIF92Kd3AfRArON3zVMqjPiHZmy3y/gJkzyu4QsJ8i YwombUZNV2MOVbSvBv8+WOHqgQS9YOnw+PFCQPyyaPBnaTxB4xfy+C2ZBK50kHdwHzQKvrTW9PRH 6T5b6M/Q+KRo69uEfp8IQR1aY1SoNFZEM27qooF8ogAN3AbAE03OFPw9sdiswX9A46c0npfn3ukg r289Q20PQe0mRxlr6utosOf7VgI4Z3ex1/tzYqmLoI4frw5oy3MOUHm/9j50GtqHe6HuD4ANk3w4 Rt/J/oVrRXrcKJMbW/FnhK57kLMmv0Lsp+vxbrn3ja72wA4p+L1uSBd9SLT1HRr9toCNgbcMmycZ G6hoS+n6RQX6c6AIcDAmErkfWvHnxZL/UkD+gmjyt7se7+DeNxRcrHWRgtPuJ9LfKKPh3lorySi4 CrhbBXkDoLN3QgBeDMFd0eY5Vfcg5yw3dsCd7Xq80/K9BLWvVeZB/WE3eMAzCu5BXQtpZaBGnTJj AbjtcW8s0HWIPkej8ZAcCwQvMOMAhHiBCu8LJlXnijF3y2DWczrR452qd3Dvqrb29cpuEl398ZSC 066nUlBHlFuzuE2AxgYrXYGzIp+n0DdOFtj6Hhiez0Jj/u8UIc6KRQW4/1wgkLuiHo+oOgP8qFrx Tst3TFujt2JLYBOgrxMr/YCA+kG6kO+j52+zrHWqpbFmjQugNi10QoeL3nfrooH6xQQJb/fWPdLY LqHq4et6CK1T9W65d91SO3GC+RzwUwTk2+i1R9xQiHCpqyVBZfSCo2WtA9CGFtsmzRhZTzSSWtT3 o0KnqwRdATvGwMZg1hgeg/o+CKk6032cnscQ5INVD614japf8lT9qIC8g3tnKLgH9TX03A0E7FvE afbHbkgdHUA9ilUD2AaoUQGw5SxDbKDbaNVfqQAZwN4JNfoePtaddZg+GoENOcin87Osu06H00Nn nZbvGAWPQO2G7h2cC84ZZuwN/zpd2B9b0u/Cgo45wFbBq9FqxLL1bXeMGy+DfRfaVoz5mucAyoKU kmc9pvk9dNbBvTlQB9b6BF1cbDU+RuBmUH9CNDbf3kP4up3ecdKhFqu2dTWiTrkRCzq5BuYZDjYw rpb0/VaOeQhWqADcg1wDt56nDtNrwT4GyA09Dgv+aw4byDst35yuvoaeOU1a8h66fdgNHnAG9l3I SzHRXUf7H5/AiGaxhBzgBQ2N8XHVwtY4E9jhxACF944yG7QdxAPuvd+Qh8Zc5BVHEebjTR5GG98X 8PT4YEKqXtHjeCmg6tjB3XV1CGpPweniQY5XL1dtIT/HoB72g5qeRoUra0C2LDUWwOst26TD51zD YB6f7m7XpwcUWu2xC4kjDSMHnK4TvHPOgx6SWDkmujwBeVWPE74/OCxUvdPyzepqDnV9ii4+9oaf RifhLUxWZmmALWSa6eDG2B+mhMc0EK9brME1aGeXhrGM/SFYXAI6o4/mDh9OS8NomiYH/fta9Phb osfxoFvxDu75FNzU1bTPXXR7M91yTHsbPbD536LmzMIsHp3fj7PKULGmIaDNtd2zTsBcYFdAD7kj bNLLYAI8mhAACuAeXoCCXi/Ex7ncE68j/y2Ny4MeP7hWvNPy+RQ809UjqN1SV297kYmBDh6sd1j+ QOGxiZXOAG2AOgI06la6OSHF2bHw7E2F10FNtMmptif2gx7HSbJHk0ASKuOZFiaa7wX/8ibT/JAf lx0f5/JVNwjA3xCqzlluVw8iwDu4CxTc0NX3eF2Ng9Xm5yZQjzQ5ALWbtC5ie4UT1emWgEYDtq7J g++NJgAlrmRx9wjUkC3hngd6VEEee+cSBx1bZH8+R72Nk5ZXJyu9PJTsO/QlJz0Ogxa/QcDOFvxp oeoM8gsHMfml03Id1CUK/klNV7sRuBhp4JCW8+ej6phKkJWCBHVPeDlWngK8MYVVOyqoXDjBjlDY 0S6BHDvMrDh3GGpLNXWsw0u6HOLPm26vwlCzjXX3k0LTfyqanKn7+86nsbLj5QD0Ie+W280LbdGe IwUndGxjYK2Dz5ksbkTLY0o9WV3MvUej0bKtchHYmYVWQI3zU0mjp6DA4xutPESLYiYtHXvCpzCa E1qOmiUfPzvYObbUzn8bCGsJ9hoW9gxWnOk5/863CzP7noD+XfrOy4MdwMV+B/h2B/aKoS0crr3I y42hXhZLGVlwwzuegmO0MFixyHZuaXFtd6bbjcqm4NTqpWn1VCjodQB/pPk60HzekL9oMVnflKqr 8fQxGB4J84zucz47QNkHsLwGwJ0RTc7Lcrlc9Adiwc+5oSrre/Rhl/Y7VT+y4K7o6mpoy4UUPLHM LrHWy+/DHMixDs89YRBldgSX/1zra+h0rNRL8oCEZOml9q76a1h/n3jEFgJOX64m1NOWrvZLRUsn A1ifC8DHWDkGE8XEBPiZk/T/7TDUib8slpzp+lna92XR4kuqLiDfdw0U4AiDuj20pVDw1GGWUvDI W44TbTctvOWhjsI+GJUobgE4or4OfE7jv+RQEkBC/WIqTAyg6fJAG/uCVGqcO6T3lZTUqiaHIIwW v4919m9ovOK4GivAE3QSfyFAH6j6AP6xgcJ+AfmRAXdJV9NpuEcNbYXZZZh9TgTQzImGinUOssgQ W3PJMwypFhnR8MEnhGAT7YMALIdaekFBFeDWApHUkRYtKgkdeKCfnxSsLZOE+p7hdiEA/i09eIFO Iuen/yij6gHI9wPAt48QsKu6mnZbhrZSUGfAHi21BWzMqDoucAJ4kS6XLW7kdJpplVH53FXsQJY+ qswloMwsqIE81csWtUe//BMCgAfOsVF+Q/GIRu0eUnQXVoQJ/HE4AnxruGaGsKcbwmY3C1V/yg0L UV4JQL4v9PihttytKaPIFpt0NbKuxjRlNKHSNQoeAT+w0Ji83gDqEljH+qmlpJWw1PEG6pWHl02W 3gkNFxfYlU5TYNoVWnLqnFPwfOno+HxovSUMB2mKa5IWm7CDyYp7qj5QdA/ySI/vJVU/7OAu6upl EgoOq7bGlNGxKgrmTjKEEYAasEuONeet9wqAxiLCA4yndctxPRqOLReOSqkhsd71ziNxSWNo0OTx 0lAoANyi6XMA7tpA7rujqHp8eby7GD6Dwwnqhf+ZeYnlqVRXIzvMMFiKGVFwjMNWppVWwBtMCiEV HRnAIq5xUgaybn0LZdDmedA3gfD0CoLsYfJ8vqgjDaeZIDcBHoAwBHium/MJwek6PH/dXDOegpwz 2lQ9DhIf9yDv4F5RX0v/ak5K4DgllwsmYLtYVwcpo6rzK/N0h58f6+4Rfmn8OAU/6lbaArVWQ63s WbcdcvNRu8JlFOvUQjUVHejl5gR2cUUN4OoCEyjTem3/9H2poy8B+QWh5Qzsx0M9Tp+9BDkOa8cX /OPuNFU/NOD21tr33BLHB8epvyDWetTVdHsCA0ut0uksJ7y8X+xB1wsblrLNTFpdu99QS213eSDk F/8ckKdAz0APdYAHtHsTAAeLfZSteKTH6XPP0i816HHcHT0OhwXUMo7RSTwVtOd5hK77R+hkfjyk 4JquLmnpmuX2lUOy5JCEHi8Qm+m3SbMVYKNhxXfyx8WKQzrK/9bAmBl90I9b1bz6ks+QRk/g3izA x2O114yrIKfPfIJ+rV/Qudo1PX6gQ2EJBWd9zUv4uAAhL+74DL38h3TdPUwn9IZUV0dWOFlPnWag afu4IKc5tOIWLcYZwLY96YpeRxtwuAMzeEnzZ7ntig0xV39p+ahB7nhI+RElIy2syOKSHPTg/HDY KwRsNe02WD8K8llhaCys+uJcnMEnGW9bMIXOfGeZu+T2JkuP09+1UT1+IMHtrTUmHTL55NHJHdvz 0Ov30uOhQT3mDi+Vcrs4wSRLFzXAn9Pyyc2Fpiccq0ks1QouCuqs3n6wYXCrKzyhZNpnHAXIAhFv Xf0iEgvgGOp0yWXHtGZ6vjAFYVqIskxzjZabTqiF8PudrD2XWScs7RROBjA3Po54CRfLGA9uwfpU HQ4ImEE6Yy6ttGjqkzjU/x4a1OOyMf19MtiBdoZ+iJOLNFXU0NWukJCixq6dDmrdMZaCEgsgzp10 6meZFrtUcxyKvjAdydg2UQBULyyte4jmEc891hUPt/KaFcoCmJV6GtN8xXeg+Q3Sv9OrNjcsQHnP DXFwttzPiS7n4hDPC9C5zNP7bqoEs3LRxn0PbqbdNI4lFvqMeLzvpFPmSwffgcOsyEkqXD74GJ/U hULBLcBmWloBu11aOKHVWQ54eemmSrlTqz4X0C3tfKvgbr9ywHCwaaGx0VGSAEEPVZkJJRPdbgC4 ptkjgCufFYXQDI0f6nDNm55MXnxWucwTe8250guXeuIijVwcgmu5vUjjVTfks7NFlxrrgFtbcDjA HVjrk5JVxsDlqpXLkjiS/32nhLq4eoaPV2/5U8gZaoskDJWuqy7FtUfcKCGt0CtugxpNDZ1bYFS6 jlggLfThLjyPmwA3NFxIUAM9lMHdDNIWgFvx7iR8Vvis1kIQkDAYqDk3wS1gsNDvCsjPCdCfF8r+ 9HC7DKNdHqw44IEFtwe1WOuT4oDwHTHvJwDcK6BeOitwcKKdgKh0cADukIKnQOf7XCFFSxVNHGFW uAsLllp1etWAis6oZ76CdcaGZgSw2oXQXKWlBPa0ogqLVCiBtQHglRBZMVW1ZbJwesKLQlTqfcen x1cFvO+Lh/1VATdXgvkx7cH0/Tz9chcCqn5wHGohqGkwqK8X+s3A/jyNT9NFyVr6o27Q2qdcYKnR sJghYKP9XOLZxYLlNkBd+t78vWiA29DoOwJmLPu6GuCctQfTqrQYzme/w+SvShxmLqld7uI13GNz QOciZ1noYFPeNDq80ue1DioALvbOKftjsPAk/+ODGvG1vuPTb8a9x68RY8bS87Rc+zcOOMCbRZe/ LJr8YksDhX1huQNdHYL6NnGMfZJOJvfZuleseAxqhQqPBRIWinfcKQ422WcR3K9Z6xzg9mumTs8A uzm6jQr61qlZDlAHfEVyZ8+nTjWIKLJOz1PL2ppeWqTnrXFwp2fOmY42mGHBp+f4F2LCeVF093NC zzlv/XGh7C+LY44tvpnpBvvBWge6+iMBqO+XCih3i67+sDjVtpwRWtIqo/iVYaUqKRq4Wyz2WsBW aPfa+tkAterAqwC91lBABXnliirWGQ+oeS3XOwJxK8Bn0POVAF5NudUbGBaSdnwijHe6MagfE5D/ UDzrF1yhoeH2XoI6oOCRruZwljjMPAW/Vo4VWoGt62JUvdRRgb1l7BQ3BOzcUqfU28TXBiy1BeIW C5623TW/G5xa600FfFLw0FwQDgn1hTAm7Ur1lnaCVg7SIUxUcZWyUurfOX2A1jA5OsdTjPykXPfX uqme2+2y++NJ6OyDdA35roPbU3BLV4vVVnW1BWrNCZUWJkxDVVgId8V9tdYBdsmbju2ruLCmsdF2 mDkjrNb8g1W8602Ah0hDO+vCrhzGnPdmr/mmB0E/sRCpWTKMVjeuRa8Xj1X50HAiyAEOcv2HoeDT Yqk/4qY2SK+lIGc9vmu0vELBR11Ne9xE9+eBWgU2jp7wOcBW9bh/7waBbYW82kDe1v9rVatd89BA 4/NqOSRVkzq1HFLaYsgqhzRv8QfMqqtWlwA6S1llsYx1boPnvBbncNmL4mR7VsYL4mV/U+j6Vdgt UBdCW2VdrTjMrHBRus/oUFsR2KMel5DZrgIbFY9+i3VG22K3GWdswDjYF6SqTUHRqbpjLU0sKU0M YBU6LBZBhOJabjMEZjnqUoBbf2f0npXB7QHuE2DeEOfaWbHivrEhA/+97d0AdWNoK9fVjcBGbeEF hos6nG2NFWA7Zemmv6mFu4qa2wK2s1NU59Dt2vOzQFycDIKFFS6pjZaFjPx5CQCuNBvYS88uajXV LNq/qtbf3B/o89WPJ5GluwVL7EHnWPnF7Z05WaquHik4DTO0lVqgZmArYEoXgGhVUlyhokrkjFOc XBsDdkNTv1UsNLab6+ZdrD4eLlkZVdefdX2tLwpJp5m8hZGmn6eYt6K7VwFp5b2z/QjzjiXU4seF EZ8Si/6kGMqtjYI71NVuaqo2hracmyg4nXiTgmeg1uhtBVS5xbZytpPFHgm4Srnm1XCXs62zSr8b FpW0WWdcG8Sbm+knb3FovdPlmnM+SgOFPQHMN7awcWO7gYPSPyHMbHtXqPpFeR43Bm5ZW+2t9Zk0 tOXcFNqiXU0KPsdpVrKWUagLsRxjTr8fdWDrlrshjo316ipZX21rclAtNjahdDcKtqRWN6XnLRzc dF5loIPsyRLIN0KlK57y2okZveZad9O63g4/jUHNi0o40eWc6O7HxLn2zkbAHdQEPybW+mMC5iy0 pXnBW4GdVzep0+Bs/bai4dOyxYhohqA0C59WQsFdQhFajf52cAP7TkHLlrGxa1q7YV7RlqQ2Ad5w LGqnCpIvANfwnfHp8x7z827KXntaQP2ceNLZW77YXhPYY+lgun9KrPRDAupRV1ugngvszFJmYEvW aqPmSXfFQguZ9VesdvaeErCxrSaaqzb9c21pqnNM7AzLBbXrvLIAxbJVO5WLkhZzaC07BdpjaGxN XDkHkPOOOTMcg9qvB+cyTRwG44UlvxBQvyqOtPdlv9Usd2Ctl9kz9Pi0WOyvuKEgIYNcDW1ZenG2 48wAtrWKS80/t4otRI40rSpLI3awtdjhTGDXAAt1EM9sE7a73usZDrXQoafmsTcsUQVo/ItzFdD2 XkiADcYkUtbWDFqOYb8igOaQ18/FYr8ZgHrMUtteEdRLLx09Zk/4rULDuWDCI26oOHrGKaEtzbqh YiFx1jHZE4O1T16AIa+iso7p2zlgt58T59TW2itLzVXMDaiWH5q/3+oDVjSfWnEF0HW69rk7HumC em55cNdr67fEMvtY9v+JtX5ZgH3ZKfnl2yuC+pRY5dsEzJ8R5xkX/b9Z3PNbGd3VgN1QnxuNLCtU wj4hU1YtLZp/X+xQC3X7ulqvpOGdTe2xuFN9ylnruNc03VoyR5rMshP+AKgclJVFl00kkL9Hn3Ra F8TDHGCz3vULR84LBedc8p+5qWJLSMHV9d3bDcBOdTWD+hbxfrPF5s6YnxSgnxEa7lRgu3WAjZnG Da1khuyMXrdd+KXSRs1ADum9BWxrjTdWGE5lcmii6jMxrTnSWpxHJWADNNBylyfGFO1ssiTUac67 JPV07kxmpp06xbOvrAirWHBMtPWbAmy21D92Qwz7VbHk5mqwKrgLuppB7YsR8q2vinJdFdi4PrDn WaOku0ehA4g2cWxaR84C9sZd3LvnSa+mnzZOJlA1y8paasvzDaUqLnUW0LJmHVqXeubA9pb6ioDa V2Nh6v1YAOzXxFN+xTV0EN1eQVezs+wesdRMwfn1azQaXgL2uijBOWp45pdi85OrOCPLwN7tDTbw AWDcL1nP1JKaPYHN7wR9YQbArL8trb5aKvBQoislYFeOg4Edgpo94X5RyFNCwTmG/RsBdnPv7+0G Cp7q6juEfntQ8yQALSmR2IDSYuHAlnJEVrF+NMJYOptfyzK3TAhzgK0lqrS4E2CHkA01YEfWD6or peac5Lygoqu27m0Jg6X10DRgNyXX1Modxz/Xgp5nes3ZZefE8/2MDLbaHLPmQg3vuLFAYns98+0E 2BoFT3X1DSGoZ1/1uHnruJeWb19sWMDqhmm52vYHLN0JbUsgodGDHtYRt+h4ekyVZZ7aKYIqsMHU 2A3A9rr6Cj3vrTUDmyus/FwcZi+JpWZQc7741VVql28HwF5mmNH924R+ewqe6upihlnNMx56tutW CKuVTGbaUjU8BHswN0DUvcKp/cGarfYOe6AzT/MmgR18F5SOICmVNL6n1Kvbta3fjllAHdjF0sZ1 YC8pOD0fUvCnxRvu2wy9Te9cgnqw1qv9wNvBWWRrzGminF32BbHWdyq6GuZaTWx+tD4txjUvZlzp xaSw5rIsD8ZtZqK3B2UycecnF1hrEoKiV3xtYGsNAxPrDAUnVhHY0FaYQSv+kAPboPxtwA694O/S 8ykFPysgf00o+hWuILBu989tcaDxp5wS68yW+gGh4zdb1nqnPcoHm5LbeWRhI7qoLVVoyXfZIVaj 34ajesdmIHB2YQS1W4k1Ka0I7DyubWv5kkc80dXv7yQFtyy3Z0RbcjB8IBdkBmGLfTzYB2YaNGWf 9ezUnHdHIIK4AyQkdbPmUgN0hVssH/hKZwBXxBXM2xFK+eQFxxRUPGstVjuk37k3PZlwUu84OLVJ wMrAhnZgR950WfY1hrYGXe0zzAwK7gIKvjkbuu2mgiUX5QAel8c8y9zrppAXF0g/YcqjFiSWaGgl w6QJECtx8+SgIG8Du65FCjtA4vgdMJQaCC25osNDuocr8xtowzu0LwYBaJgcWoEdWFhw9W4j2neC Vn5JAfac0sVzgS2vjbqaMQSTrj5rU/DNgnoE97ByBq+6abUJzyJcm+l5oeb3i3ONiyzclHjKmxsX VbEScVQ31u4Zyt8YgAm0bd5pAtZ2qg0tXTEGez4XRF8ZHVf177Vnu/AiipLMEMw5cFWmDNBgnUF3 eJmNB0pthjTnHKRNCQxg15ZtjjOFUv+8patnBnD95CrAjnQ1W2V6PQ1tndspCm461IZSZ3hFDuqS UIVX3dSUzKe83eOG6ipM17kowzExQqC2lSlcz+tw8tJHRGmLMG8l1044snDmc+EFFraJThGSVSNZ SVeXAd1inUuOLvU5o2VveqBFYINR6gDAbmxgADs6hqTaqnWcEAtzT8EjXU37arr6XcLaSMEBdjZ9 cDtwQCyXlhHIlwdKt14r8EGdF2v+gFB1zljziSwngT9nMFaNYB5mg9CbbDmYSlBWjb3x4lA3C1Xr u6qmr3nMQ9E//p2h9k4oeegnUJwzUZgspc+z8D2TbtfaAlkTRr5vqQ2QTq/VaqOaJ984uLnAVqWE nv02OMsmCt6kqxlfO0HBi+AugPyim9aSvihU/V7xqkd6nP72LcRW7a0APAF7K6eMwk4b0sp14E+S IXLKJTPUSM8Nh5qchegzrYiABRycoY+gtoChYqFXAnoDsLOYtgVso6tnxmAg/7vnAnuSC1myy1JX B0kov6b7e6KrV/alBmEyzjH3LU04c+1OAXiqxzlstlWrqY2JGbJa12JDCup0H9WiiIuxc6e9X/C3 Ki15jZLJybGl+2THZf5ttnMQCx7GtUOAM0G9LrBtkMYWFpIwVguwIW1uAFODv62gNXATsAs9yVyg q+npfaGrZ1nuxIrzzYIu/Mt0/wrdvi/0w3sAUz1+twD8WFQCVvMfhU4zF1vetApHOgNrHuU0cWTQ 23UzXrLQakJK9PnWewzrbVlQLfMsKTCQ9gJr9V+of98MLV2k2dXnoZjjnWWKBWGulYHtKtluleYF aiMCD2qQ7DIfrzZ09U6FtjZquQ1L7ruH+N5Ffm03W/Mvu2GByV1C1Y+nlly34GXrlpZY0ix4to4a 45FbWDQXk2T9wTLLvdp70VgyN6fXdvxaq9K2K5ADbIZua4AvhbEyClztwlmYLALrG1rtOEyWvq5o 8oCGw+Qs41j1ebHIz9PjF3EwbC/K43NuKpxw1VXWWO9bcCsg3xKQc3YbLyjhxSVfpPFZ0ea3ej1O b9lqAnhj4f85AE/fj6jUW2vsx12s9ZZUZs1eQwOStWWsuHNJeNBgkVvArANbTyFNnVVpEUKAirVu AHbeEhjicJvqbIu87WypL8Cgm7kQ4aNuyCxbWmgc2Oq7EFjppYbdB6BeC9wGyI+J7mZ6zktDH5Th HW830u5jsURsWFTS3NljBrhDkI7FGszvMhoBBt/T2pPbnKAMoNfAvqlfspVeq19h5lnbrKDWFG8O sEcggwLyxArHQNaBLZ/DSuwyDOBlPc3FCL8v918SCeoLJlz1v8Z+AvVGwB2CXIB+QsJjN4nVvlfC Zw+KJb8duS8Yymo0zXJhGeBmL+6CEyx9bxHgBUdbbsXLJZh1cDul80llMU0F8JsKl1rebVO6Gt04 Leo9EuvWBSgWsANQRyC3rHVCz7NY+DQBoDjKGMRc+YTLG/1MLLbvnlktb3SowB2APNTjTNVPByDn 4olfELCfDq24pmszL7qie1uaEmge7FSDj+DGgrdc9aSXu47WPP4q0FsB79rXQlfd8q5snW09bXvB swkg1d3FZaNWCmoC7FA3V4GdO84CYDOor7phxRZZaPgBPcXAflyAfj4A9WK/g7rJWz5fvwEuFour Qlt8DyNfa/mcnCT2KN5PJ3Gg6jwR4BCpiGPVhTi4JKU4IyacpqZCMoGAeNIhTPo2Q07SyRIxaypn t4Js9Vu7PKEmSVXT6htudiWYluNa6LWtAM+m3bmVtookgpK5ltNwMB1i2nrsjIYnzju21HTDfax5 fTVflxyf/hGN/6JXn6Sr5zWx1lf2o6beVcvtt8ViEQQ1nHe6fUhCZZ8Qx5uqx2dZcNfeYbNVH0d0 G3Vvd7WLp+EIi7ugYLsV38kfq3J1ZNlgkJcVskBdo91FUCcru1RLvDoN5zn/6jIJhUANQ+N6Dmc9 NoS24Fl67g26DryzDA8SqHfleglBTtu2FFu09TguJ4DtTTcFxGIiCpb1dEWDq97/5Mm4oaAe0qp1 9QTYowsEKs6xEvVupN8asCNQuzRNFZppeKbTBzL2Pt2+Tg+fc0MRQtbUnITCeRucw/E27XmZf5W9 SkDZ9+AOQQ7D6pRZehwNgGcaXfOGGwBv9W5HGW0FHV4Gd2zZF6hbdURbWe/FwpeovlhhIcgmrXUW HlMcZpq3PKXhBboeWuuXYAhv/UQcZy+IXHxbJCVRdVjAFriDvG3vxpcIpZmtx53vMxYu8xKaHmaz xcvAXKbF0V98IQIDvYxa8YZw+aa34ulzUd9YF3+25gMI2Ueyztuaa71fAHdx3i41D6ha61UoeGBd h+sFVMsdVT8OU0k1TT558QdnGSwzy35D918Q+v0/cvuqSwomLD0+BxzYeyLj1tLjqbVVvehOzSIL E0nMUsda04LUUqudQ2LKbtH2tB/Z3LZku2XEw8QS7UDmeL+zOuKF2LcH51YD9U6/Q3GYDc4yATXd fwEGXf2EWGum4ewwe8/ts8yyAwvutfW40UoIK0kvanZZwWEWJ65UFn9gHLO2wV9wvrlCsmiB8m/u CgCj2kjF2T/X+12i9LLQg/GlJaFo9ckzPT7sxNaameFSV0Osq9lycy1wn4xy6EC95+BeRY8TJk47 l2e5hQAsaeoMsAUHm5qVloG73A4pBfpiRlfBvA9YvkasRY/XGxMkpYRMhxmUjrCJdseaOS1RPFHq Cdyp7s71dEjnJUDaoquZgu/JMsxDp7k3pcfpR7s/pOp+/fgYt5aAca6hJYEBtUXR6WKOUMjXqpJC ZloRjHa1Pk6u5GxjU804yF5TS1DNmtmhkEIaa9sctFD16pdADcGToTNsabmVkJYrpJaKA2QZr3Yz dPVhBva+sNwr6nGVqqMWFzfCXqFXPaTpHqpaj29z7XklVOfCfdRTb4PUWreNa+hxtRaZpZOLnTlB P0jL8mtVVpTw1RYooS+7WukytLWk4C4KbT1Jzz9Drx5qXX1gwD1Dj2ehMxSverkgQwwmPRwGUf65 M7U25vHrhs6lJR6OxgtzgF+y5GZXS6NFjm2J47CUHcoDfX10mmgCufVuKEO8pOBuyC7jFNGAggNZ bnyd9nmLDuniUQP1vqHlFaru66j7+GNb6KxSCQ2xYIXcdMUCBKBVwm5TvQkMykPpdB9KarWUwoqF cp+IajkhrcBFapFta2x5tcH2dkPNVmiebyvRJKDgyXuSPHCfMlqi4IdeVx84cDfocc735TI2L3mq Dhw6C0GOsOVCnR3FtqGh8Bg0u6bHqDcE4S7jQsdRIroonzvDNxawPcbHldaRXttrFNspmt9ct20A WtHniS3XBQTYmWdWtdJkvXaaB+5TRo9MaOtQ0PIVqXoWOkOevCq10GLPepIummraNISlpZS6Scdj 2qVEa+5n361r6grdb28YD+pakhKgrXTTrNhh0mumtrgjBvz43BDagkxXG6EtwK1DkIRyZMAdgnxG 6OwM+nZIkdML1Hh025JROwU2vx9Y8TCN1UAybgDwVhdN65fX0kYtS15LXgkB2uLMMzPQdGud6Oqj F9o6VLR8JlXXQmefp9s76BI5ThfJVlrAHgIHmF9yOunVWqjM2WmniS4fnlL69KZpqmEBclBofPDZ 6PTSRTBzvg6TQ1Qgh0enOdo0K6yZ/eAP0CaDZBWXtmrryIe2Dj24A5B7hxsW9DinHn6ZLpBbaKdr AZfNE7a8FA/dvWFV07xxYdFORkS71CiPj1aryz6+z/wAUCaElO7OJGFaj2wlWy1S1EYXjlJHTlBE fqHqytJSb0EUr+66+qiBO7HiI8ilBPMloWy+Bxo73O6mC4dbIZ3iYo1SyyEoXxw42NKGgBqQQ487 eqqKg10aCzDE1H/LB2bTZaOoi6QS6KGJexsazOr7BWXNDlKtQq3C0lhyKZQCkxWfrPVSV8NSUx/J lNEjrbln6vHbxcnGzrbPuaHsMj93PeLUc3yVpaWl9ddWgklajDFNsMk+oyFmrX2/vf+8pgNZXNvI O7fa5ObvMb3vy5AnsLQC9yO6/W7X1Ufccjfo8ZfFcr8iMz9r8U/RuJsuOm6DdC2DHEBquVWWlo7W OklRdYljDhI2HUbctNAWjA0UUktu9EhL0FlKQwWl8HixRrnibJuov+1w0wr8Z76AfHLwxf6XxRPE Un+HXvkevdR1dbfcthUXy3ycwMDNEz5KlpO96b7sMt9yWutI1Uc4lTLOFE91rTqLv4tJ7E3zgmPB EhdldWO543IpY68njMIIFd1cBbULSsPBEqyXpIQwF/jnYoRclPAHtBdRcey6uoO7TtPdUFOd+4p/ iIDIYL5LwB1T9SEurlB1zACrLevUQB5R+2J4C8sUGypAXvFXTnph5c62DJjlTiVpxVMl5ZVdHB+I fman57MC7EdFZxPQ4S0mYB3UnZYXaToOiPNtVtmj/o7ouHMZVeeOpaBR9ULmFToz5BN151Sqs0Sf BFPKa9UoQxuOsfa2MP1TA3biSLPCYcVyS4G1BrHWbmgHzUD+iYD6GZFQ5+V3utpB3cHd4EgCb1V9 g/SrSzoIwBfRBXrel7Rlqs4rz+5U9bgGI8XDnr8eOOAgBnvemldJJ3VYb8+rZZk5O4gXec3BKmOc pq1CDmSwXw+rWLllo/klqN8S/8czAuyfyLl/I5h8Fz27rNPy2RvGGSoaVef14g+kely0O4x6WC3g UOiS4oLOJoYmdzU53UDXYeYvnzUNMOYYKFL2Yrkl7wX3FPxXbvCCc1P6p0Vr/3ZymoG05ung7uBe H+QMWs5TZ5DfKGC+U9Pjbii5vOWs/uAFkIdlnOb21W4qrQSr/6ilhSWZdVbot6bNJWatUfDHRWP7 LMKwPY/rVLzT8h2j6m4Ivbyu6XEaN9O7rqULdxtxXHIcM3PfCcWhskTUV4upoS8usgirINb8u4us Xn0MStO+XJNHzjIPao2CPydgvxCc9+406+DeGZCzw41ulyEXuntFLsz35ALM9PgS5EAgdwbIYWpB NKwDl9x1LISyUE93bdu/BdBl69ziIMu0enJECqjPjhQcYKDgiAEF37/dMTstP6RUHYdskmME+GY9 jhhkfKux7nJLJMNwm56xecBus9YxuKG6hjtx/oehLa+rn5L7rywZEMBgrQe21EHdwb37m8TG5+tx zDuWqgA3QNpWJLGJzeeOrwZrPYJas8xGaMvVdfVvIwoOgFvQL7lOy/do8xZlth5PqDomYa94ZRfG K0SxoodbgD2jDai6asuukJQCOwR1s65entsO7A7u/azHk/j4M6LF7xOQ30Jvu4ELRAAOi8B0Axto ck1bY52pz50BrEormpV2aIKaz4VfO/+y0O5ngpGEtrqu7rT84Ot1Po9subme25/R428K6K9zQVti k7abSEa9cgus8WMDmGDXQC6788TG66i/T+Pv5ZYXdlw5yF0wu+XuW4uVZyPPFp1XNV2hx+/S46/R /YdYqxM+rkmjWhFtT0AVes4h1Ougru9qRnYV0IkGd0OVUZYj3NqWq6D8C40fiizpwO6W+8hacbbc Xw9Afgtp62tq0nklWj7nRwW72EvwfAd1B3ffZlJ1Lt54IgMutgN9E78y2MDuoO60vG8zqfpVevwB PeZSzBwz34p1sNmRx+EqSz1b881ja911dQd33+YA3A2e9Z/T4PAQx8u/IQC/PgR5k9GFsmUvRprs xiXdWnda3rcNUPWbaHyVaTqNL1kgx3UEdx3M4cax6KdpUshADdBB3cHdt1VB/kd09y9pfMUNnVOa g8FFPQ7NPyqvneayRn/bKXin5X3bHF0/T+D+NxqX6f5v6PZLc6k6rj4181vZF8AJKP9I4z86Be+W u297SNU3tLG1/jWNH9H4No1/pXGug7qDu28HF+QMak6XfUK09T/TeIZAfbmf+Q7uvh0QPW4Am9dT /52Mpzqou+bu2z7Q42tY8cha0+d1a90td9/2kxWnm7lUXaXgNFF0UHdw9+2AgryDum99O+B6/Fs0 /oHG6zSu4rBdovEojb+h8TCNE/1s9a1r7gOox8VKc0UYLhLBQObiCf8pFrtb674tt/8XYADVfRAu cBYyjAAAAABJRU5ErkJggg==",
    transform: "matrix(0.9932 0 0 0.9932 1262.1746 1165.0742)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 1185.639,
    y1: 1818.931,
    x2: 1329.1691,
    y2: 1818.931,
    gradientTransform: "matrix(1 0 0 -1 -2.2891 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    style: {
      stopColor: "#CED3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#E9EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "1326.88,1228.95 1183.35,1228.95 1194.44,1253.29 1326.88,1253.29  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 1184.3229,
    y1: 1855.421,
    x2: 1318.0629,
    y2: 1855.421,
    gradientTransform: "matrix(1 0 0 -1 -23.7129 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    style: {
      stopColor: "#CED3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#E9EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "1294.35,1196.89 1160.61,1196.89 1161.91,1212.37 1294.35,1212.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 1160.9866,
    y1: 1848.197,
    x2: 1144.8226,
    y2: 1887.6143,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A4400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A4430"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M1151.84,1174.29c-4.47-3.04-11.51,2.14-13.29,7.89c-0.08,2.48,1.76,6.62,1.76,6.62s7.46,16.62,10,19.44 c2.54,2.84,12.83,6.89,17.79,2.66c3.56-4.62-3.5-7.37-4.79-11.94c-1.68-5.94-0.96-10.7-2.61-15.18 C1159.34,1180.1,1151.84,1174.29,1151.84,1174.29z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1138.98,1181.04c-0.01,0.02-0.01,0.04-0.02,0.07c-0.08,2.47,1.75,6.62,1.75,6.62s7.47,16.61,10,19.44 c2.54,2.83,12.84,6.89,17.79,2.66c0.2-0.26,0.36-0.52,0.49-0.76c-0.12,0.58-0.4,1.19-0.9,1.84 c-4.96,4.23-15.25,0.18-17.79-2.66c-2.54-2.82-10-19.44-10-19.44s-1.84-4.14-1.76-6.62 C1138.68,1181.79,1138.82,1181.42,1138.98,1181.04z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1164.1,1178.05c-2.18-1.48-11.18-4.75-11.18-4.75s-0.77,1.02-2.03,1.51c-0.13,0.03-0.26,0.08-0.4,0.13 c-2.22,0.02-6.25,2.1-3.76,6.58c4.83,8.69,15.99,8.39,14.76,4.27C1160.65,1183.02,1162.95,1179.75,1164.1,1178.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 1166.2892,
    y1: 1850.3679,
    x2: 1150.1228,
    y2: 1889.7913,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A4400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A4430"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M1161.69,1188.05c0.34-1.37,0.74-4.35-2.77-4.84c-3.68-0.52-7.84,1.18-7.5,3.34 C1152.13,1191.04,1161.35,1189.43,1161.69,1188.05z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 1147.6569,
    y1: 1940.1211,
    x2: 1225.6769,
    y2: 1940.1211,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242956"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M1147.94,1173.47c4.18-5.63,35.12-42.88,49.7-50.3c-4.9-20.56-17.62-47.27-13.58-69.3h31.05 c0,0,18.41,65.22,6.63,80.76c-8.92,11.78-48.42,41.87-63.13,51.36C1153.56,1185.99,1146.11,1177.84,1147.94,1173.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 1202.5903,
    y1: 1808.9244,
    x2: 1167.8517,
    y2: 1831.6112,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A4400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A4430"
    }
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M1174.29,1227.62c-5.33,0.87-6.88,9.47-4.21,14.86c1.65,1.85,5.84,3.59,5.84,3.59s16.85,6.91,20.63,7.21 c3.79,0.31,12.21-1.11,12.9-7.58c-0.65-3.96-3.97-5.04-8.06-7.47c-5.31-3.15-9.87-7.73-14.15-9.83 C1183.72,1226.68,1174.29,1227.62,1174.29,1227.62z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1196.43,1251.56c-3.9-0.31-21.24-7.41-21.24-7.41s-4.04-1.7-5.83-3.54c0.19,0.65,0.42,1.29,0.71,1.88 c1.65,1.85,5.84,3.59,5.84,3.59s16.85,6.91,20.63,7.21c3.79,0.31,12.21-1.11,12.9-7.58c-0.03-0.13-0.08-0.26-0.1-0.4 C1207.56,1250.64,1200,1251.85,1196.43,1251.56z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1185.77,1221.91c-2.6,0.42-11.39,4.24-11.39,4.24s0.15,1.28-0.43,2.5c-0.07,0.12-0.13,0.24-0.2,0.36 c-1.6,1.55-3.28,4.29,1.6,5.83c9.48,2.98,17.57-3.38,13.84-5.52C1186.68,1227.88,1186.1,1223.92,1185.77,1221.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 1205.9763,
    y1: 1814.1001,
    x2: 1171.2295,
    y2: 1836.792,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A4400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A4430"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M1190.8,1230.59c-0.71-0.94-2.35-3.44-5.24-1.38c-3.03,2.16-3.71,4.75-3.36,6.91s6.59,0.56,6.83,0.23 C1189.27,1236.04,1190.8,1230.59,1190.8,1230.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 1150.5428,
    y1: 1915.7419,
    x2: 1190.1196,
    y2: 1915.7419,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242956"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M1187.87,1062.7c0,29.16,0.3,51.89,0.3,77.36c0,29.12,2.23,65.22,1.92,89.63 c-4.68,5.8-16.58,4.34-19.08-0.14c-3.09-22.15-9.99-55.9-8.28-80.08c-7.37-31.86-14.49-69.35-11.48-94.35 C1158.29,1057.36,1180.81,1060.46,1187.87,1062.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 1217.5444,
    y1: 2045.3311,
    x2: 1261.1801,
    y2: 2045.3311,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCD6DF"
    }
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M1223.27,980.99c10.47,5.83,20.5,38.11,25,44.04c4.5,5.92,12.91,13.46,12.91,13.46 c-4.84,4.04-15.44,9.96-15.44,9.96c-5.11-4.31-13.71-3.42-23.99-29.13C1211.47,993.59,1223.27,980.99,1223.27,980.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 13170.1953,
    y1: 2026.1288,
    x2: 13086.4072,
    y2: 2026.1288,
    gradientTransform: "matrix(-1 0 0 -1 14318.6895 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCD6DF"
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1168.88,991.72c6.17-7.72,21.32-18.49,31.25-19.22c16.88-1.24,29.61,11.66,32,24.36 c2.12,11.24-18.69,68.02-15.07,82.93c-1.78,7.87-14.86,12.13-20.34,13.33c-23.82,5.23-47.91,1.89-48.18-13.33 C1147.65,1029.33,1159.98,1000.62,1168.88,991.72z"
  }))), /*#__PURE__*/React.createElement("g", null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1354.12,1158.25l-59.42,34.31c-3.26,1.88-6.22,2.06-8.36,0.82c-2.14-1.24-3.46-3.88-3.46-7.66v-68.61 c0-3.77,1.32-7.95,3.46-11.66c2.14-3.71,5.1-6.94,8.36-8.83l59.42-34.31c3.27-1.89,6.22-2.06,8.36-0.83 c2.14,1.24,3.46,3.88,3.46,7.66v68.61c0,3.77-1.32,7.95-3.46,11.66C1360.34,1153.13,1357.39,1156.37,1354.12,1158.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1282.87,1185.73v-68.61c0-3.77,1.32-7.95,3.46-11.66c2.14-3.71,5.1-6.94,8.36-8.83l59.42-34.31 c3.27-1.89,6.22-2.06,8.36-0.83l-77.84-44.94c-2.14-1.23-5.1-1.06-8.36,0.83l-59.42,34.31c-3.27,1.89-6.22,5.12-8.36,8.83 s-3.47,7.88-3.47,11.65v68.62c0,3.77,1.33,6.42,3.47,7.65l77.84,44.94C1284.19,1192.15,1282.87,1189.5,1282.87,1185.73z"
  }))), /*#__PURE__*/React.createElement("g", null, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M1274.04,1098.36c2.14-3.71,5.1-6.94,8.36-8.83l59.43-34.31c3.26-1.89,6.22-2.06,8.35-0.83l3.73,2.15 c-2.14-1.23-5.1-1.06-8.36,0.83l-59.42,34.31c-3.27,1.88-6.22,5.12-8.36,8.83s-3.46,7.89-3.46,11.66v68.61 c0,3.77,1.32,6.42,3.46,7.65l0,0l-3.73-2.15c-2.14-1.23-3.46-3.89-3.46-7.66v-68.61 C1270.57,1106.25,1271.9,1102.07,1274.04,1098.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 1246.879,
    y1: 1889.4547,
    x2: 1323.0256,
    y2: 2021.3444,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1264.05,1092.59c2.14-3.71,5.1-6.94,8.36-8.83l59.42-34.31c3.26-1.89,6.22-2.06,8.36-0.83l3.73,2.15 c-2.14-1.24-5.09-1.06-8.36,0.83l-59.42,34.31c-3.27,1.89-6.22,5.12-8.36,8.83s-3.47,7.89-3.47,11.66v68.61 c0,3.77,1.33,6.42,3.47,7.65l0,0l-3.73-2.15c-2.14-1.24-3.47-3.88-3.47-7.65v-68.62 C1260.58,1100.48,1261.91,1096.3,1264.05,1092.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 1236.8932,
    y1: 1895.218,
    x2: 1313.0397,
    y2: 2027.1078,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M1254.06,1086.82c2.14-3.71,5.09-6.94,8.36-8.83l59.43-34.31c3.26-1.88,6.22-2.06,8.36-0.82l3.73,2.15 c-2.14-1.24-5.1-1.06-8.36,0.83l-59.42,34.31c-3.26,1.89-6.22,5.12-8.36,8.83s-3.47,7.89-3.47,11.65v68.62 c0,3.77,1.33,6.42,3.47,7.65l0,0l-3.73-2.15c-2.14-1.24-3.46-3.88-3.46-7.65v-68.62 C1250.59,1094.71,1251.92,1090.53,1254.06,1086.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 1226.8982,
    y1: 1900.9784,
    x2: 1303.0476,
    y2: 2032.873,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M1244.07,1081.06c2.14-3.71,5.09-6.94,8.36-8.83l59.42-34.31c3.26-1.89,6.22-2.07,8.36-0.83l3.73,2.15 c-2.14-1.23-5.1-1.06-8.36,0.83l-59.42,34.31c-3.27,1.88-6.22,5.12-8.36,8.82c-2.14,3.71-3.46,7.89-3.46,11.66v68.62 c0,3.77,1.32,6.42,3.46,7.66l0,0l-3.73-2.16c-2.14-1.23-3.47-3.88-3.47-7.65v-68.62 C1240.6,1088.94,1241.92,1084.76,1244.07,1081.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1216.9067,
    y1: 1906.7458,
    x2: 1293.0576,
    y2: 2038.6431,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M1234.08,1075.29c2.14-3.71,5.09-6.94,8.36-8.83l59.42-34.31c3.26-1.89,6.22-2.06,8.36-0.83l3.73,2.15 c-2.14-1.23-5.1-1.06-8.36,0.83l-59.42,34.31c-3.27,1.89-6.22,5.12-8.36,8.83s-3.46,7.89-3.46,11.66v68.62 c0,3.77,1.32,6.42,3.46,7.65l0,0l-3.73-2.15c-2.14-1.23-3.47-3.89-3.47-7.66v-68.62 C1230.61,1083.17,1231.93,1078.99,1234.08,1075.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1206.9152,
    y1: 1912.5267,
    x2: 1283.0619,
    y2: 2044.4165,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M1224.08,1069.52c2.14-3.71,5.1-6.94,8.36-8.83l59.43-34.31c3.26-1.89,6.22-2.06,8.36-0.83l3.73,2.15 c-2.14-1.24-5.1-1.06-8.36,0.83l-59.42,34.31c-3.27,1.89-6.22,5.12-8.36,8.83s-3.46,7.89-3.46,11.65v68.62 c0,3.77,1.32,6.42,3.46,7.65l0,0l-3.73-2.15c-2.14-1.24-3.46-3.88-3.46-7.66v-68.61 C1220.62,1077.4,1221.94,1073.22,1224.08,1069.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 1196.9209,
    y1: 1918.2793,
    x2: 1273.0718,
    y2: 2050.1765,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M1214.09,1063.75c2.14-3.71,5.1-6.94,8.36-8.83l59.43-34.31c3.27-1.89,6.22-2.06,8.36-0.82l3.73,2.15 c-2.14-1.24-5.1-1.06-8.36,0.83l-59.42,34.31c-3.27,1.89-6.23,5.12-8.36,8.83c-2.14,3.7-3.46,7.89-3.46,11.65v68.62 c0,3.77,1.32,6.42,3.46,7.66l0,0l-3.73-2.15c-2.14-1.24-3.46-3.89-3.46-7.66v-68.62 C1210.63,1071.63,1211.95,1067.46,1214.09,1063.75z"
  })))), /*#__PURE__*/React.createElement("g", null, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M1202.61,1102.11c0.69,0.98,2.52,11.68-5.62,13.35C1193.46,1112.73,1193.97,1102.27,1202.61,1102.11z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1198.09,1101.21l4.5,2.66c2.57,1.32,9.68,1.29,14.24-1.81c4.56-3.1,3.9,4.65-0.99,5.96 c-4.9,1.31-5.31,3.18,1.67,5.86c3.26,1.26,6.41,3.79,7.38,5.22c2.1,3.09,3.87,9.38-0.78,11.38c-3.77,1.62-12.84-4.74-15.61-6.53 c-7.63-4.95-5.66-6.28-9.88-9.37c-4.22-3.1-5.27-3.21-5.27-3.21L1198.09,1101.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 1156.6484,
    y1: 2006.8688,
    x2: 1202.6,
    y2: 2006.8688,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CABD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCD6DF"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M1179.77,992.12c-5.01-2.07-14.04-3.37-19.42,12.14c-3.05,8.8-5.65,39.67-1.69,55.28 c5.42,21.35,18.8,43.43,38.32,55.93c-2.54-4.35,1.02-12.24,5.62-13.35c-13.45-15.28-22.89-35.17-22.89-44.96 c0-16.17,2.98-40.91,4.16-45.87C1186.38,1000.85,1184.72,994.16,1179.77,992.12z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1198,950.09c-0.62-5.47,18.28,5.67,17.52,12.89c-0.62,5.87-2.33,11.05,3.61,14.72 c2.05,1.64,9.06,13.06-1.72,13.18c-15.42,0.19-19.53-4.04-30.68-13.6C1193.39,973.54,1200.01,967.82,1198,950.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1193.55,946.85l7.68-10.8h33.42v20.12c0,11.12-7.48,20.12-16.71,20.12c-8.96,0-17.28-7.42-17.72-18.07 l-4.06-1.4L1193.55,946.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1217.17,981.67c-7.99,0-17.87-12.83-16.94-23.44c0.41,10,8.73,17.21,17.04,18.04 c0.71,0.59,1.14,0.99,1.87,1.44c0.16,0.13,0.35,0.32,0.56,0.56C1219.7,979.89,1218.62,981.67,1217.17,981.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M1232.7,926.97c3.06-0.53,3.33-3.07-9.06-7.36c-7.2-3.53-17.4-4.62-24.01-0.53 c-8.95,5.54-11.65,13.68-10.04,23.9c1.6,10.23,8.15,19.95,8.15,19.95c0.99,1,1.14-3.71,0.33-7.2c-0.38-0.36-0.77-1.29-1.16-2.99 c-2.37-10.39,3.98-8.84,4.86-7.96c1.96,0.81-1.83,9.4,3.91,8.54c2.78-0.41,2.4-8.17,2.39-10.9c0.41,0.1,0.81,0.17,1.25,0.33 c4.74,2.63,20.86,4.55,11.91-1.05c6.23,0,14.73,2.88,17.6-1.08C1242.23,935.91,1236.77,930.78,1232.7,926.97z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Woman_holding_block"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 13704.1973,
    y1: 1730.051,
    x2: 13804.2773,
    y2: 1730.051,
    gradientTransform: "matrix(-1 0 0 -1 15232.457 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#FAFBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5298,
    style: {
      stopColor: "#ECEEF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8346,
    style: {
      stopColor: "#D4D8EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4CAE9"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1428.18,
    y: 1319.52,
    className: "st155",
    width: 100.08,
    height: 20.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 13749.1475,
    y1: 1699.806,
    x2: 13856.7568,
    y2: 1699.806,
    gradientTransform: "matrix(-1 0 0 -1 15232.457 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00561798,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#FAFBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5298,
    style: {
      stopColor: "#ECEEF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8346,
    style: {
      stopColor: "#D4D8EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4CAE9"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1375.7,
    y: 1349.77,
    className: "st156",
    width: 107.61,
    height: 20.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 855.919,
    y1: 1733.8632,
    x2: 898.2869,
    y2: 1733.8632,
    gradientTransform: "matrix(1 0 0 -1 541.9531 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#423EAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3038,
    style: {
      stopColor: "#3A35A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8906,
    style: {
      stopColor: "#241E77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20196F"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1440.24,1334.02c0-16.46-10.44-16.93-10.44-16.93s-5.8,0.59-15.1-2.91 c-11.72-4.4-21.55-3.22-14.41,9.95c0.07,0.16,0.15,0.32,0.25,0.49c0.44,0.69,1.18,1.38,2.31,2.03l22.8,13.37 C1429.12,1342,1440.16,1337.41,1440.24,1334.02z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1440.18,1332.54c-0.2,3.38-11.08,7.88-14.53,5.92l-22.8-13.37c-0.75-0.43-2.05-1.31-3.21-2.34 c0.22,0.46,0.39,0.89,0.66,1.38c0.07,0.16,0.15,0.32,0.25,0.49c0.44,0.69,1.18,1.38,2.31,2.03l22.8,13.37 c3.25,1.86,13.15-2.05,14.45-5.34c0.06-0.24,0.09-0.48,0.09-0.66C1440.24,1333.5,1440.2,1333.04,1440.18,1332.54z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1436,1314.92c-1.35,0-4.42,0.6-7.13,1.21c-2.24-0.58-9.64-0.85-14.48-2.28 c-1.44-0.42-2.8-1.33-4.32-0.17c-1.91,2.35,3.07,8.1,13.34,12.53c3.63,2.29,6.58,0.83,7.98-0.56c0.57-1.06,1.41-2.24,2.57-2.92 c1.21-0.69,1.94-1,2.46-1.04c-0.01-0.07,0.03-0.22,0.03-0.22S1437.12,1314.92,1436,1314.92z"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M1430.84,1206.7c4.58-14.04,2.47-30.25-0.93-46.55c-10.31,0.18-29.82-5.58-40.12-5.4 c3.84,30.98,12.48,58.22,17.64,88.22c5.53,29.17,12.11,50.58,17.55,74.86c1.99,4.52,11.7,2.48,11.7-0.23 c1.44-22.36,0.48-48.28-6.14-74.07C1430.99,1231.87,1428.99,1218.31,1430.84,1206.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 803.9005,
    y1: 1703.7358,
    x2: 846.3169,
    y2: 1703.7358,
    gradientTransform: "matrix(1 0 0 -1 541.9531 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#423EAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3038,
    style: {
      stopColor: "#3A35A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8906,
    style: {
      stopColor: "#241E77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20196F"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M1388.27,1364.27c0-16.46-10.43-16.93-10.43-16.93s-6.12,0.27-15.42-3.23 c-11.72-4.4-21.24-2.9-14.11,10.27c0.07,0.16,0.16,0.32,0.25,0.49c0.43,0.69,1.18,1.38,2.31,2.02l22.8,13.37 C1377.15,1372.25,1388.19,1367.66,1388.27,1364.27z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1388.21,1362.79c-0.2,3.38-11.09,7.89-14.54,5.92l-22.8-13.38c-0.75-0.43-2.05-1.31-3.22-2.34 c0.21,0.45,0.39,0.89,0.65,1.38c0.07,0.16,0.16,0.32,0.25,0.49c0.43,0.69,1.18,1.38,2.31,2.02l22.8,13.37 c3.24,1.86,13.14-2.04,14.45-5.34c0.05-0.24,0.1-0.47,0.1-0.67C1388.27,1363.75,1388.23,1363.29,1388.21,1362.79z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1384.03,1345.17c-1.35,0-4.42,0.6-7.13,1.21c-2.23-0.58-9.64-0.84-14.48-2.28 c-1.44-0.42-2.8-1.33-4.32-0.17c-1.91,2.35,3.07,8.1,13.34,12.53c3.63,2.28,6.57,0.83,7.97-0.56c0.57-1.06,1.41-2.25,2.57-2.92 c1.2-0.69,1.93-1,2.46-1.04c0-0.07,0.03-0.22,0.03-0.22S1385.15,1345.17,1384.03,1345.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 826.3493,
    y1: 1804.7445,
    x2: 888.1158,
    y2: 1804.7445,
    gradientTransform: "matrix(1 0 0 -1 541.9531 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#423EAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2442,
    style: {
      stopColor: "#38339C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#27207B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20196F"
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M1403.45,1227.61c8.78-35.28,28.59-15.08,26.46-67.46c-10.2-1.5-46.63,21.54-56.83,20.04 c-5.97,37.97-4.73,61.42-4.55,91.86c0.69,29.68,2.63,49.99,4.04,74.82c1.23,4.79,12.09,4.42,12.09,1.54 c5.07-21.81,9.12-48.42,6.79-74.94C1394.5,1258.78,1400.15,1243.2,1403.45,1227.61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 1490.5164,
    y1: 3716.8047,
    x2: 1575.0032,
    y2: 3716.8047,
    gradientTransform: "matrix(0.9614 -0.2751 -0.2751 -0.9614 935.4067 5139.8945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M1424.66,1214.55c-16.62,10.16-42.76,16.45-59.58,9.01c-1.74-9.82,13.45-74.55,3.46-91.6 c-2.18-3.72-9.2-0.68-11.09-4.72c-4.92-10.48-9.61-32.27-9.61-35.58c0-7.05,5.66-14.36,11.52-18.25 c8.01-5.34,19.39-12.48,29.43-10.52c21.92,6.15,37.43,62.7,53.52,128.14C1440.66,1198.44,1434.65,1208.44,1424.66,1214.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 1348.1699,
    y1: 1900.991,
    x2: 1380.4254,
    y2: 1900.991,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    style: {
      stopColor: "#E2E6F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M1380.33,1148.92c1.08-8.07-7.26-22.34-12.03-23.95c-4.77-1.62-8.96-3.5-8.96-8.98 c0-5.49,2.26-14.12,1.07-20.64l-12.24-0.8c1.16,7.1,5.14,23.89,9.27,32.7c1.9,4.04,8.91,1,11.09,4.72 c9.99,17.05-5.19,81.78-3.46,91.6c0,0,6.11-31.06,8-43.37C1374.97,1167.88,1379.25,1156.99,1380.33,1148.92z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1385.03,1067.85c-6.72-4.49-6.31-8.1-5.58-14.58c1.13-3.42,1.71-7.2,1.56-11.19 c-0.54-14.35-10.13-26.4-21.3-25.21c-22.51,2.4-18.05,14.12-17.51,28.46c0.5,13.29,6.87,22.2,17,23.37 c0.09,2.18-0.58,4.23-3.3,6.26c7.53,4.14,19.23,1.91,23.94-0.04C1384.47,1073.02,1388.22,1070.91,1385.03,1067.85z"
  }))), /*#__PURE__*/React.createElement("g", null, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1290.49,1151.19c-1.98,0.18-3.43-4.59-6.67-4.99s-10.11-1.45-9.96,0.53c0.13,1.66,5.98,1.37,5.19,2.23 c-2.29,2.47-7.8,0.02-9.13-2.09c-1.34-2.12-3.26-2.29-3.06-0.14c0.19,2.15,1.44,11.77,9.21,13.93s16.81,0.86,16.81,0.86 L1290.49,1151.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 10129.3896,
    y1: 6659.9404,
    x2: 10230.4141,
    y2: 6659.9404,
    gradientTransform: "matrix(-0.6319 0.7751 -0.7751 -0.6319 12923.1328 -2553.6318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48A6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M1290.08,1162.36c0,0-6.92-4.56-0.56-12.37c22.45-4,50.36-29.32,57.19-59.41 c4.15-11.73,17.31-3.54,14.58,11.37C1356.98,1125.42,1329.65,1161.24,1290.08,1162.36z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 1339.129,
    y1: 2009.891,
    x2: 1412.6,
    y2: 2009.891,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006204433,
    style: {
      stopColor: "#E57139",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4198,
    style: {
      stopColor: "#C36A3F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F6049"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M1339.22,1036.26c0.41-8.33,7.16-22.33,22.01-21.28c14.35,1.01,20.47,11.21,20.62,23.64 c0.12,9.76,8.83,37.37,30.75,35.77C1403.23,1091.74,1336.33,1094.84,1339.22,1036.26z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 1082.1168,
    y1: -483.2749,
    x2: 967.4875,
    y2: -368.6456,
    gradientTransform: "matrix(0.866 0.5 0 -1.1547 994.3859 -541.7986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000620847,
    style: {
      stopColor: "#E9A274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A284"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M1933.27,434.94l-102.81-59.36c-6-3.46-10.91-0.63-10.91,6.3v89.2c0,6.92,4.91,15.43,10.91,18.89 l31.91,18.42l19.49,33.77l19.49-11.25l0,0l31.92,18.43c6,3.46,10.9,0.63,10.91-6.3v-89.2 C1944.17,446.91,1939.27,438.4,1933.27,434.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 1907.2198,
    y1: 2556.6411,
    x2: 1856.0718,
    y2: 2632.0627,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006349755,
    style: {
      stopColor: "#E9A284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M1848.16,414.97v-7.76l3.02,1.74v7.76l4.53,2.61v-7.76l3.02,1.74v7.76l4.08,2.36v3.29l-4.08-2.36v5.62 l4.08,2.36v3.29l-4.08-2.36v7.76l-3.02-1.74v-7.76l-4.53-2.61v7.76l-3.02-1.74v-7.76l-4.08-2.36v-3.29l4.08,2.36v-5.62 l-4.08-2.36v-3.29L1848.16,414.97z M1851.18,425.62l4.53,2.61v-5.62l-4.53-2.61V425.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 1917.2389,
    y1: 2563.4358,
    x2: 1866.0907,
    y2: 2638.8574,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006349755,
    style: {
      stopColor: "#E9A284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M1866.89,425.91c0-5.03,2.47-6.46,6.86-3.92l16.46,9.5c4.19,2.42,6.45,6.26,6.45,11.13v16.75 c0,2.18-1.16,2.89-3.12,1.76l-4.8-2.77c-1.54-0.89-2.5-2.47-2.5-4.14v-0.47l-0.48-0.27c-0.55,1.42-1.89,2.63-4.84,0.93 c-4.18-2.41-7.03-8.34-7.03-13.88v-0.67c0-5.59,2.81-8.2,6.82-5.88c2.99,1.72,4.22,4.34,4.87,6.3l0.48,0.28v-2.93l3.12,1.8 v14.85c0,0.75,0.27,1.23,0.86,1.56l2.23,1.29c0.82,0.48,1.2,0.26,1.2-0.77v-15.68c0-2.54-1.2-4.61-3.4-5.88l-15.81-9.13 c-2.78-1.6-4.19-0.79-4.19,2.42v19.25c0,3.21,1.41,5.64,4.19,7.25l21.88,12.63v3.37l-22.4-12.93 c-4.39-2.54-6.86-6.81-6.86-11.84v-19.91H1866.89z M1881.54,451.35c2.68,1.55,4.49,0.1,4.49-3.94v-0.44 c0-4.04-1.82-7.58-4.49-9.13c-2.67-1.54-4.46-0.04-4.46,3.92v0.48C1877.08,446.24,1878.86,449.81,1881.54,451.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 1934.059,
    y1: 2568.0269,
    x2: 1882.9126,
    y2: 2643.446,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006349755,
    style: {
      stopColor: "#E9A284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M1907.29,454.71l1.85,1.82l0.17-0.46l-1.99-2.29l-2.81-4.95l1.89-1.09l2.88,4.91l0.99,2.87l0.48,0.08 l-0.65-2.51v-4.99l2.74,1.58v4.99l-0.65,1.76l0.48,0.48l0.99-1.72l2.88-1.58l1.89,3.27l-2.81,1.7h-1.99l0.17,0.65l1.85,0.32 l4.32,2.49v3.17l-4.32-2.49l-1.85-1.82l-0.17,0.45l1.99,2.3l2.81,4.95l-1.89,1.09l-2.88-4.91l-0.99-2.87l-0.48-0.08l0.65,2.51 v4.99l-2.74-1.58v-5l0.65-1.76l-0.48-0.48l-0.99,1.72l-2.88,1.59l-1.89-3.27l2.81-1.7h1.99l-0.17-0.65l-1.85-0.32l-4.32-2.49 v-3.17L1907.29,454.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 1885.4724,
    y1: 2541.8928,
    x2: 1834.3236,
    y2: 2617.3157,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006349755,
    style: {
      stopColor: "#E9A284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M1853.24,457.13c4.87,2.81,8.36,8.16,8.36,12.79v0.2c0,4.48-2.47,5.03-5.14,4.83l-0.86-0.1 c-0.86-0.02-1.17,0.36-1.17,1.62v1.78l-3.39-1.96v-1.98c0-2.5,0.62-3.6,2.74-3.44l0.86,0.1c2.3,0.18,3.56-0.24,3.56-2.81 c0-2.85-2.16-5.76-4.97-7.38c-2.92-1.68-5.25-1.37-5.25,2.04v1.27l-3.39-1.96v-1.43 C1844.59,455.27,1848.29,454.28,1853.24,457.13z M1852.75,479.51c1.51,0.87,2.67,2.85,2.67,4.63s-1.17,2.41-2.67,1.54 c-1.55-0.89-2.67-2.85-2.67-4.63C1850.08,479.27,1851.21,478.62,1852.75,479.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 1891.1914,
    y1: 2545.77,
    x2: 1840.0415,
    y2: 2621.1943,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006349755,
    style: {
      stopColor: "#E9A284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M1867.92,488.27c1.55,0.89,2.68,2.85,2.68,4.63s-1.13,2.44-2.68,1.55c-1.51-0.87-2.67-2.85-2.67-4.63 C1865.25,488.03,1866.42,487.4,1867.92,488.27z M1869.64,467.16v19.88l-3.4-1.96V465.2L1869.64,467.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1898.146,
    y1: 2549.3064,
    x2: 1846.9999,
    y2: 2624.7251,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006349755,
    style: {
      stopColor: "#E9A284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M1886.44,491.15c0.45,0.26,0.82,0.2,1.2,0.02l2.91-0.93l1.85,3.76l-3.5,1.15 c-0.79,0.26-1.65,0.47-2.78-0.18c-1.47-0.85-2.23-2.12-2.81-3.6c-0.48-1.22-0.72-1.8-1.37-2.18c-0.44-0.26-0.79-0.18-1.17,0 l-2.92,0.93l-1.85-3.76l3.5-1.15c0.79-0.26,1.65-0.44,2.74,0.2c1.51,0.87,2.26,2.1,2.85,3.58 C1885.58,490.22,1885.82,490.8,1886.44,491.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 1907.1298,
    y1: 2552.3162,
    x2: 1855.9823,
    y2: 2627.7368,
    gradientTransform: "matrix(1 0 0 -1 0 3060.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006349755,
    style: {
      stopColor: "#E9A284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M1901.41,507.6c1.55,0.89,2.67,2.85,2.67,4.63s-1.13,2.44-2.67,1.55c-1.51-0.87-2.67-2.85-2.67-4.63 C1898.74,507.37,1899.91,506.73,1901.41,507.6z M1903.13,486.5v19.88l-3.4-1.96v-19.88L1903.13,486.5z"
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st172",
    x1: 4997.63,
    y1: 501.94,
    x2: 4997.63,
    y2: 2101.94
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M4917.63,2019.9V824.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_131_",
    cx: 426.7992,
    cy: -1401.744,
    r: 25.552,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 1980.9303 -436.4328)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M1737.66,766.62c5-10.12,16.1-12.62,24.92-5.6c8.85,7.04,11.91,20.92,6.98,31.02 c-4.95,10.09-16.1,12.6-24.92,5.58C1735.77,790.61,1732.73,776.71,1737.66,766.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 1701.4601,
    y1: 1959.0863,
    x2: 1831.3252,
    y2: 1959.0863,
    gradientTransform: "matrix(1 0 0 -1 0 2744.5513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M1830.86,776.44c0.86-6.21,3.96-26.63-30.98-25.31c-18.26,0.68-36.58-0.89-54.21-4.06 c-28.81,13.45-43.92,42-44.21,61.86c15.89,6.53,33.34,11.23,51.55,13.86C1803.42,830.02,1827.73,799.06,1830.86,776.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 1636.05,
    y1: 2021.3862,
    x2: 1658.3401,
    y2: 2021.3862,
    gradientTransform: "matrix(1 0 0 -1 0 2744.5513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M1653.02,697.91c-7.11-10.51-10.89-21.71-12.38-32.91v-0.03l-0.52,0.01c-2.59,15-4.07,30.55-4.07,46.6 c0,12.9,0.99,25.46,2.68,37.71c2.7,11.19,9.52,22.03,19.61,32.07C1650.47,758.91,1644.69,730.37,1653.02,697.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_134_",
    cx: 644.1732,
    cy: 2241.8503,
    r: 25.552,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 2141.2039 -1146.5549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M1737.73,766.03c5-10.12,16.1-12.62,24.92-5.6c8.85,7.04,11.91,20.92,6.98,31.02 c-4.95,10.09-16.1,12.6-24.92,5.58C1735.84,790.01,1732.8,776.11,1737.73,766.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 1701.5302,
    y1: -449.1337,
    x2: 1831.3953,
    y2: -449.1337,
    gradientTransform: "matrix(1 0 0 1 0 1234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M1830.93,775.84c0.86-6.21,3.96-26.63-30.98-25.31c-18.26,0.68-36.58-0.89-54.21-4.06 c-28.82,13.45-43.92,42-44.21,61.86c15.89,6.53,33.34,11.23,51.55,13.86C1803.49,829.43,1827.8,798.47,1830.93,775.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 1636.12,
    y1: -511.425,
    x2: 1658.41,
    y2: -511.425,
    gradientTransform: "matrix(1 0 0 1 0 1234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M1653.09,697.32c-7.11-10.51-10.89-21.71-12.38-32.91v-0.03l-0.52,0.01c-2.59,15-4.07,30.55-4.07,46.6 c0,12.9,0.99,25.46,2.68,37.71c2.7,11.19,9.52,22.03,19.61,32.07C1650.54,758.32,1644.76,729.78,1653.09,697.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_137_",
    cx: 861.7593,
    cy: -380.4344,
    r: 26.0039,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 1350.4191 77.042)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M1737.8,765.02c5.09-10.3,16.38-12.84,25.36-5.7c9,7.17,12.12,21.3,7.1,31.57 c-5.04,10.26-16.38,12.83-25.36,5.68C1735.88,789.43,1732.79,775.28,1737.8,765.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 1700.96,
    y1: 1640.3639,
    x2: 1833.1313,
    y2: 1640.3639,
    gradientTransform: "matrix(1 0 0 -1 0 2424.5513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M1832.66,775.01c0.87-6.32,4.03-27.1-31.53-25.76c-18.58,0.7-37.23-0.91-55.17-4.14 c-29.33,13.69-44.7,42.74-45,62.96c16.17,6.64,33.93,11.43,52.47,14.1C1804.73,829.55,1829.47,798.03,1832.66,775.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1634.38,
    y1: 1703.7611,
    x2: 1657.0699,
    y2: 1703.7611,
    gradientTransform: "matrix(1 0 0 -1 0 2424.5513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M1651.66,695.09c-7.24-10.7-11.09-22.1-12.6-33.5v-0.03l-0.53,0.01c-2.63,15.27-4.15,31.09-4.15,47.43 c0,13.13,1.01,25.91,2.73,38.38c2.75,11.39,9.69,22.42,19.96,32.64C1649.07,757.17,1643.18,728.12,1651.66,695.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_140_",
    cx: 1078.6357,
    cy: 1220.7905,
    r: 26.382,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 1510.6926 -633.0802)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M1737.23,764.18c5.16-10.45,16.62-13.03,25.73-5.79c9.13,7.27,12.29,21.6,7.21,32.03 c-5.11,10.41-16.62,13.01-25.73,5.76C1735.28,788.94,1732.14,774.59,1737.23,764.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 1699.86,
    y1: -130.3757,
    x2: 1833.9274,
    y2: -130.3757,
    gradientTransform: "matrix(1 0 0 1 0 914.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M1833.45,774.31c0.88-6.41,4.09-27.49-31.98-26.13c-18.85,0.71-37.77-0.92-55.97-4.2 c-29.75,13.89-45.34,43.36-45.64,63.87c16.41,6.74,34.42,11.6,53.22,14.31C1805.12,829.64,1830.22,797.67,1833.45,774.31z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_142_",
    cx: 357.6241,
    cy: 3269.2839,
    r: 26.8139,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 2676.8025 -1741.449)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#F67D66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#DE715C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4582,
    style: {
      stopColor: "#9F5142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7403,
    style: {
      stopColor: "#3D1F19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M1732.03,763.55c5.24-10.62,16.89-13.24,26.15-5.88c9.28,7.39,12.5,21.96,7.33,32.55 c-5.2,10.58-16.89,13.23-26.15,5.86C1730.05,788.72,1726.86,774.14,1732.03,763.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 1694.0399,
    y1: -766.9015,
    x2: 1830.3276,
    y2: -766.9015,
    gradientTransform: "matrix(1 0 0 1 0 1550.2244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M1829.84,773.85c0.9-6.52,4.16-27.95-32.51-26.56c-19.16,0.72-38.39-0.93-56.89-4.26 c-30.24,14.12-46.09,44.07-46.4,64.92c16.68,6.85,34.99,11.79,54.1,14.54C1801.04,830.09,1826.55,797.59,1829.84,773.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_144_",
    cx: 811.2304,
    cy: 2242.772,
    r: 25.552,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 2036.278 -1230.4924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M1736.69,765.83c5-10.12,16.1-12.62,24.92-5.6c8.85,7.04,11.91,20.92,6.98,31.02 c-4.95,10.09-16.1,12.6-24.92,5.58C1734.8,789.82,1731.76,775.92,1736.69,765.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 1700.4901,
    y1: -450.0495,
    x2: 1830.3552,
    y2: -450.0495,
    gradientTransform: "matrix(1 0 0 1 0 1234.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M1829.89,775.65c0.86-6.21,3.96-26.63-30.98-25.31c-18.26,0.68-36.58-0.89-54.21-4.06 c-28.81,13.45-43.92,42-44.21,61.86c15.89,6.53,33.34,11.23,51.55,13.86C1802.45,829.23,1826.76,798.27,1829.89,775.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 1635.0801,
    y1: -512.3444,
    x2: 1657.3701,
    y2: -512.3444,
    gradientTransform: "matrix(1 0 0 1 0 1234.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M1639.15,664.19c-2.59,15-4.07,30.55-4.07,46.6c0,12.9,0.99,25.46,2.68,37.71 c2.7,11.19,9.52,22.03,19.61,32.07c-7.87-22.45-13.65-50.99-5.32-83.45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_147_",
    cx: 1028.6046,
    cy: -977.7756,
    r: 25.552,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 1455.3448 -433.5717)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M1736.76,765.24c5-10.12,16.1-12.62,24.92-5.6c8.85,7.04,11.91,20.92,6.98,31.02 c-4.95,10.09-16.1,12.6-24.92,5.58C1734.87,789.22,1731.83,775.32,1736.76,765.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 1700.5601,
    y1: 1045.1992,
    x2: 1830.4252,
    y2: 1045.1992,
    gradientTransform: "matrix(1 0 0 -1 0 1829.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M1829.96,775.05c0.86-6.21,3.96-26.63-30.98-25.31c-18.26,0.68-36.58-0.89-54.21-4.06 c-28.82,13.45-43.92,42-44.21,61.86c15.89,6.53,33.34,11.23,51.55,13.86C1802.52,828.64,1826.83,797.68,1829.96,775.05z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_149_",
    cx: 1246.1906,
    cy: 1221.4623,
    r: 26.0039,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 1405.7667 -717.0176)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M1736.83,764.23c5.09-10.3,16.38-12.84,25.36-5.7c9,7.17,12.12,21.3,7.1,31.57 c-5.04,10.26-16.38,12.83-25.36,5.68C1734.91,788.64,1731.82,774.49,1736.83,764.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 1699.9899,
    y1: -131.3272,
    x2: 1832.1613,
    y2: -131.3272,
    gradientTransform: "matrix(1 0 0 1 0 914.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M1831.69,774.22c0.87-6.32,4.03-27.1-31.53-25.76c-18.58,0.7-37.23-0.91-55.17-4.14 c-29.33,13.69-44.7,42.74-45,62.96c16.17,6.64,33.93,11.43,52.47,14.1C1803.76,828.76,1828.5,797.24,1831.69,774.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 1633.41,
    y1: -177.9594,
    x2: 1656.1,
    y2: -177.9594,
    gradientTransform: "matrix(1 0 0 1 0 914.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M1633.41,708.21c0,13.13,1.01,25.91,2.73,38.38c2.75,11.39,9.69,22.42,19.96,32.64 c-8-22.85-13.89-51.9-5.41-84.93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 1637.5601,
    y1: -253.9444,
    x2: 1637.5601,
    y2: -253.9444,
    gradientTransform: "matrix(1 0 0 1 0 914.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M1637.56,660.78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_153_",
    cx: 1463.0673,
    cy: 43.284,
    r: 26.382,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 824.8336 79.903)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M1736.26,763.39c5.16-10.45,16.62-13.03,25.73-5.79c9.13,7.27,12.29,21.6,7.21,32.03 c-5.11,10.41-16.62,13.01-25.73,5.76C1734.31,788.15,1731.17,773.8,1736.26,763.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 1698.89,
    y1: 726.4412,
    x2: 1832.9574,
    y2: 726.4412,
    gradientTransform: "matrix(1 0 0 -1 0 1509.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M1832.48,773.52c0.88-6.41,4.09-27.49-31.98-26.13c-18.85,0.71-37.77-0.92-55.97-4.2 c-29.75,13.89-45.34,43.36-45.64,63.87c16.41,6.74,34.42,11.6,53.22,14.31C1804.15,828.85,1829.25,796.88,1832.48,773.52z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_155_",
    cx: 745.0591,
    cy: -2000.6986,
    r: 26.8139,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 1991.0406 -1028.3875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#F67D66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#DE715C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4582,
    style: {
      stopColor: "#9F5142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7403,
    style: {
      stopColor: "#3D1F19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st198",
    d: "M1734.62,761.1c5.24-10.62,16.89-13.24,26.15-5.88c9.28,7.39,12.5,21.96,7.33,32.55 c-5.2,10.58-16.89,13.23-26.15,5.86C1732.64,786.27,1729.45,771.69,1734.62,761.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 1696.629,
    y1: 1364.6244,
    x2: 1832.9167,
    y2: 1364.6244,
    gradientTransform: "matrix(1 0 0 -1 0 2145.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M1832.43,771.4c0.9-6.52,4.16-27.95-32.51-26.56c-19.16,0.72-38.39-0.93-56.89-4.26 c-30.24,14.12-46.09,44.07-46.4,64.92c16.68,6.85,34.99,11.79,54.1,14.54C1803.63,827.64,1829.14,795.14,1832.43,771.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 1641.739,
    y1: 1168.2573,
    x2: 1641.739,
    y2: 1168.2573,
    gradientTransform: "matrix(1 0 0 -1 0 1830)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F49E7E"
    }
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st200",
    d: "M1641.74,661.74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_158_",
    cx: 1198.6655,
    cy: -974.1865,
    r: 25.552,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 1350.5161 -517.4309)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M1739.28,763.38c5-10.12,16.1-12.62,24.92-5.6c8.85,7.04,11.91,20.92,6.98,31.02 c-4.95,10.09-16.1,12.6-24.92,5.58C1737.39,787.37,1734.35,773.47,1739.28,763.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 1703.0791,
    y1: 1047.7723,
    x2: 1832.9442,
    y2: 1047.7723,
    gradientTransform: "matrix(1 0 0 -1 0 1830)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M1832.48,773.2c0.86-6.21,3.96-26.63-30.98-25.31c-18.26,0.68-36.58-0.89-54.21-4.06 c-28.81,13.45-43.92,42-44.21,61.86c15.89,6.53,33.34,11.23,51.55,13.86C1805.04,826.78,1829.35,795.82,1832.48,773.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 1637.6691,
    y1: 1093.6023,
    x2: 1659.9591,
    y2: 1093.6023,
    gradientTransform: "matrix(1 0 0 -1 0 1830)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M1637.67,708.34c0,12.9,0.99,25.46,2.68,37.71c2.7,11.19,9.52,22.03,19.61,32.07 c-7.87-22.45-13.65-50.99-5.32-83.45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 1641.739,
    y1: 1168.2573,
    x2: 1641.739,
    y2: 1168.2573,
    gradientTransform: "matrix(1 0 0 -1 0 1830)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M1641.74,661.74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 1641.809,
    y1: 341.1527,
    x2: 1641.809,
    y2: 341.1527,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F49E7E"
    }
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M1641.81,661.15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_163_",
    cx: 1416.0396,
    cy: 1813.7416,
    r: 25.552,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 1510.5955 -1227.1584)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M1739.35,762.79c5-10.12,16.1-12.62,24.92-5.6c8.85,7.04,11.91,20.92,6.98,31.02 c-4.95,10.09-16.1,12.6-24.92,5.58C1737.46,786.77,1734.42,772.87,1739.35,762.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 1703.1492,
    y1: 461.629,
    x2: 1833.0143,
    y2: 461.629,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M1832.55,772.6c0.86-6.21,3.96-26.63-30.98-25.31c-18.26,0.68-36.58-0.89-54.21-4.06 c-28.82,13.45-43.92,42-44.21,61.86c15.89,6.53,33.34,11.23,51.55,13.86C1805.11,826.19,1829.42,795.23,1832.55,772.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 1637.739,
    y1: 415.8077,
    x2: 1660.0291,
    y2: 415.8077,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M1637.74,707.75c0,12.9,0.99,25.46,2.68,37.71c2.7,11.19,9.52,22.03,19.61,32.07 c-7.87-22.45-13.65-50.99-5.32-83.45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 1641.809,
    y1: 341.1527,
    x2: 1641.809,
    y2: 341.1527,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M1641.81,661.15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_167_",
    cx: 1633.6257,
    cy: 47.1231,
    r: 26.0039,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 720.0048 -3.9561)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M1739.42,761.78c5.09-10.3,16.38-12.84,25.36-5.7c9,7.17,12.12,21.3,7.1,31.57 c-5.04,10.26-16.38,12.83-25.36,5.68C1737.5,786.19,1734.41,772.04,1739.42,761.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 1702.579,
    y1: 729.0501,
    x2: 1834.7504,
    y2: 729.0501,
    gradientTransform: "matrix(1 0 0 -1 0 1510)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M1834.28,771.77c0.87-6.32,4.03-27.1-31.53-25.76c-18.58,0.7-37.23-0.91-55.17-4.14 c-29.33,13.69-44.7,42.74-45,62.96c16.17,6.64,33.93,11.43,52.47,14.1C1806.35,826.31,1831.09,794.79,1834.28,771.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 1653.2791,
    y1: 818.1473,
    x2: 1653.2791,
    y2: 818.1473,
    gradientTransform: "matrix(1 0 0 -1 0 1510)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M1653.28,691.85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 1635.999,
    y1: 768.7273,
    x2: 1658.689,
    y2: 768.7273,
    gradientTransform: "matrix(1 0 0 -1 0 1510)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M1636,705.76c0,13.13,1.01,25.91,2.73,38.38c2.75,11.39,9.69,22.42,19.96,32.64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 1640.149,
    y1: 851.6673,
    x2: 1640.149,
    y2: 851.6673,
    gradientTransform: "matrix(1 0 0 -1 0 1510)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M1640.15,658.33"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_172_",
    cx: 1850.5035,
    cy: 792.6846,
    r: 26.38,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 880.0842 -713.6837)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M1738.85,760.94c5.16-10.45,16.62-13.03,25.73-5.79c9.13,7.27,12.29,21.6,7.21,32.03 c-5.11,10.41-16.62,13.01-25.73,5.76C1736.9,785.7,1733.76,771.35,1738.85,760.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 1701.4825,
    y1: 780.3872,
    x2: 1835.5509,
    y2: 780.3872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M1835.07,771.08c0.88-6.41,4.09-27.49-31.98-26.13c-18.85,0.71-37.77-0.92-55.97-4.2 c-29.75,13.89-45.34,43.36-45.64,63.87c16.41,6.74,34.42,11.6,53.22,14.31C1806.74,826.4,1831.84,794.43,1835.07,771.08z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_174_",
    cx: 758.911,
    cy: -1997.0109,
    r: 26.8139,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 1991.0406 -1028.3875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#F67D66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#DE715C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4582,
    style: {
      stopColor: "#9F5142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7403,
    style: {
      stopColor: "#3D1F19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M1744.56,765.35c5.24-10.62,16.89-13.24,26.15-5.88c9.28,7.39,12.5,21.96,7.33,32.55 c-5.2,10.58-16.89,13.23-26.15,5.86C1742.58,790.52,1739.39,775.94,1744.56,765.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 1706.5682,
    y1: 1360.3759,
    x2: 1842.856,
    y2: 1360.3759,
    gradientTransform: "matrix(1 0 0 -1 0 2145.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M1842.37,775.65c0.9-6.52,4.16-27.95-32.51-26.56c-19.16,0.72-38.39-0.93-56.89-4.26 c-30.24,14.12-46.09,44.07-46.4,64.92c16.68,6.85,34.99,11.79,54.1,14.54C1813.57,831.89,1839.08,799.39,1842.37,775.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 1637.9282,
    y1: 1425.7488,
    x2: 1661.3182,
    y2: 1425.7488,
    gradientTransform: "matrix(1 0 0 -1 0 2145.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M1642.2,658.69c-2.72,15.75-4.27,32.06-4.27,48.9c0,13.54,1.04,26.72,2.81,39.57 c2.84,11.74,9.99,23.12,20.58,33.65c-8.26-23.55-14.33-53.5-5.59-87.56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_177_",
    gradientUnits: "userSpaceOnUse",
    x1: 1647.6083,
    y1: 1084.5713,
    x2: 1842.8894,
    y2: 1084.5713,
    gradientTransform: "matrix(1 0 0 -1 0 1830)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F49E7E"
    }
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st220",
    d: "M1651.68,665.99c-2.59,15-4.07,30.55-4.07,46.6c0,12.9,0.99,25.46,2.68,37.71 c4.44,18.37,18.71,36.1,43.18,50.22c20.37,11.76,45.07,19.52,71.12,23.27c50.4,7.25,74.72-23.72,77.85-46.34 c0.83-6.22,3.94-26.64-31-25.32c-41.45,1.55-83.79-6.82-115.46-25.11c-29.17-16.84-40.86-38.92-43.78-61.01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_178_",
    cx: 1212.5175,
    cy: -970.4988,
    r: 25.552,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 1350.5161 -517.4309)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st221",
    d: "M1749.22,767.63c5-10.12,16.1-12.62,24.92-5.6c8.85,7.04,11.91,20.92,6.98,31.02 c-4.95,10.09-16.1,12.6-24.92,5.58C1747.33,791.62,1744.29,777.72,1749.22,767.63z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_179_",
    cx: 1274.7382,
    cy: -1281.3162,
    r: 18.5435,
    gradientTransform: "matrix(0.6465 0.763 0.3375 -0.9413 1269.3123 -1451.7776)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7962"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#C25C4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4468,
    style: {
      stopColor: "#70352B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#331814"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8211,
    style: {
      stopColor: "#0E0705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st222",
    d: "M1649.02,712.78c3.47-9.63,11.57-11.11,18.23-3.3s9.21,21.94,5.72,31.6c-3.44,9.64-11.57,11.12-18.26,3.32 C1648.12,736.58,1645.55,722.45,1649.02,712.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 1713.0183,
    y1: 1043.5239,
    x2: 1842.8834,
    y2: 1043.5239,
    gradientTransform: "matrix(1 0 0 -1 0 1830)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M1842.42,777.45c0.86-6.21,3.96-26.63-30.98-25.31c-18.26,0.68-36.58-0.89-54.21-4.06 c-28.81,13.45-43.92,42-44.21,61.86c15.89,6.53,33.34,11.23,51.55,13.86C1814.98,831.03,1839.29,800.07,1842.42,777.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_181_",
    gradientUnits: "userSpaceOnUse",
    x1: 1647.6083,
    y1: 1105.8188,
    x2: 1669.8983,
    y2: 1105.8188,
    gradientTransform: "matrix(1 0 0 -1 0 1830)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M1651.68,665.99c-2.59,15-4.07,30.55-4.07,46.6c0,12.9,0.99,25.46,2.68,37.71 c2.7,11.19,9.52,22.03,19.61,32.07c-7.87-22.45-13.65-50.99-5.32-83.45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_182_",
    gradientUnits: "userSpaceOnUse",
    x1: 1647.6782,
    y1: 424.8387,
    x2: 1842.9633,
    y2: 424.8387,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F49E7E"
    }
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M1651.75,665.4c-2.59,15-4.07,30.55-4.07,46.6c0,12.9,0.99,25.46,2.68,37.71 c4.44,18.37,18.71,36.1,43.18,50.22c20.37,11.76,45.07,19.52,71.12,23.27c50.4,7.25,74.72-23.72,77.85-46.34 c0.84-6.22,3.94-26.64-31-25.32c-41.45,1.55-83.79-6.82-115.46-25.11c-29.17-16.84-40.86-38.92-43.78-61.01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_183_",
    cx: 1429.8915,
    cy: 1810.0538,
    r: 25.552,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 1510.5955 -1227.1584)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st226",
    d: "M1749.29,767.04c5-10.12,16.1-12.62,24.92-5.6c8.85,7.04,11.91,20.92,6.98,31.02 c-4.95,10.09-16.1,12.6-24.92,5.58C1747.4,791.02,1744.36,777.12,1749.29,767.04z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_184_",
    cx: 1409.7328,
    cy: 2011.9707,
    r: 18.5407,
    gradientTransform: "matrix(0.6465 0.763 -0.3375 0.9413 1428.7042 -2243.1384)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7962"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#C25C4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4468,
    style: {
      stopColor: "#70352B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#331814"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8211,
    style: {
      stopColor: "#0E0705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M1649.09,712.19c3.47-9.63,11.57-11.11,18.23-3.3s9.21,21.94,5.72,31.59c-3.44,9.65-11.57,11.12-18.26,3.32 C1648.19,735.99,1645.63,721.86,1649.09,712.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_185_",
    gradientUnits: "userSpaceOnUse",
    x1: 1713.0884,
    y1: 465.8775,
    x2: 1842.9535,
    y2: 465.8775,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st228",
    d: "M1842.49,776.85c0.86-6.21,3.96-26.63-30.98-25.31c-18.26,0.68-36.58-0.89-54.21-4.06 c-28.82,13.45-43.92,42-44.21,61.86c15.89,6.53,33.34,11.23,51.55,13.86C1815.05,830.44,1839.36,799.48,1842.49,776.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_186_",
    gradientUnits: "userSpaceOnUse",
    x1: 1647.6782,
    y1: 403.5912,
    x2: 1669.9683,
    y2: 403.5912,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st229",
    d: "M1651.75,665.4c-2.59,15-4.07,30.55-4.07,46.6c0,12.9,0.99,25.46,2.68,37.71 c2.7,11.19,9.52,22.03,19.61,32.07c-7.87-22.45-13.65-50.99-5.32-83.45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_187_",
    gradientUnits: "userSpaceOnUse",
    x1: 1645.9381,
    y1: 766.5717,
    x2: 1844.6895,
    y2: 766.5717,
    gradientTransform: "matrix(1 0 0 -1 0 1510)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F49E7E"
    }
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st230",
    d: "M1650.09,662.58c-2.63,15.27-4.15,31.09-4.15,47.43c0,13.13,1.01,25.91,2.73,38.38 c4.51,18.69,19.04,36.74,43.94,51.11c20.73,11.97,45.87,19.86,72.38,23.68c51.3,7.38,76.04-24.14,79.23-47.16 c0.87-6.33,4.03-27.11-31.53-25.77c-42.18,1.58-85.28-6.94-117.51-25.56c-29.69-17.14-41.58-39.61-44.56-62.09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_188_",
    cx: 1647.4775,
    cy: 50.8108,
    r: 26.0039,
    gradientTransform: "matrix(0.6238 0.4973 0.3521 -0.7159 720.0048 -3.9561)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st231",
    d: "M1749.36,766.03c5.09-10.3,16.38-12.84,25.36-5.7c9,7.17,12.12,21.3,7.1,31.57 c-5.04,10.26-16.38,12.83-25.36,5.68C1747.44,790.44,1744.35,776.29,1749.36,766.03z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_189_",
    cx: 1542.5948,
    cy: -43.1474,
    r: 18.8742,
    gradientTransform: "matrix(0.6465 0.763 0.3375 -0.9413 676.8462 -492.9896)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7962"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#C25C4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4468,
    style: {
      stopColor: "#70352B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#331814"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8211,
    style: {
      stopColor: "#0E0705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M1647.39,710.2c3.53-9.8,11.78-11.31,18.56-3.35c6.78,7.95,9.37,22.33,5.82,32.16 c-3.51,9.82-11.78,11.32-18.58,3.38C1646.47,734.42,1643.86,720.05,1647.39,710.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_190_",
    gradientUnits: "userSpaceOnUse",
    x1: 1712.5182,
    y1: 724.8016,
    x2: 1844.6896,
    y2: 724.8016,
    gradientTransform: "matrix(1 0 0 -1 0 1510)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st233",
    d: "M1844.22,776.02c0.87-6.32,4.03-27.1-31.53-25.76c-18.58,0.7-37.23-0.91-55.17-4.14 c-29.33,13.69-44.7,42.74-45,62.96c16.17,6.64,33.93,11.43,52.47,14.1C1816.29,830.56,1841.03,799.04,1844.22,776.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_191_",
    gradientUnits: "userSpaceOnUse",
    x1: 1645.9382,
    y1: 788.1938,
    x2: 1668.6282,
    y2: 788.1938,
    gradientTransform: "matrix(1 0 0 -1 0 1510)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st234",
    d: "M1650.09,662.58c-2.63,15.27-4.15,31.09-4.15,47.43c0,13.13,1.01,25.91,2.73,38.38 c2.75,11.39,9.69,22.42,19.96,32.64c-8-22.85-13.89-51.9-5.41-84.93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_192_",
    gradientUnits: "userSpaceOnUse",
    x1: 1643.8832,
    y1: 742.2665,
    x2: 1845.4902,
    y2: 742.2665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F49E7E"
    }
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M1648.09,660.26c-2.67,15.49-4.21,31.54-4.21,48.11c0,13.32,1.02,26.29,2.77,38.93 c4.58,18.96,19.31,37.27,44.58,51.85c21.03,12.14,46.53,20.15,73.42,24.02c52.04,7.48,77.14-24.49,80.37-47.84 c0.88-6.41,4.09-27.49-31.98-26.13c-42.79,1.6-86.5-7.04-119.2-25.93c-30.12-17.39-42.18-40.18-45.2-62.98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_193_",
    cx: 1864.3555,
    cy: 788.9969,
    r: 26.38,
    gradientTransform: "matrix(0.6238 0.4973 -0.3521 0.7159 880.0842 -713.6837)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FF755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2584,
    style: {
      stopColor: "#E76A55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#A84D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#46201A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M1748.79,765.19c5.16-10.45,16.62-13.03,25.73-5.79c9.13,7.27,12.29,21.6,7.21,32.03 c-5.11,10.41-16.62,13.01-25.73,5.76C1746.84,789.95,1743.7,775.6,1748.79,765.19z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_194_",
    cx: 1675.1571,
    cy: 774.8808,
    r: 19.1436,
    gradientTransform: "matrix(0.6465 0.763 -0.3375 0.9413 836.2382 -1284.3505)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7962"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#C25C4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4468,
    style: {
      stopColor: "#70352B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#331814"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8211,
    style: {
      stopColor: "#0E0705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#000000"
    }
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st237",
    d: "M1645.35,708.56c3.58-9.95,11.95-11.47,18.82-3.4c6.88,8.06,9.51,22.65,5.9,32.62 c-3.56,9.96-11.95,11.48-18.85,3.43C1644.42,733.13,1641.77,718.55,1645.35,708.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_195_",
    gradientUnits: "userSpaceOnUse",
    x1: 1711.4218,
    y1: 784.6357,
    x2: 1845.4902,
    y2: 784.6357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st238",
    d: "M1845.01,775.32c0.88-6.41,4.09-27.49-31.98-26.13c-18.85,0.71-37.77-0.92-55.97-4.2 c-29.75,13.89-45.34,43.36-45.64,63.87c16.41,6.74,34.42,11.6,53.22,14.31C1816.68,830.65,1841.78,798.68,1845.01,775.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_196_",
    gradientUnits: "userSpaceOnUse",
    x1: 1643.8832,
    y1: 720.3298,
    x2: 1666.8918,
    y2: 720.3298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st239",
    d: "M1648.09,660.26c-2.67,15.49-4.21,31.54-4.21,48.11c0,13.32,1.02,26.29,2.77,38.93 c2.79,11.55,9.83,22.74,20.24,33.11c-8.11-23.17-14.08-52.64-5.49-86.14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionIa);
export default __webpack_public_path__ + "static/media/solutionIA.2bef044fae49b9eb450602d03b19364a.svg";
export { ForwardRef as ReactComponent };